(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-gifts"] && !Shopify.designMode) return;
  try {
    (function () {
    // Shared across Section Rendering swaps and across the two instances a page
    // can hold (drawer + /cart page): busy = single-flight guard for mutations.
    // dismissed = in-memory dismissal fallback when localStorage is unavailable.
    if (!window.__dcCartGifts) {
      window.__dcCartGifts = { busy: false, dismissed: {} };
    }
    if (!window.__dcCartGifts.dismissed) window.__dcCartGifts.dismissed = {};

    class CartGifts extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.context = this.dataset.context === 'drawer' ? 'drawer' : 'page';
        this.addUrl = this.dataset.addUrl || '/cart/add.js';
        this.changeUrl = this.dataset.changeUrl || '/cart/change.js';
        this._onClick = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        this.config = this._readConfig();
        this._applyState();
        this._reconcile();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
      }

      _readConfig() {
        var el = this.querySelector('[data-gift-config]');
        try {
          var parsed = JSON.parse(el ? el.textContent : '');
          return {
            active: parsed.active || [],
            giftLines: parsed.giftLines || [],
            known: Array.isArray(parsed.known) ? parsed.known.map(String) : null
          };
        } catch (e) {
          return { active: [], giftLines: [], known: null };
        }
      }

      _entry(handle) {
        return this.config.active.find(function (gift) {
          return gift.handle === handle;
        });
      }

      // Offers show for earned + undismissed + not-in-bag gifts (#1714). A
      // dismissed gift is simply hidden (no re-offer panel -- see the header).
      _applyState() {
        var self = this;
        this.querySelectorAll('[data-gift-offer]').forEach(function (offer) {
          var handle = offer.getAttribute('data-gift-offer');
          var entry = self._entry(handle);
          var show = !!(entry && !entry.inCart && !self._dismissed(handle));
          offer.hidden = !show;
          if (show) self._syncOffer(offer, entry);
        });
      }

      // The variant whose options match every checked radio (a single-variant
      // gift has no radios, so its one signed variant matches).
      _selection(offer) {
        var selected = {};
        offer.querySelectorAll('[data-gift-option]').forEach(function (input) {
          if (input.checked) selected[input.getAttribute('data-gift-option')] = input.value;
        });
        return selected;
      }

      _match(entry, selected) {
        return (entry.variants || []).find(function (variant) {
          return Object.keys(selected).every(function (index) {
            return String(variant.options[index]) === selected[index];
          });
        });
      }

      // Mark values with no purchasable (signed) variant under the current
      // selection (data-disabled, visual only), refresh "Valued at" to the
      // chosen variant's price, and disable the add when nothing matches.
      _syncOffer(offer, entry) {
        if (!entry) return;
        var self = this;
        var selected = this._selection(offer);
        offer.querySelectorAll('[data-gift-option]').forEach(function (input) {
          var trial = Object.assign({}, selected);
          trial[input.getAttribute('data-gift-option')] = input.value;
          if (self._match(entry, trial)) {
            input.removeAttribute('data-disabled');
          } else {
            input.setAttribute('data-disabled', 'true');
          }
        });
        var chosen = this._match(entry, selected);
        var valued = offer.querySelector('[data-gift-valued]');
        if (valued && chosen) {
          valued.textContent = chosen.valued || '';
          valued.hidden = !chosen.valued;
        }
        var add = offer.querySelector('[data-gift-add]');
        if (add && !add.hasAttribute('aria-busy')) add.disabled = !chosen;
      }

      // Auto-REMOVE lapsed gift lines (unchanged rule). There is no auto-add
      // any more: earned gifts are offered and added by the shopper (#1714).
      _reconcile() {
        var state = window.__dcCartGifts;
        if (state.busy) return;
        // On /cart the page instance owns the reconcile (one owner per page).
        if (this.context === 'drawer' && document.querySelector('cart-gifts[data-context="page"]')) return;
        var keep = [];
        this.config.active.forEach(function (gift) {
          (gift.variantIds || [gift.variantId]).forEach(function (id) {
            keep.push(String(id));
          });
        });
        var known = this.config.known;
        var toRemove = this.config.giftLines.filter(function (line) {
          var id = String(line.variantId);
          if (keep.indexOf(id) !== -1) return false;
          return !known || known.indexOf(id) !== -1;
        });
        if (!toRemove.length) return;
        state.busy = true;
        this._mutate([], toRemove, null);
      }

      // One add POST for the chosen gift, then serialised qty-0 changes for
      // lapsed lines, then ONE Section Rendering GET + swap. The GET works on
      // preview/dev themes where bundled sections are omitted and covers a
      // batch that spans several mutations. The common case -- one add, no
      // removals -- asks the add POST to bundle the sections instead and only
      // falls back to the GET when the response carries none, saving a full
      // cart-page render round trip (client QA round 3: the gift was slow to
      // land after the add).
      _mutate(toAdd, toRemove, addedHandle) {
        var self = this;
        var chain = Promise.resolve(null);
        var added = false;
        var bundled = null;
        var sectionIds = this._sectionIds();

        if (toAdd.length) {
          chain = chain.then(function () {
            var payload = {
              items: toAdd.map(function (variant) {
                return { id: variant.id, quantity: 1, properties: variant.properties };
              })
            };
            if (!toRemove.length) {
              payload.sections = sectionIds.join(',');
              payload.sections_url = window.location.pathname;
            }
            return fetch(self.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload)
            }).then(function (response) {
              // Sold-out race: the variant was purchasable at render time; a
              // failed add is skipped silently (live parity).
              added = response.ok;
              return response.ok ? response.json() : null;
            }).then(function (json) {
              var sections = json && json.sections;
              var complete = !!sections && sectionIds.every(function (id) {
                return typeof sections[id] === 'string';
              });
              if (!toRemove.length && complete) bundled = sections;
              return json;
            });
          });
        }

        toRemove.forEach(function (line) {
          var row = document.querySelector('[data-line-key="' + line.key + '"]');
          if (row) row.setAttribute('data-pending', '');
          chain = chain.then(function () {
            return fetch(self.changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            }).then(function (response) {
              return response.ok ? response.json() : null;
            });
          });
        });

        chain
          .then(function () {
            return bundled || self._fetchSections(sectionIds);
          })
          .then(function (sections) {
            window.__dcCartGifts.busy = false;
            self._render(sections, added ? addedHandle : null);
          })
          .catch(function () {
            window.__dcCartGifts.busy = false;
            self._release();
          });
      }

      // The page cart section, discovered at runtime: a drawer-initiated gift
      // mutation on /cart must refresh the page cart too.
      _pageSectionId() {
        var pageEl = document.querySelector('cart-items[data-section-id]');
        return pageEl ? pageEl.getAttribute('data-section-id') : null;
      }

      _sectionIds() {
        var ids = [];
        [this.sectionId, this._pageSectionId(), 'cart-drawer'].forEach(function (id) {
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
        return ids;
      }

      _fetchSections(ids) {
        var params = new URLSearchParams(window.location.search);
        params.set('sections', (ids || this._sectionIds()).join(','));
        return fetch(window.location.pathname + '?' + params.toString()).then(function (response) {
          return response.ok ? response.json() : Promise.reject(response);
        });
      }

      // Swap the page cart (scoped to the page section's root, whichever
      // instance initiated), announce an add, and dispatch cart:updated -- the
      // <cart-drawer> controller owns the drawer swap and header count sync.
      // Never cart:added (it pops the drawer). The success panel is revealed in
      // the freshly swapped instances only, so the next swap clears it.
      _render(sections, addedHandle) {
        var pageId = this._pageSectionId();
        var pageHtml = pageId && sections && sections[pageId];
        if (pageHtml) {
          var pageEl = document.querySelector('cart-items[data-section-id="' + pageId + '"]');
          var fresh = new DOMParser().parseFromString(pageHtml, 'text/html').querySelector('[data-cart-contents]');
          var live = pageEl && pageEl.querySelector('[data-cart-contents]');
          if (fresh && live) live.replaceWith(fresh);
        }
        if (addedHandle) this._announce();
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: null, sections: sections || null }
          })
        );
        if (addedHandle) this._revealSuccess(addedHandle);
      }

      _revealSuccess(handle) {
        document.querySelectorAll('cart-gifts [data-gift-success]').forEach(function (panel) {
          if (panel.getAttribute('data-gift-success') === handle) panel.hidden = false;
        });
      }

      _announce() {
        var region = document.querySelector('[data-cart-announce]');
        if (region) region.textContent = this.dataset.labelAdded || '';
      }

      _release() {
        var busyButtons = document.querySelectorAll('cart-gifts [data-gift-add][aria-busy]');
        busyButtons.forEach(function (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
        document.querySelectorAll('cart-gifts [data-gift-offer][data-pending]').forEach(function (offer) {
          offer.removeAttribute('data-pending');
        });
      }

      // Re-apply visibility in every instance on the page (a dismiss in the page
      // offer must also hide the drawer's copy, and vice versa).
      _syncAll() {
        document.querySelectorAll('cart-gifts').forEach(function (el) {
          if (typeof el._applyState === 'function' && el.config) el._applyState();
        });
      }

      _onChange(event) {
        var input = event.target.closest('[data-gift-option]');
        if (!input) return;
        var offer = input.closest('[data-gift-offer]');
        if (!offer) return;
        this._syncOffer(offer, this._entry(offer.getAttribute('data-gift-offer')));
      }

      // Offer X / REMOVE: write the session dismissal. Offer add link: post the
      // CHOSEN variant's signed payload.
      _onClick(event) {
        var dismiss = event.target.closest('[data-gift-dismiss]');
        if (dismiss) {
          event.preventDefault();
          this._dismiss(dismiss.getAttribute('data-gift-dismiss'));
          this._syncAll();
          return;
        }
        var button = event.target.closest('[data-gift-add]');
        if (!button) return;
        event.preventDefault();
        if (window.__dcCartGifts.busy || button.disabled) return;
        var handle = button.getAttribute('data-gift-add');
        var entry = this._entry(handle);
        if (!entry || entry.inCart || !entry.variants || !entry.variants.length) return;
        var offer = button.closest('[data-gift-offer]');
        var variant = offer ? this._match(entry, this._selection(offer)) : entry.variants[0];
        if (!variant) return;
        this._undismiss(handle);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        // Dim the whole offer block while the add is in flight (the cart
        // lines' pending convention), so the tap is seen to land at once.
        if (offer) offer.setAttribute('data-pending', '');
        window.__dcCartGifts.busy = true;
        this._mutate([variant], [], handle);
      }

      _storageKey(handle) {
        return 'dc-gift:' + handle;
      }

      // A dismissal lasts the browsing session (sessionStorage, per tab): long
      // enough that the block does not nag across page views and cart edits,
      // short enough that the gift is offered again next visit. The pre-round-4
      // build kept a 1-day localStorage dismissal and re-offered through the
      // cart page's dashed panel; without that panel a day-long dismissal would
      // leave no way back to the gift (client QA round 4: the client dismissed
      // on their phone and then saw "no GWP in the mini cart on mobile").
      _dismissed(handle) {
        if (!handle) return false;
        try {
          return window.sessionStorage.getItem(this._storageKey(handle)) === '1';
        } catch (e) {
          return !!window.__dcCartGifts.dismissed[handle];
        }
      }

      _dismiss(handle) {
        try {
          window.sessionStorage.setItem(this._storageKey(handle), '1');
        } catch (e) {
          // Storage unavailable (private mode): dismissal degrades to per-pageview.
          window.__dcCartGifts.dismissed[handle] = true;
        }
      }

      _undismiss(handle) {
        try {
          window.sessionStorage.removeItem(this._storageKey(handle));
        } catch (e) {
          // Storage unavailable: clear the per-pageview fallback instead.
        }
        delete window.__dcCartGifts.dismissed[handle];
      }
    }

    if (!window.customElements.get('cart-gifts')) {
      window.customElements.define('cart-gifts', CartGifts);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addUrl = this.dataset.addUrl || '/cart/add.js';
      this._onClick = this._onClick.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this.addEventListener('submit', this._onSubmit);
      this._reveal();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('change', this._onChange);
      this.removeEventListener('submit', this._onSubmit);
    }

    // Show the first eligible band the visitor hasn't dismissed. Runs on every
    // (re)connect -- the element re-upgrades inside each Section Rendering swap,
    // which is what re-evaluates eligibility after cart mutations.
    _reveal() {
      var bands = this.querySelectorAll('[data-upsell-promo]');
      var shown = false;
      for (var i = 0; i < bands.length; i++) {
        if (!shown && !this._dismissed(bands[i].getAttribute('data-promo-key'))) {
          bands[i].hidden = false;
          shown = true;
        } else {
          bands[i].hidden = true;
        }
      }
    }

    _storageKey(key) {
      return 'dc-upsell:' + key;
    }

    // Dismissals mirror live's storage semantics: {"value":true,"expiry":<epoch-ms>},
    // pruned on read once expired.
    _dismissed(key) {
      if (!key) return false;
      var raw = null;
      try {
        raw = window.localStorage.getItem(this._storageKey(key));
      } catch (e) {
        return false;
      }
      if (!raw) return false;
      try {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.expiry && parsed.expiry < Date.now()) {
          window.localStorage.removeItem(this._storageKey(key));
          return false;
        }
        return !!(parsed && parsed.value);
      } catch (e) {
        return false;
      }
    }

    _dismiss(key) {
      var days = parseFloat(this.dataset.expiryDays);
      if (isNaN(days) || days <= 0) days = 1;
      var payload = JSON.stringify({ value: true, expiry: Date.now() + days * 86400000 });
      try {
        window.localStorage.setItem(this._storageKey(key), payload);
      } catch (e) {
        // Storage unavailable (private mode): the band still hides for this render.
      }
    }

    _onClick(event) {
      // Re-clicking the size a product is ALREADY on fires no `change` event, so the
      // click path is what makes "a size pill selects the size AND its product" hold
      // for every pill (live uses buttons + state, which has no such gap). Idempotent
      // with the change path that follows a real size switch.
      var size = event.target.closest('[data-upsell-size]');
      if (size) {
        this._selectSize(size);
        return;
      }
      var cancel = event.target.closest('[data-upsell-cancel]');
      if (!cancel) return;
      event.preventDefault();
      var band = cancel.closest('[data-upsell-promo]');
      if (!band) return;
      this._dismiss(band.getAttribute('data-promo-key'));
      this._reveal();
    }

    _onChange(event) {
      var size = event.target.closest('[data-upsell-size]');
      if (size) this._selectSize(size);
    }

    // A size pill selects both the size AND its product (live behaviour): rewrite
    // the item's `id` radio to the chosen variant, check it, and re-evaluate the
    // low-stock note.
    _selectSize(size) {
      var item = size.closest('[data-upsell-item]');
      if (!item) return;
      if (!size.checked) size.checked = true;
      var radio = item.querySelector('[data-upsell-radio]');
      if (radio) {
        radio.value = size.getAttribute('data-variant-id');
        radio.checked = true;
      }
      var note = item.querySelector('[data-low-stock-note]');
      var live = item.querySelector('[data-low-stock-live]');
      var low = size.getAttribute('data-low-stock') === 'true';
      if (note) {
        note.hidden = !low;
        if (live) live.textContent = low ? note.textContent.trim() : '';
      }
    }

    _onSubmit(event) {
      var form = event.target.closest('[data-upsell-form]');
      if (!form) return;
      event.preventDefault();
      if (this._busy) return;
      var radio = form.querySelector('[data-upsell-radio]:checked');
      if (!radio || !radio.value) return;

      var properties = {};
      var inputs = form.querySelectorAll('input[type="hidden"]');
      for (var i = 0; i < inputs.length; i++) {
        var match = inputs[i].name.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = inputs[i].value;
      }

      // The signature is per-product, carried on the chosen item's id radio
      // (size selection never changes it). The Function rejects the line without
      // it, so a valid discount can't ride an add that omits it (#254).
      var secret = radio.getAttribute('data-upsell-secret');
      if (secret) properties['_upsell_secret'] = secret;

      // Hidden _aux_* line properties from the chosen item's analytics payload
      // via dcAnalytics.lineProps (#268, #336, event map Q7) so the checkout
      // pixel can report item_category. Without dcAnalytics the add goes ahead.
      var dca = window.dcAnalytics;
      if (dca && dca.lineProps) Object.assign(properties, dca.lineProps(radio.closest('[data-analytics]')));

      var submit = form.querySelector('button[type="submit"]');
      this._busy = true;
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }

      var self = this;
      // Single-shot add detail for analytics (#268): the band's cart:updated
      // carries it as `detail.added` so consumers can attribute exactly this
      // add without rescanning cart lines (an `_upsell_item` property persists
      // for the life of the line, so a rescan would re-report it on every
      // later bag edit).
      var added = { variantId: parseInt(radio.value, 10), quantity: 1 };
      fetch(this.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: added.variantId, quantity: added.quantity, properties: properties }],
          sections: this.sectionId + ',cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) {
            // Sold-out / unavailable: live fails silently; re-enable and stop
            // (a native re-submit would land on Shopify's error page).
            self._release(submit);
            return null;
          }
          return response.json();
        })
        .then(function (json) {
          if (!json) return;
          if (json.sections && json.sections[self.sectionId]) {
            self._render(json, added);
            return;
          }
          // Preview/dev themes omit bundled sections from cart AJAX responses;
          // re-fetch via the Section Rendering GET (same fallback as <cart-items>).
          var params = new URLSearchParams(window.location.search);
          params.set('sections', self.sectionId + ',cart-drawer');
          return fetch(window.location.pathname + '?' + params.toString())
            .then(function (response) {
              return response.ok ? response.json() : Promise.reject(response);
            })
            .then(function (sections) {
              json.sections = sections;
              self._render(json, added);
            });
        })
        .catch(function () {
          // Never fall back to a native form post: a sold-out variant would
          // land the shopper on Shopify's full-page error. Release the button
          // so they can retry once the network recovers.
          self._release(submit);
        });
    }

    _release(submit) {
      this._busy = false;
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    }

    // Swap the page cart (this element lives INSIDE the swapped region, so all
    // lookups go through document and the work completes in this closure), announce,
    // and dispatch cart:updated -- the <cart-drawer> controller owns the drawer swap
    // and header count sync from the bundled payload. Never cart:added (it opens
    // the drawer; live does not open it from the band).
    _render(json, added) {
      var sectionHtml = json.sections && json.sections[this.sectionId];
      if (sectionHtml) {
        var fresh = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('[data-cart-contents]');
        var live = document.querySelector('[data-cart-contents]');
        if (fresh && live) {
          live.replaceWith(fresh);
          this._announce();
          this._focusHeading();
        }
      }
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: json, sections: json.sections || null, added: added || null }
        })
      );
    }

    _announce() {
      var region = document.querySelector('[data-cart-announce]');
      if (region) region.textContent = this.dataset.labelAdded || '';
    }

    // The swap removes the focused Add button; land focus on the cart heading
    // (the same fallback <cart-items> uses when a line disappears).
    _focusHeading() {
      var active = document.activeElement;
      if (active && active !== document.body && document.contains(active)) return;
      var target = document.querySelector('.cart__heading');
      if (!target) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus();
    }
  }

  if (!window.customElements.get('cart-upsell')) {
    window.customElements.define('cart-upsell', CartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dc-scroller"] && !Shopify.designMode) return;
  try {
    class DcScroller extends HTMLElement {
    // Find the first matching descendant that belongs to THIS scroller and not a
    // nested one (a featured-products rail nests per-card gallery scrollers).
    findOwn(selector) {
      const matches = this.querySelectorAll(selector);
      for (let i = 0; i < matches.length; i++) {
        if (matches[i].closest('dc-scroller') === this) return matches[i];
      }
      return null;
    }

    connectedCallback() {
      this.track = this.findOwn('[data-dc-scroller-track]');
      this.thumb = this.findOwn('[data-dc-scroller-thumb]');
      if (!this.track || !this.thumb) return;

      this.onScroll = this.update.bind(this);
      this.onResize = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    // Opt-in item-count model (see the doc header). Live's Scroll.tsx computes
    // `itemWidth / scrollWidth` where `itemWidth = scrollWidth / itemCount`,
    // which reduces to `100 / itemCount` -- independent of how many items are
    // on screen, so the bar reads as "item i of N" at every breakpoint. An
    // absent, non-numeric or non-positive attribute falls through to the
    // visible-fraction default, so no existing consumer is touched.
    thumbWidthPct(track) {
      const items = parseInt(this.getAttribute('data-dc-scroller-items'), 10);
      if (items > 0) return Math.min(100, 100 / items);
      return (track.clientWidth / track.scrollWidth) * 100;
    }

    update() {
      const track = this.track;
      const overflow = track.scrollWidth > track.clientWidth + 1;
      this.dataset.overflow = overflow ? 'true' : 'false';
      if (!overflow) return;

      const widthPct = this.thumbWidthPct(track);
      const maxScroll = track.scrollWidth - track.clientWidth;
      const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      const leftPct = progress * (100 - widthPct);

      this.thumb.style.width = widthPct + '%';
      this.thumb.style.left = leftPct + '%';
    }
  }

  if (!window.customElements.get('dc-scroller')) {
    window.customElements.define('dc-scroller', DcScroller);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dc-slider"] && !Shopify.designMode) return;
  try {
    class DcSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dc-slider__track');
      if (!this.track) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onPrev = this.prev.bind(this);
      this.onNext = this.next.bind(this);
      this.prevBtn = this.querySelector('[data-dc-prev]');
      this.nextBtn = this.querySelector('[data-dc-next]');
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

      this.setupDrag();
      this.setupVideos();
      this.setupAutoloop();

      this.onResize = this.updateOverflow.bind(this);
      window.addEventListener('resize', this.onResize, { passive: true });
      this.updateOverflow();
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.track && this.onDown) this.track.removeEventListener('pointerdown', this.onDown);
      if (this.onMove) window.removeEventListener('pointermove', this.onMove);
      if (this.onUp) window.removeEventListener('pointerup', this.onUp);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      this.stopAutoloop();
      this.teardownAutoloopEvents();
      if (this.videoObserver) this.videoObserver.disconnect();
    }

    behavior() {
      return this.reduceMotion && this.reduceMotion.matches ? 'auto' : 'smooth';
    }

    slideStep() {
      const slide = this.track.querySelector('.dc-slider__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    next() {
      const scrollLeft = this.track.scrollLeft;
      const scrollWidth = this.track.scrollWidth;
      const clientWidth = this.track.clientWidth;
      if (Math.ceil(scrollLeft + clientWidth) >= scrollWidth) {
        this.track.scrollTo({ left: 0, behavior: this.behavior() });
      } else {
        this.track.scrollBy({ left: this.slideStep(), behavior: this.behavior() });
      }
    }

    prev() {
      const scrollLeft = this.track.scrollLeft;
      const scrollWidth = this.track.scrollWidth;
      const clientWidth = this.track.clientWidth;
      if (scrollLeft <= 0) {
        this.track.scrollTo({ left: scrollWidth - clientWidth, behavior: this.behavior() });
      } else {
        this.track.scrollBy({ left: -this.slideStep(), behavior: this.behavior() });
      }
    }

    setupDrag() {
      this.dragging = false;
      this.dragMoved = false;
      this.swallowClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };

      this.onMove = (e) => {
        if (!this.dragging) return;
        const dx = e.pageX - this.startX;
        if (Math.abs(dx) > 4) this.dragMoved = true;
        this.track.scrollLeft = this.startScroll - dx;
      };
      this.onUp = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.removeAttribute('data-dc-dragging');
        // Detach the global move/up listeners as soon as the drag ends, so there are
        // no idle window listeners firing on every pointer move between drags.
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('pointerup', this.onUp);
        if (this.dragMoved) {
          this.track.addEventListener('click', this.swallowClick, { capture: true, once: true });
        }
      };
      this.onDown = (e) => {
        if (e.pointerType !== 'mouse') return;
        this.dragging = true;
        this.dragMoved = false;
        this.startX = e.pageX;
        this.startScroll = this.track.scrollLeft;
        this.setAttribute('data-dc-dragging', '');
        // Attach window move/up only for the duration of this drag.
        window.addEventListener('pointermove', this.onMove, { passive: true });
        window.addEventListener('pointerup', this.onUp, { passive: true });
      };

      this.track.addEventListener('pointerdown', this.onDown);
    }

    setupAutoloop() {
      if (!this.hasAttribute('data-dc-autoloop')) return;
      this.autoDelay = parseInt(this.getAttribute('data-dc-autoloop-delay'), 10) || 5000;

      this.pause = this.stopAutoloop.bind(this);
      this.resume = this.startAutoloop.bind(this);
      this.onVisibility = () => {
        if (document.hidden) {
          this.stopAutoloop();
        } else {
          this.startAutoloop();
        }
      };

      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (this.reduceMotion.addEventListener) {
        this.onMotionChange = () => {
          if (this.reduceMotion.matches) {
            this.stopAutoloop();
          } else {
            this.startAutoloop();
          }
        };
        this.reduceMotion.addEventListener('change', this.onMotionChange);
      }

      this.startAutoloop();
    }

    teardownAutoloopEvents() {
      if (this.pause) {
        this.removeEventListener('pointerenter', this.pause);
        this.removeEventListener('pointerleave', this.resume);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.resume);
      }
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onMotionChange && this.reduceMotion.removeEventListener) {
        this.reduceMotion.removeEventListener('change', this.onMotionChange);
      }
    }

    startAutoloop() {
      if (!this.hasAttribute('data-dc-autoloop')) return;
      if (this.reduceMotion.matches) return;
      this.stopAutoloop();
      this.autoTimer = window.setInterval(() => this.next(), this.autoDelay);
    }

    stopAutoloop() {
      if (this.autoTimer) {
        window.clearInterval(this.autoTimer);
        this.autoTimer = null;
      }
    }

    setupVideos() {
      this.videos = Array.from(this.querySelectorAll('[data-dc-video]'));
      if (!this.videos.length) return;
      if (this.reduceMotion.matches) {
        this.videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }
      if (!('IntersectionObserver' in window)) return;
      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playVideo(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );
      this.videos.forEach((video) => this.videoObserver.observe(video));
    }

    playVideo(video) {
      if (video.offsetParent === null) return;
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }

    updateOverflow() {
      /* Fractional slide widths (calc(25% - 0.334rem) x 4) can leave a few px
         of phantom overflow; a real extra slide is never under 8px. */
      this.dataset.overflow = this.track.scrollWidth - this.track.clientWidth > 8 ? 'true' : 'false';
    }
  }

  if (!window.customElements.get('dc-slider')) {
    window.customElements.define('dc-slider', DcSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["find-in-store"] && !Shopify.designMode) return;
  try {
    /* Data layer (#270): route through the theme module once it has booted so
     the push carries market / currency / customer_id like every other event;
     the bare dataLayer push is the pre-boot fallback with identical keys. */
  function fisTrack(name, payload) {
    if (window.dcAnalytics) window.dcAnalytics.push(name, payload);
    else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload));
  }

  class FindInStoreDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-fis-input]');
      this.predictionsEl = this.querySelector('[data-fis-predictions]');
      this.resultsEl = this.querySelector('[data-fis-results]');
      this.emptyEl = this.querySelector('[data-fis-empty]');
      this.loadingEl = this.querySelector('[data-fis-loading]');
      this.fieldSpinnerEl = this.querySelector('[data-fis-field-spinner]');
      this.rowTemplate = this.querySelector('template[data-fis-row]');
      this.geoBtn = this.querySelector('[data-fis-geo]');
      this.closeBtn = this.querySelector('[data-fis-close]');
      this.statusEl = this.querySelector('[data-fis-status]');

      this.apiKey = this.dataset.apiKey || '';
      this.country = this.dataset.country || 'au';
      this.stores = null;
      this.search = null;
      this._predictions = [];
      this._activeIndex = -1;
      this._debounce = null;

      var scope = this.closest('find-in-store-trigger') || document;
      this.trigger = scope.querySelector('[data-find-in-store-trigger]');

      this._onTrigger = this._onTrigger.bind(this);
      if (this.trigger) this.trigger.addEventListener('click', this._onTrigger);
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.dialog.close());

      // Backdrop click closes (the click target is the dialog itself outside the panel
      // content only when the panel has no padding overlap -- the flex column fills the
      // dialog, so a backdrop click's target IS the dialog element).
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });

      // Escape with the predictions open dismisses just the predictions.
      this.dialog.addEventListener('cancel', (e) => {
        if (!this.predictionsEl.hidden) {
          e.preventDefault();
          this._hidePredictions();
        }
      });

      // Pointer interaction anywhere outside the search field dismisses the predictions
      // (they otherwise persist, aria-expanded stuck true, until Escape or a new query).
      this.dialog.addEventListener('pointerdown', (e) => {
        if (!this.predictionsEl.hidden && !e.target.closest('.find-in-store__field')) {
          this._hidePredictions();
        }
      });

      this.input.addEventListener('input', () => {
        clearTimeout(this._debounce);
        var q = this.input.value.trim();
        if (q.length < 3) {
          this._hidePredictions();
          return;
        }
        this._debounce = setTimeout(() => this._fetchPredictions(q), 1000);
      });

      this.input.addEventListener('keydown', (e) => this._onInputKey(e));

      if (this.geoBtn) this.geoBtn.addEventListener('click', () => this._geolocate());

      // location_cta fires on the store title link only -- the mobile "view store details"
      // twin points at the same page and would double-count the same intent. [href] gates
      // out the inert title a store with no published page falls back to.
      this.resultsEl.addEventListener('click', (e) => {
        var link = e.target.closest('a[data-fis-store-link][href]');
        if (!link) return;
        fisTrack('location_cta', { search_text: link.textContent.trim() });
      });
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this._onTrigger);
      clearTimeout(this._debounce);
    }

    _onTrigger() {
      fisTrack('find_in_store', { product_name: this.dataset.productTitle || '' });
      this.dialog.showModal();
      this._ensureMaps();
      this._ensureStores();

      try {
        this.search = JSON.parse(localStorage.getItem('search'));
      } catch (e) {
        this.search = null;
      }
      // Live mounts straight into a stock fetch for the active variant, so the modal never
      // opens on the empty pane: a stored search gives the nearest-first, 100km-capped list;
      // with none (or one missing its geometry) the fetch still runs and lists every store in
      // the market holding stock, source order, distance line omitted. Either branch re-runs
      // on every open, so a size change is always re-checked.
      if (!this.search || !this.search.geometry) {
        this.search = null;
      } else if (this.search.address) {
        this.input.value = this.search.address;
      }
      this._runStockSearch();
    }

    _ensureMaps() {
      if (!this.apiKey) return Promise.resolve(null);
      if (window.__fisMapsPromise) return window.__fisMapsPromise;
      window.__fisMapsPromise = new Promise((resolve, reject) => {
        window.__fisMapsCb = () => {
          Promise.all([
            window.google.maps.importLibrary('places'),
            window.google.maps.importLibrary('geocoding')
          ]).then(resolve, reject);
        };
        var s = document.createElement('script');
        s.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(this.apiKey) +
          '&libraries=places&loading=async&callback=__fisMapsCb';
        s.async = true;
        s.onerror = reject;
        document.head.appendChild(s);
      });
      return window.__fisMapsPromise;
    }

    _ensureStores() {
      if (this._storesPromise) return this._storesPromise;
      this._storesPromise = fetch('/?sections=find-in-store-stores')
        .then((r) => (r.ok ? r.json() : Promise.reject(r)))
        .then((json) => {
          var html = json['find-in-store-stores'];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('[data-find-in-store-stores]');
          this.stores = node ? JSON.parse(node.textContent) : [];
          return this.stores;
        })
        .catch(() => {
          this.stores = [];
          return this.stores;
        });
      return this._storesPromise;
    }

    _fetchPredictions(query) {
      var self = this;

      // Grandfathered keys (the live key included) reject the new
      // AutocompleteSuggestion API server-side even though the class exists,
      // so class presence alone must not pick the path -- try new, fall back
      // to the legacy service on rejection.
      function legacyPredictions(places) {
        return new Promise(function (resolve) {
          if (!places.AutocompleteService) return resolve([]);
          new places.AutocompleteService().getPlacePredictions(
            {
              input: query,
              types: ['(regions)'],
              componentRestrictions: { country: self.country }
            },
            function (preds, status) {
              if (status !== 'OK' || !preds) return resolve([]);
              resolve(
                preds.map(function (p) {
                  return { id: p.place_id, text: p.description };
                })
              );
            }
          );
        });
      }

      this._setFieldBusy(true);
      this._ensureMaps()
        .then(function () {
          var places = window.google && window.google.maps && window.google.maps.places;
          if (!places) return [];
          if (places.AutocompleteSuggestion) {
            return places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
              input: query,
              includedRegionCodes: [self.country]
            })
              .then(function (res) {
                return (res.suggestions || []).map(function (s) {
                  return { id: s.placePrediction.placeId, text: s.placePrediction.text.toString() };
                });
              })
              .catch(function () {
                return legacyPredictions(places);
              });
          }
          return legacyPredictions(places);
        })
        .then(function (list) {
          self._renderPredictions(list);
        })
        .catch(function () {
          self._hidePredictions();
        });
    }

    // Field spinner (live parity): tracks the in-flight Places request, NOT the 1000ms
    // debounce wait -- it appears when the fetch starts and clears on render, failure or
    // any dismissal of the predictions.
    _setFieldBusy(busy) {
      if (this.fieldSpinnerEl) this.fieldSpinnerEl.hidden = !busy;
    }

    _renderPredictions(list) {
      this._setFieldBusy(false);
      this._predictions = list;
      this._activeIndex = -1;
      this.predictionsEl.textContent = '';
      if (!list.length) {
        this._hidePredictions();
        return;
      }
      var self = this;
      list.forEach(function (p, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'find-in-store__prediction';
        btn.setAttribute('role', 'option');
        btn.id = 'fis-option-' + i;
        btn.setAttribute('aria-selected', 'false');
        // Options are reached via aria-activedescendant from the input; a tab stop here
        // would run a second, competing focus model (APG combobox pattern).
        btn.tabIndex = -1;
        btn.textContent = p.text;
        btn.addEventListener('click', function () {
          self._select(p);
        });
        self.predictionsEl.appendChild(btn);
      });
      this.predictionsEl.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    _hidePredictions() {
      this._setFieldBusy(false);
      this.predictionsEl.hidden = true;
      this.predictionsEl.textContent = '';
      this._predictions = [];
      this._activeIndex = -1;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    _onInputKey(e) {
      if (this.predictionsEl.hidden) return;
      var max = this._predictions.length - 1;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        if (e.key === 'ArrowDown') {
          this._activeIndex = this._activeIndex < 0 ? 0 : Math.min(this._activeIndex + 1, max);
        } else if (e.key === 'ArrowUp') {
          // APG: ArrowUp with no active option lands on the LAST option.
          this._activeIndex = this._activeIndex < 0 ? max : Math.max(this._activeIndex - 1, 0);
        } else if (e.key === 'Home') {
          this._activeIndex = 0;
        } else {
          this._activeIndex = max;
        }
        var options = this.predictionsEl.querySelectorAll('[role="option"]');
        options.forEach((o, i) => {
          o.setAttribute('aria-selected', i === this._activeIndex ? 'true' : 'false');
        });
        var active = options[this._activeIndex];
        if (active) this.input.setAttribute('aria-activedescendant', active.id);
      } else if (e.key === 'Enter') {
        if (this._activeIndex >= 0) {
          e.preventDefault();
          this._select(this._predictions[this._activeIndex]);
        }
      }
    }

    _select(prediction) {
      var self = this;
      this._hidePredictions();
      this._ensureMaps()
        .then(function () {
          return new window.google.maps.Geocoder().geocode({ placeId: prediction.id });
        })
        .then(function (res) {
          var loc = res.results && res.results[0] && res.results[0].geometry.location;
          if (!loc) return;
          self.search = {
            address: prediction.text,
            geometry: { lat: loc.lat(), lng: loc.lng() }
          };
          try {
            localStorage.setItem('search', JSON.stringify(self.search));
          } catch (e) {
            /* storage unavailable */
          }
          self.input.value = prediction.text;
          fisTrack('location_search', { search_text: prediction.text });
          self._runStockSearch();
        })
        .catch(function () {
          self._show('empty');
        });
    }

    _geolocate() {
      var self = this;
      if (!navigator.geolocation) {
        this._show('empty');
        return;
      }
      this._show('loading');
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          self.search = {
            address: '',
            geometry: { lat: pos.coords.latitude, lng: pos.coords.longitude }
          };
          try {
            localStorage.setItem('search', JSON.stringify(self.search));
          } catch (e) {
            /* storage unavailable */
          }
          self.input.value = '';
          self._runStockSearch();
        },
        function () {
          self._show('empty');
        }
      );
    }

    _currentSku() {
      return this.trigger ? this.trigger.getAttribute('data-sku') || '' : '';
    }

    // Runs with or without a searched point. Geometry present: the live availableStores
    // memo -- distance, 100km cap, nearest first. Geometry null (nothing searched yet):
    // every in-stock store in the market, raw source order, no distance -- which is what
    // live renders on mount, where the unset origin makes every distance 0 and its
    // `distance > 0` guard hides the line.
    _runStockSearch() {
      var sku = this._currentSku();
      if (!sku) {
        this._show('empty');
        return;
      }
      var origin = this.search && this.search.geometry ? this.search.geometry : null;
      this._show('loading');
      var self = this;
      Promise.all([
        this._ensureStores(),
        fetch('/apps/dotapparel21/api-checkStock?sku=' + encodeURIComponent(sku)).then(function (r) {
          return r.ok ? r.json() : Promise.reject(r);
        })
      ])
        .then(function (out) {
          var stores = out[0] || [];
          var payload = out[1];
          var stocked = {};
          ((payload && payload.data) || []).forEach(function (row) {
            if (row && row.attributes) stocked[row.attributes.storeNumber] = row.attributes.freeStock;
          });
          var list = stores
            .map(function (s) {
              return Object.assign({}, s, {
                distance: origin ? self._distanceKm(origin, s) : null,
                stock: stocked[s.ap21]
              });
            })
            .filter(function (s) {
              // Market scope first: AU + NZ share one metaobject set (Markets model) and
              // AP21 numbering interleaves across countries, so numbers alone must never
              // join. Entries pre-dating the country_code backfill default to AU.
              if ((s.country || 'AU').toLowerCase() !== self.country || s.stock == null) return false;
              // Nothing searched yet: no point to measure from, so no proximity cap either.
              if (!origin) return true;
              return s.distance < 100;
            });
          // Nearest first only once there is a point to sort against -- without one the
          // metaobject source order stands (live parity).
          if (origin) {
            list.sort(function (a, b) {
              return a.distance - b.distance;
            });
          }
          self._renderResults(list);
        })
        .catch(function () {
          self._show('empty');
        });
    }

    // Haversine (km) -- port of the live getDistance helper.
    _distanceKm(origin, store) {
      var R = 6371;
      var dLat = this._deg2rad(store.lat - origin.lat);
      var dLng = this._deg2rad(store.lng - origin.lng);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this._deg2rad(origin.lat)) * Math.cos(this._deg2rad(store.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    _deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    // Store detail deep link. `from` carries the PDP the shopper came from so the store
    // page can offer a way back (live ProductStockStore parity); `url` is nil until the
    // store metaobject definition is published to the online store.
    _storeHref(url) {
      if (!url) return '';
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'from=' + encodeURIComponent(location.pathname + location.search);
    }

    _renderResults(list) {
      if (!list.length) {
        this._show('empty');
        return;
      }
      this.resultsEl.textContent = '';
      var self = this;
      list.forEach(function (store) {
        var row = self.rowTemplate.content.cloneNode(true);

        var href = self._storeHref(store.url);

        var title = row.querySelector('[data-fis-store-link]');
        title.textContent = store.title || '';
        // No href leaves the anchor as inert text (the CSS scopes underline/hover to
        // [href]) rather than shipping a link with nowhere to go.
        if (href) title.href = href;

        // Same destination, mobile-only. Dropped outright without a page -- unlike the
        // title it carries no information of its own, so an inert copy is just noise.
        var view = row.querySelector('[data-fis-view]');
        if (href) {
          view.href = href;
        } else {
          view.remove();
        }

        var addr = row.querySelector('[data-fis-address]');
        (store.address || '').split(/\r\n|\r|\n/).forEach(function (line, i) {
          if (i > 0) addr.appendChild(document.createElement('br'));
          addr.appendChild(document.createTextNode(line));
        });

        var email = row.querySelector('[data-fis-email]');
        if (store.email) {
          email.href = 'mailto:' + store.email;
          email.textContent = store.email;
        } else {
          email.remove();
        }

        var phone = row.querySelector('[data-fis-phone]');
        if (store.phone) {
          phone.href = 'tel:' + store.phone;
          phone.textContent = store.phone;
        } else {
          phone.remove();
        }

        var directions = row.querySelector('[data-fis-directions]');
        directions.href = '//www.google.com/maps?saddr&daddr=' + (store.address || '').split(' ').join('+');

        var dist = row.querySelector('[data-fis-distance]');
        // distance is null on the pre-search listing (no point to measure from), so the
        // line drops out of the row rather than rendering an unanchored "0.00kms" -- the
        // same outcome live's `distance > 0` guard produces on mount.
        if (store.distance > 0) {
          var d = store.distance.toFixed(2);
          var unit = d === '1.00' ? 'km' : 'kms';
          dist.textContent = (self.dataset.distanceTemplate || '').replace('__D__', d + unit);
        } else {
          dist.hidden = true;
        }

        var stock = row.querySelector('[data-fis-stock]');
        if (store.stock > 0) {
          stock.textContent = store.stock > 3 ? self.dataset.labelInStock : self.dataset.labelLowStock;
        } else {
          stock.hidden = true;
        }

        self.resultsEl.appendChild(row);
      });
      this._show('results', list.length);
    }

    _show(state, count) {
      var prev = this.dataset.state;
      this.loadingEl.hidden = state !== 'loading';
      this.resultsEl.hidden = state !== 'results';
      this.emptyEl.hidden = state !== 'empty';
      this.dataset.state = state;

      // SR status line: the state panes are display:none while they change, so outcomes
      // are voiced here. "Empty" announces only as a fetch OUTCOME (loading -> empty), so
      // the pane reached without one -- no SKU on the trigger -- stays silent.
      if (!this.statusEl) return;
      if (state === 'loading') {
        this.statusEl.textContent = this.dataset.statusSearching || '';
      } else if (state === 'results') {
        this.statusEl.textContent =
          count === 1
            ? this.dataset.statusResultOne || ''
            : (this.dataset.statusResults || '').replace('__N__', String(count));
      } else if (prev === 'loading') {
        this.statusEl.textContent = this.dataset.statusEmpty || '';
      }
    }
  }

  if (!window.customElements.get('find-in-store-dialog')) {
    window.customElements.define('find-in-store-dialog', FindInStoreDialog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-field"] && !Shopify.designMode) return;
  try {
    // Native date inputs are never :placeholder-shown, so the floating label needs a
  // value hook: <dc-date-field> mirrors the input's filled state onto [data-filled].
  class DcDateField extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="date"]');
      if (!this.input) return;
      this._sync = this._sync.bind(this);
      this._onClick = this._onClick.bind(this);
      this.input.addEventListener('input', this._sync);
      this.input.addEventListener('change', this._sync);
      this.addEventListener('click', this._onClick);
      this._sync();
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('input', this._sync);
      this.input.removeEventListener('change', this._sync);
      this.removeEventListener('click', this._onClick);
    }

    // Live opens its datepicker calendar from a click anywhere in the field; the
    // native indicator alone is a tiny (and here hidden) target, so Chrome users
    // were landing in segment keyboard entry instead (#51 feedback item 11).
    // showPicker() throws outside a user gesture and in cross-origin iframes
    // (theme editor preview); the catch degrades to plain segment focus.
    _onClick() {
      if (typeof this.input.showPicker !== 'function') return;
      try {
        this.input.showPicker();
      } catch (e) {
        /* editor iframe or unsupported: keep native focus behaviour */
      }
    }

    _sync() {
      if (this.input.value) {
        this.input.setAttribute('data-filled', '');
      } else {
        this.input.removeAttribute('data-filled');
      }
    }
  }

  if (!window.customElements.get('dc-date-field')) {
    window.customElements.define('dc-date-field', DcDateField);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["google-maps-loader"] && !Shopify.designMode) return;
  try {
    window.ensureGoogleMaps =
    window.ensureGoogleMaps ||
    function (apiKey, mapId) {
      if (!apiKey) return Promise.resolve(null);
      if (window.__dcMapsPromise) return window.__dcMapsPromise;
      window.__dcMapsPromise = new Promise(function (resolve, reject) {
        window.__dcMapsCb = function () {
          Promise.all([
            window.google.maps.importLibrary('maps'),
            window.google.maps.importLibrary('marker'),
            window.google.maps.importLibrary('places'),
            window.google.maps.importLibrary('geocoding')
          ]).then(resolve, reject);
        };
        var url =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(apiKey) +
          '&libraries=places,marker&loading=async&callback=__dcMapsCb';
        if (mapId) {
          url += '&map_ids=' + encodeURIComponent(mapId);
        }
        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return window.__dcMapsPromise;
    };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["intelistyle-product-input"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__intelistyleProductInputBound) return;
    window.__intelistyleProductInputBound = true;

    document.addEventListener('variant:change', (event) => {
      const input = document.querySelector('input[data-intelistyle-product]');
      const variantId = event.detail && event.detail.variantId;
      if (!input || !variantId) return;

      try {
        const data = JSON.parse(input.value);
        const match = (data.variants || []).find((v) => String(v.id) === String(variantId));
        if (!match) return;
        data.selectedVariant = match;
        input.value = JSON.stringify(data);
      } catch (e) {
        /* malformed value: leave the input unchanged (vendor falls back to the URL handle) */
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["market-selector"] && !Shopify.designMode) return;
  try {
    class MarketSelector extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-market-select]');
      if (!this.select) return;
      this.handleChange = () => {
        if (this.select.form) this.select.form.submit();
      };
      this.select.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      if (this.select && this.handleChange) {
        this.select.removeEventListener('change', this.handleChange);
      }
    }
  }

  if (!window.customElements.get('market-selector')) {
    window.customElements.define('market-selector', MarketSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    class MegaMenu extends HTMLElement {
    connectedCallback() {
      // Disclosure state: reflect open/closed on the trigger's aria-expanded and
      // let Escape force the panel closed (the panel itself opens via CSS :hover /
      // :focus-within). Set up for every mega-menu, columns or image-only.
      this.trigger = this.querySelector('[data-mega-trigger]');
      this.onFocusin = this.onFocusin.bind(this);
      this.onFocusout = this.onFocusout.bind(this);
      this.onPointerenter = this.onPointerenter.bind(this);
      this.onPointerleave = this.onPointerleave.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.addEventListener('focusin', this.onFocusin);
      this.addEventListener('focusout', this.onFocusout);
      this.addEventListener('pointerenter', this.onPointerenter);
      this.addEventListener('pointerleave', this.onPointerleave);
      this.addEventListener('keydown', this.onKeydown);

      // Column balancing only applies when this mega-menu renders link columns.
      this.balance = this.balance.bind(this);
      this.columns = this.querySelector('.mega__columns');
      if (this.columns) {
        this.balance();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.balance);
          this.observer.observe(this);
        }
        window.addEventListener('resize', this.balance, { passive: true });
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.balance);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('focusin', this.onFocusin);
      this.removeEventListener('focusout', this.onFocusout);
      this.removeEventListener('pointerenter', this.onPointerenter);
      this.removeEventListener('pointerleave', this.onPointerleave);
      this.removeEventListener('keydown', this.onKeydown);
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.balance);
    }

    setExpanded(expanded) {
      if (this.trigger) this.trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    onFocusin() {
      if (this.collapsing) return;
      this.removeAttribute('data-collapsed');
      this.setExpanded(true);
    }

    onFocusout(event) {
      // Only collapse when focus leaves this mega-menu entirely.
      if (this.contains(event.relatedTarget)) return;
      this.removeAttribute('data-collapsed');
      this.setExpanded(false);
    }

    onPointerenter() {
      this.removeAttribute('data-collapsed');
      this.setExpanded(true);
    }

    onPointerleave() {
      this.removeAttribute('data-collapsed');
      this.setExpanded(false);
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      // Force the panel closed (overriding :hover/:focus-within) and return focus to
      // the trigger. The `collapsing` guard stops the resulting focusin reopening it.
      this.collapsing = true;
      this.setAttribute('data-collapsed', '');
      this.setExpanded(false);
      if (this.trigger) this.trigger.focus();
      this.collapsing = false;
    }

    balance() {
      const cols = this.columns;
      if (!cols) return;
      const blocks = Array.from(cols.children);
      if (blocks.length < 2) return;

      // Row unit = the height of one link line; the grid rows are fixed to this
      // so a submenu's row span maps directly to its link lines. The shortest
      // link is the unit, so a long label that wraps inside its column is never
      // taken as the one-line height.
      const linkEls = Array.from(cols.querySelectorAll('.mega__link'));
      const samples = linkEls.length ? linkEls : Array.from(cols.querySelectorAll('.mega__heading'));
      const heights = samples.map((el) => el.getBoundingClientRect().height).filter((h) => h >= 1);
      const unit = heights.length ? Math.min.apply(null, heights) : 0;
      if (unit < 1) return;

      // Mirror the live layout: each submenu spans its link count plus the
      // heading row and a fixed inter-submenu gap, and the grid holds the
      // tallest submenu plus a small buffer. `grid-auto-flow: column` then
      // packs short submenus together exactly as live does.
      const GAP_ROWS = 3;
      const BUFFER_ROWS = 2;
      let maxRows = 1;
      const spans = blocks.map((block) => {
        // A wrapped label spans as many rows as the lines it occupies.
        let links = 0;
        block.querySelectorAll('.mega__link').forEach((el) => {
          links += Math.max(1, Math.round(el.getBoundingClientRect().height / unit));
        });
        const heading = block.querySelector('.mega__heading') ? 1 : 0;
        const rows = links + heading + GAP_ROWS;
        if (rows > maxRows) maxRows = rows;
        return rows;
      });

      cols.style.setProperty('--mega-row-h', unit + 'px');
      cols.style.setProperty('--mega-rows', maxRows + BUFFER_ROWS);
      blocks.forEach((block, i) => {
        block.style.setProperty('--rows', spans[i]);
      });
    }
  }

  if (!customElements.get('mega-menu')) {
    customElements.define('mega-menu', MegaMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('notify-me-dialog')) {
    customElements.define(
      'notify-me-dialog',
      class extends HTMLElement {
        connectedCallback() {
          this._dialog = this.querySelector('.notify-me__dialog');
          this._form = this.querySelector('.notify-me__form');
          this._email = this.querySelector('#notify-me-email');
          this._checkbox = this.querySelector('#notify-me-subscribe');
          this._submit = this.querySelector('.notify-me__submit');
          if (!this._dialog || !this._form) return;

          this._variantId = '';
          this._busy = false;

          var scope = this.closest('product-form') || document;
          this._trigger = scope.querySelector('[data-notify-trigger]');
          if (this._trigger) {
            this._trigger.setAttribute('aria-haspopup', 'dialog');
            this._trigger.addEventListener('click', this.open.bind(this));
          }

          var closeBtn = this.querySelector('[data-notify-close]');
          if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
          var successClose = this.querySelector('.notify-me__success-close');
          if (successClose) successClose.addEventListener('click', this.close.bind(this));

          this._dialog.addEventListener('click', this._onBackdrop.bind(this));
          this._dialog.addEventListener('close', this._reset.bind(this));
          this._form.addEventListener('submit', this._onSubmit.bind(this));
          this._form.addEventListener('input', this._syncSubmit.bind(this));
          this._syncSubmit();

          // reCAPTCHA v3 (#327): Google's script loads when the dialog opens,
          // never in the editor; the token is minted at submit.
          this._honeypot = this.querySelector('input[name="hp_website"]');
          this._recaptchaKey = this.dataset.recaptchaKey || '';
          this._designMode = this.dataset.designMode === 'true';
        }

        open() {
          if (typeof this._dialog.showModal !== 'function') return;
          this._variantId = this._trigger ? this._trigger.getAttribute('data-variant-id') || '' : '';
          if (this._recaptchaKey && !this._designMode && window.dcRecaptcha) {
            window.dcRecaptcha.load(this._recaptchaKey);
          }
          this._dialog.showModal();
        }

        close() {
          if (this._dialog.open) this._dialog.close();
        }

        _onBackdrop(event) {
          if (event.target === this._dialog) this.close();
        }

        // Every close path (X, Escape, backdrop, success Close) lands here via the
        // native close event: next open always shows a fresh form (live parity).
        _reset() {
          this._setBusy(false);
          if (this._email) this._email.value = '';
          if (this._checkbox) this._checkbox.checked = true;
          this._setView('form');
          this._syncSubmit();
        }

        _setView(view) {
          this.dataset.view = view;
          this._dialog.setAttribute('aria-labelledby', 'notify-me-heading-' + view);
          if (view !== 'form' && this._dialog.open) {
            var heading = this.querySelector('#notify-me-heading-' + view);
            if (heading) heading.focus();
          }
        }

        _syncSubmit() {
          if (!this._submit) return;
          var hasEmail = this._email && this._email.value.trim() !== '';
          var consented = this._checkbox && this._checkbox.checked;
          this._submit.disabled = this._busy || !hasEmail || !consented;
        }

        _onSubmit(event) {
          event.preventDefault();
          if (this._busy) return;
          if (!this._form.reportValidity()) return;
          if (!this._checkbox || !this._checkbox.checked) return;

          var endpoint = this.dataset.endpoint;
          if (!endpoint) {
            this._setView('error');
            return;
          }

          this._setBusy(true);
          var self = this;
          var payload = {
            email: this._email.value.trim(),
            variant: this._variantId,
            // The shopper's actual choice, never a literal (#245). While consent
            // gates submission (live parity) this is always true here, but the
            // recorded value must come from the checkbox so ungating never
            // silently mis-records consent.
            acceptsMarketing: this._checkbox ? this._checkbox.checked : false,
            // Honeypot (#327): humans never see the field, so this is ''.
            hp_website: this._honeypot ? this._honeypot.value : ''
          };
          // reCAPTCHA v3 (#327): '' when there is no key, no Google, or the
          // editor; the Worker decides what '' means (fail closed when its
          // secret is set).
          var minted =
            this._recaptchaKey && !this._designMode && window.dcRecaptcha
              ? window.dcRecaptcha.token(this._recaptchaKey, 'notify_me')
              : Promise.resolve('');
          minted
            .then(function (token) {
              if (token) payload['g-recaptcha-response'] = token;
              return fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(payload)
              });
            })
            .then(function (response) {
              return response
                .json()
                .catch(function () {
                  return {};
                })
                .then(function (json) {
                  return { ok: response.ok, json: json };
                });
            })
            .then(function (result) {
              if (result.ok && result.json && result.json.status === 'success') {
                self._setView('success');
              } else {
                self._setView('error');
              }
            })
            .catch(function () {
              self._setView('error');
            })
            .finally(function () {
              self._setBusy(false);
            });
        }

        _setBusy(on) {
          this._busy = on;
          if (!this._submit) return;
          this._submit.setAttribute('aria-busy', on ? 'true' : 'false');
          if (on) {
            this._submit.disabled = true;
            // Live shows a spinner; keep the label as the accessible name.
            this._submit.setAttribute('aria-label', this.dataset.labelSubmit || '');
            this._submit.innerHTML = '<span class="notify-me__spinner" aria-hidden="true"></span>';
          } else {
            this._submit.removeAttribute('aria-label');
            this._submit.textContent = this.dataset.labelSubmit || '';
            this._syncSubmit();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.overlay__panel');
      this.backdrop = this.querySelector('[data-overlay-backdrop]');
      this.trigger = document.querySelector('[aria-controls="' + this.id + '"]');

      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBackdropClick = this.handleBackdropClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleDocFocusin = this.handleDocFocusin.bind(this);
      document.addEventListener('focusin', this.handleDocFocusin);

      if (this.trigger) {
        this.trigger.addEventListener('click', this.handleTriggerClick);
      }
      if (this.backdrop) {
        this.backdrop.addEventListener('click', this.handleBackdropClick);
      }
      // Close buttons are handled by DELEGATION: overlay bodies can be replaced
      // wholesale by Section Rendering swaps (the cart drawer re-renders its
      // contents on every cart:added/cart:updated), which would orphan
      // per-button listeners bound at connect time.
      this.addEventListener('click', this.handleCloseClick);
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener('click', this.handleTriggerClick);
      }
      if (this.backdrop) {
        this.backdrop.removeEventListener('click', this.handleBackdropClick);
      }
      this.removeEventListener('click', this.handleCloseClick);
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('focusin', this.handleDocFocusin);
    }

    // Track the last focused element OUTSIDE this overlay. When the overlay is
    // opened with no trigger (the cart drawer opens on add-to-cart), the opener
    // may be a button that was disabled during its pending fetch -- disabling
    // drops focus to <body> before open() runs, so activeElement alone cannot
    // tell us where to restore focus on close.
    handleDocFocusin(event) {
      if (!this.contains(event.target)) {
        this.lastOutsideFocus = event.target;
      }
    }

    get isOpen() {
      return this.hasAttribute('data-open');
    }

    open() {
      // Overlays are exclusive: opening one closes any other first (mirrors the
      // drawer->search handoff, Resolved Decision 3). Without this, the earlier
      // overlay's background-inert covers this element, so the freshly opened
      // panel renders with every control inert -- it cannot be closed by
      // pointer or keyboard (#1714 QA: drawer opened over the search overlay).
      // Closing the other overlay FIRST also lets its inert/scroll teardown run
      // before this open re-establishes both.
      document.querySelectorAll('overlay-drawer[data-open]').forEach((other) => {
        if (other !== this && typeof other.close === 'function') other.close();
      });
      const active = document.activeElement;
      this.previouslyFocused = active && active !== document.body ? active : this.lastOutsideFocus;
      this.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      this.setBackgroundInert(true);
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.swapIcon(true);
      }
      // Force a style flush so the now-visible panel can take focus (a still-hidden
      // element silently rejects focus); focus the first item, else the panel itself.
      void this.offsetHeight;
      const focusables = this.getFocusable();
      (focusables[0] || this.panel || this).focus();
      // Lets panel contents defer work to first open (predictive search fires its
      // trending + recommendation requests here rather than on page load).
      this.dispatchEvent(new CustomEvent('overlay:open', { bubbles: true }));
    }

    close() {
      if (!this.isOpen) return;
      this.removeAttribute('data-open');
      document.body.style.overflow = '';
      this.setBackgroundInert(false);
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.swapIcon(false);
      }
      // Return focus to the trigger (or whatever was focused before opening).
      const target = this.trigger && this.trigger.offsetParent !== null ? this.trigger : this.previouslyFocused;
      if (target && typeof target.focus === 'function') target.focus();
      this.dispatchEvent(new CustomEvent('overlay:close', { bubbles: true }));
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    // Optional trigger icon swap: if the trigger holds [data-icon-open] (shown when
    // closed) and [data-icon-close] (shown when open) children, toggle them. A no-op
    // when the trigger has neither, so the overlay stays generic across surfaces.
    swapIcon(open) {
      if (!this.trigger) return;
      const iconOpen = this.trigger.querySelector('[data-icon-open]');
      const iconClose = this.trigger.querySelector('[data-icon-close]');
      if (iconOpen) iconOpen.toggleAttribute('hidden', open);
      if (iconClose) iconClose.toggleAttribute('hidden', !open);
    }

    // A11y: inert the page behind the overlay so assistive tech can't browse it while
    // open (aria-modal alone is not honoured everywhere). The overlay's own top-level
    // ancestor (the header) is left interactive so the trigger can still toggle it
    // closed -- matching the live storefront. Only inert we add is removed on close.
    setBackgroundInert(on) {
      let topAncestor = this;
      while (topAncestor.parentElement && topAncestor.parentElement !== document.body) {
        topAncestor = topAncestor.parentElement;
      }
      Array.from(document.body.children).forEach((child) => {
        if (child === topAncestor) return;
        if (on) {
          if (!child.hasAttribute('inert')) {
            child.setAttribute('inert', '');
            child.setAttribute('data-overlay-inert', '');
          }
        } else if (child.hasAttribute('data-overlay-inert')) {
          child.removeAttribute('inert');
          child.removeAttribute('data-overlay-inert');
        }
      });
    }

    getFocusable() {
      if (!this.panel) return [];
      const selector = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
      return Array.from(this.panel.querySelectorAll(selector)).filter((el) => el.offsetParent !== null && !el.closest('[hidden]'));
    }

    trapTab(event) {
      const focusables = this.getFocusable();
      if (focusables.length === 0) {
        event.preventDefault();
        if (this.panel) this.panel.focus();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (!this.contains(active) || active === this) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleTriggerClick(event) {
      // Progressive enhancement: the trigger is an <a href> fallback to the search
      // results page; with JS we intercept and toggle the overlay instead.
      event.preventDefault();
      this.toggle();
    }

    handleBackdropClick() {
      this.close();
    }

    handleCloseClick(event) {
      if (event.target.closest('[data-overlay-close]')) this.close();
    }

    handleKeydown(event) {
      if (!this.isOpen) return;
      // A modal dialog layered over this overlay but outside its panel (the
      // cart drawer's quick-add bottom sheet, #1714) owns its own Escape and
      // Tab handling; trapping here would yank focus back into the panel and
      // close both on Escape.
      if (
        event.target &&
        event.target.closest &&
        !this.contains(event.target) &&
        event.target.closest('[role="dialog"][aria-modal="true"]')
      ) {
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab') {
        this.trapTab(event);
      }
    }
  }

  if (!window.customElements.get('overlay-drawer')) {
    window.customElements.define('overlay-drawer', OverlayDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination-nav"] && !Shopify.designMode) return;
  try {
    class DcPagination extends HTMLElement {
    static get observedAttributes() {
      return ['total-pages', 'current-page'];
    }

    connectedCallback() {
      this.nav = this.querySelector('[data-pagination-nav]');
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    attributeChangedCallback() {
      if (this.nav) this.render();
    }

    get totalPages() {
      const n = parseInt(this.getAttribute('total-pages'), 10);
      return Number.isNaN(n) || n < 0 ? 0 : n;
    }

    get currentPage() {
      const n = parseInt(this.getAttribute('current-page'), 10);
      return Number.isNaN(n) || n < 1 ? 1 : n;
    }

    // Port of live `Pagination.tsx#pagesToShow`: first and last always, two
    // pages either side of the current one; a single missing page is shown as
    // itself, any wider gap collapses to one ellipsis.
    pages() {
      const total = this.totalPages;
      const current = Math.min(this.currentPage, total);
      const delta = 2;
      const range = [1];
      for (let i = Math.max(2, current - delta); i <= Math.min(total - 1, current + delta); i++) {
        range.push(i);
      }
      if (total > 1) range.push(total);
      const out = [];
      let prev = 0;
      range.forEach((page) => {
        if (page - prev === 2) out.push(prev + 1);
        else if (page - prev !== 1) out.push('ellipsis');
        out.push(page);
        prev = page;
      });
      return out;
    }

    render() {
      if (!this.nav) return;
      const total = this.totalPages;
      // Live returns null below two pages; the shared CSS collapses the empty
      // nav's top margin.
      if (total <= 1) {
        this.nav.textContent = '';
        return;
      }
      const current = Math.min(this.currentPage, total);
      const ds = this.dataset;
      const list = document.createElement('ul');
      list.className = 'collection-pagination__list';
      list.appendChild(this.navItem('previous', current > 1, current - 1));
      this.pages().forEach((page) => {
        const li = document.createElement('li');
        if (page === 'ellipsis') {
          const dots = document.createElement('span');
          dots.className = 'collection-pagination__ellipsis';
          dots.setAttribute('aria-hidden', 'true');
          dots.textContent = '…';
          li.appendChild(dots);
          const sr = document.createElement('span');
          sr.className = 'visually-hidden';
          sr.textContent = ds.labelMore || '';
          li.appendChild(sr);
        } else if (page === current) {
          const active = document.createElement('span');
          active.className = 'collection-pagination__page collection-pagination__page--active';
          active.setAttribute('aria-current', 'page');
          active.textContent = String(page);
          li.appendChild(active);
        } else {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'collection-pagination__page';
          btn.dataset.page = String(page);
          btn.setAttribute('aria-label', (ds.labelGoPage || '').replace('%page%', String(page)));
          btn.textContent = String(page);
          li.appendChild(btn);
        }
        list.appendChild(li);
      });
      list.appendChild(this.navItem('next', current < total, current + 1));
      this.nav.textContent = '';
      this.nav.appendChild(list);
    }

    navItem(direction, enabled, targetPage) {
      const ds = this.dataset;
      const li = document.createElement('li');
      const el = document.createElement(enabled ? 'button' : 'span');
      el.className = 'collection-pagination__nav';
      if (enabled) {
        el.type = 'button';
        el.dataset.page = String(targetPage);
        el.setAttribute('aria-label', direction === 'previous' ? ds.labelGoPrevious || '' : ds.labelGoNext || '');
      } else {
        el.setAttribute('aria-disabled', 'true');
      }
      const label = document.createElement('span');
      label.className = 'collection-pagination__nav-label';
      label.textContent = direction === 'previous' ? ds.labelPrevious || '' : ds.labelNext || '';
      const icon = this.icon(direction);
      if (direction === 'previous') {
        if (icon) el.appendChild(icon);
        el.appendChild(label);
      } else {
        el.appendChild(label);
        if (icon) el.appendChild(icon);
      }
      li.appendChild(el);
      return li;
    }

    icon(direction) {
      const tpl = this.querySelector('template[data-pagination-icon="' + direction + '"]');
      return tpl ? tpl.content.cloneNode(true) : null;
    }

    handleClick(e) {
      const target = e.target.closest('[data-page]');
      if (!target || !this.contains(target)) return;
      e.preventDefault();
      const page = parseInt(target.dataset.page, 10);
      if (Number.isNaN(page) || page < 1 || page > this.totalPages || page === this.currentPage) return;
      this.setAttribute('current-page', String(page));
      this.dispatchEvent(new CustomEvent('pagination:change', { detail: { page: page }, bubbles: true }));
    }
  }

  if (!window.customElements.get('dc-pagination')) {
    window.customElements.define('dc-pagination', DcPagination);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('predictive-search')) {
    customElements.define(
      'predictive-search',
      class PredictiveSearch extends HTMLElement {
        constructor() {
          super();
          this.minChars = 3;
          this.debounceMs = 300;
          this.limit = 4;
          this.mode = 'rail';
          this.primed = false;
          this.bound = false;
          this.timer = null;
          this.railRecords = [];
          this.railResponseId = '';
          this.resultRecords = [];
          this.resultResponseId = '';
          this.onInput = this.onInput.bind(this);
          this.onSubmit = this.onSubmit.bind(this);
          this.onClick = this.onClick.bind(this);
          this.onOverlayOpen = this.onOverlayOpen.bind(this);
        }

        connectedCallback() {
          if (this.bound) return;
          this.bound = true;

          this.form = this.querySelector('form');
          this.input = this.querySelector('input[type="search"]');
          this.enhanced = this.querySelector('[data-ps-enhanced]');
          this.aside = this.querySelector('[data-ps-aside]');
          this.grid = this.querySelector('[data-ps-grid]');
          this.asideHeading = this.querySelector('[data-ps-aside-heading]');
          this.popularList = this.querySelector('[data-ps-popular]');
          this.recentList = this.querySelector('[data-ps-recent]');
          this.seeResults = this.querySelector('[data-ps-see-results]');
          this.status = this.querySelector('[data-ps-status], .predictive-search__status');

          // No Searchspring on this page (setting off, or no Site ID for this
          // market): leave the plain form and render nothing else.
          if (!window.Searchspring) {
            this.setAttribute('data-ps-inactive', '');
            return;
          }

          this.ss = window.Searchspring;
          this.headingProducts = this.dataset.headingProducts || '';
          this.headingSuggestions = this.dataset.headingSuggestions || '';
          this.searchUrl = this.dataset.searchUrl || '/search';

          if (this.enhanced) this.enhanced.hidden = false;
          if (this.aside) this.aside.hidden = false;

          if (this.input) this.input.addEventListener('input', this.onInput);
          if (this.form) this.form.addEventListener('submit', this.onSubmit);
          this.addEventListener('click', this.onClick);

          // The overlay shell owns open/close; it announces first open so the
          // trending and recommendation requests never run on page load.
          this.overlay = this.closest('[data-overlay]');
          if (this.overlay) {
            this.overlay.addEventListener('overlay:open', this.onOverlayOpen);
            if (this.overlay.hasAttribute('data-open')) this.prime();
          } else {
            this.prime();
          }
        }

        disconnectedCallback() {
          if (this.input) this.input.removeEventListener('input', this.onInput);
          if (this.form) this.form.removeEventListener('submit', this.onSubmit);
          this.removeEventListener('click', this.onClick);
          if (this.overlay) this.overlay.removeEventListener('overlay:open', this.onOverlayOpen);
          if (this.observer) this.observer.disconnect();
          if (this.timer) clearTimeout(this.timer);
          // Reset so a moved node rebinds cleanly on reconnect.
          this.bound = false;
        }

        onOverlayOpen() {
          this.prime();
        }

        // Fires once per page load: terms and the rail are cached thereafter.
        prime() {
          if (this.primed) return;
          this.primed = true;
          this.renderRecent();
          this.loadTrending();
          this.loadRail();
        }

        /* ---------------- terms ---------------- */

        loadTrending() {
          var self = this;
          this.ss.client
            .trending({ limit: this.limit })
            .then(function (response) {
              var queries = (response && response.trending && response.trending.queries) || [];
              var terms = queries
                .slice()
                .sort(function (a, b) {
                  return Number(b.popularity || 0) - Number(a.popularity || 0);
                })
                .map(function (entry) {
                  return entry.searchQuery;
                })
                .filter(Boolean);
              self.renderTerms(self.popularList, terms.length ? terms : self.fallbackTerms());
            })
            .catch(function () {
              self.renderTerms(self.popularList, self.fallbackTerms());
            });
        }

        fallbackTerms() {
          var raw = this.dataset.fallbackTerms || '';
          return raw
            .split('|')
            .map(function (term) {
              return term.trim();
            })
            .filter(Boolean);
        }

        renderRecent() {
          var recent = [];
          try {
            recent = this.ss.session.recentSearches() || [];
          } catch (e) {
            recent = [];
          }
          this.renderTerms(this.recentList, recent);
        }

        renderTerms(list, terms) {
          if (!list) return;
          list.textContent = '';
          (terms || []).forEach(function (term) {
            var item = document.createElement('li');
            var link = document.createElement('a');
            link.className = 'predictive-search__term';
            link.href = this.termUrl(term);
            link.setAttribute('data-ps-term', term);
            link.textContent = term;
            item.appendChild(link);
            list.appendChild(item);
          }, this);
        }

        termUrl(term) {
          return this.searchUrl + '?query=' + encodeURIComponent(String(term).toLowerCase());
        }

        queryUrl(term) {
          /* `q` is Shopify's own search param, so the results page's native
             fallback grid populates for JS-disabled and NZ-market shoppers
             (#113). The search page still accepts `query` for inbound links. */
          return this.searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
        }

        /* ---------------- querying ---------------- */

        onInput() {
          var self = this;
          if (this.timer) clearTimeout(this.timer);
          this.timer = setTimeout(function () {
            self.timer = null;
            self.query();
          }, this.debounceMs);
        }

        query() {
          var term = this.term();
          if (term.length < this.minChars) {
            this.showRail();
            return;
          }

          var self = this;
          if (this.grid) this.grid.setAttribute('aria-busy', 'true');

          // The foundation aborts the previous in-flight request per endpoint
          // itself, so no AbortController is needed here. The term guard below
          // still matters: a request that resolves after the field has moved on
          // must not paint a stale result set.
          this.ss.client
            .autocomplete({ q: term, resultsPerPage: this.limit })
            .then(function (response) {
              if (self.grid) self.grid.removeAttribute('aria-busy');
              if (self.term() !== term) return;
              var records = self.ss.normalizeRecords((response && response.results) || []);
              self.resultResponseId = (response && response.responseId) || '';
              self.trackAutocomplete(records, self.resultResponseId);
              if (records.length) {
                self.resultRecords = records;
                self.showResults(records);
              } else {
                // Live falls back to the rail on an empty result set and hides
                // See results -- there is no in-drawer no-results state.
                self.showRail();
              }
            })
            .catch(function (error) {
              if (self.grid) self.grid.removeAttribute('aria-busy');
              if (self.ss.errors && self.ss.errors.isAbort(error)) return;
              // Keep the last good content: live shows no error state.
            });
        }

        term() {
          return this.input ? this.input.value.trim() : '';
        }

        /* ---------------- rendering ---------------- */

        showRail() {
          this.mode = 'rail';
          this.setAttribute('data-ps-mode', 'rail');
          if (this.asideHeading) this.asideHeading.textContent = this.headingSuggestions;
          if (this.seeResults) this.seeResults.hidden = true;
          this.paint(this.railRecords);
          this.observeRail();
        }

        showResults(records) {
          this.mode = 'results';
          this.setAttribute('data-ps-mode', 'results');
          if (this.asideHeading) this.asideHeading.textContent = this.headingProducts;
          if (this.seeResults) {
            this.seeResults.hidden = false;
            this.seeResults.href = this.queryUrl(this.term());
          }
          if (this.observer) this.observer.disconnect();
          this.paint(records);
          this.announce(records.length);
        }

        paint(records) {
          if (!this.grid) return;
          this.grid.textContent = '';
          (records || []).forEach(function (record, index) {
            var card = this.ss.renderMiniCard(record, { index: index });
            card.setAttribute('data-ps-index', String(index));
            this.grid.appendChild(card);
          }, this);
        }

        announce(count) {
          if (!this.status) return;
          var template = (this.ss.config.strings && this.ss.config.strings.predictiveResults) || '';
          if (!template) return;
          this.status.textContent = template.replace('__COUNT__', String(count));
        }

        /* ---------------- recommendations rail ---------------- */

        loadRail() {
          var self = this;
          var tag = this.dataset.recommendTag;
          if (!tag) return;
          this.ss.client
            .recommend({ tags: tag, limits: this.limit })
            .then(function (response) {
              var profile = Array.isArray(response) ? response[0] : response;
              var results = (profile && profile.results) || [];
              self.railRecords = results.map(function (result) {
                return self.ss.normalizeRecommendResult(result);
              });
              self.railResponseId = (profile && profile.responseId) || '';
              if (self.railRecords.length && self.ss.canTrack()) {
                self.ss.beacon.render({
                  source: 'recommendations',
                  responseId: self.railResponseId,
                  tag: tag,
                });
              }
              if (self.mode === 'rail') self.showRail();
            })
            .catch(function () {
              /* No rail is a legitimate outcome when the profile is unconfigured. */
            });
        }

        // Recommendation impressions are viewport-gated on live; autocomplete
        // impressions are not (see trackAutocomplete).
        observeRail() {
          if (!this.grid || !this.railRecords.length) return;
          if (typeof IntersectionObserver !== 'function') return;
          if (this.observer) this.observer.disconnect();
          var self = this;
          this.observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var index = Number(entry.target.getAttribute('data-ps-index'));
                var record = self.railRecords[index];
                self.observer.unobserve(entry.target);
                if (!record || !self.ss.canTrack()) return;
                self.ss.beacon.impression({
                  source: 'recommendations',
                  record: record,
                  responseId: self.railResponseId,
                  tag: self.dataset.recommendTag,
                });
              });
            },
            { threshold: 0 }
          );
          Array.prototype.forEach.call(this.grid.children, function (child) {
            self.observer.observe(child);
          });
        }

        /* ---------------- analytics ---------------- */

        trackAutocomplete(records, responseId) {
          if (!this.ss.canTrack()) return;
          this.ss.beacon.render({ source: 'autocomplete', responseId: responseId });
          // All results, immediately -- live does not viewport-gate the
          // autocomplete source. The foundation batches these into one request.
          records.forEach(function (record) {
            this.ss.beacon.impression({
              source: 'autocomplete',
              record: record,
              responseId: responseId,
            });
          }, this);
        }

        trackRedirect(url) {
          if (!this.ss.canTrack()) return;
          var absolute = url.indexOf('http') === 0 ? url : window.location.origin + url;
          this.ss.beacon.redirect({
            source: 'autocomplete',
            redirect: absolute,
            responseId: this.resultResponseId,
          });
        }

        /* ---------------- interaction ---------------- */

        onSubmit(event) {
          if (!this.ss) return;
          var term = this.term();
          if (!term) return;
          event.preventDefault();
          var url = this.queryUrl(term);
          this.trackRedirect(url);
          window.location.href = url;
        }

        onClick(event) {
          var prev = event.target.closest('[data-ps-prev]');
          var next = event.target.closest('[data-ps-next]');
          if (prev || next) {
            this.scrollRail(prev ? -1 : 1);
            return;
          }

          var term = event.target.closest('[data-ps-term]');
          if (term) {
            this.trackRedirect(term.getAttribute('href'));
            return;
          }

          var see = event.target.closest('[data-ps-see-results]');
          if (see) {
            this.trackRedirect(see.getAttribute('href'));
            return;
          }

          var card = event.target.closest('[data-ps-card]');
          if (card) this.onCardClick(card);
        }

        onCardClick(card) {
          if (!this.ss || !this.ss.canTrack()) return;
          var index = Number(card.getAttribute('data-ps-index'));
          var isResults = this.mode === 'results';
          var record = isResults ? this.resultRecords[index] : this.railRecords[index];
          if (!record) return;
          if (isResults) {
            this.ss.beacon.clickthrough({
              source: 'autocomplete',
              record: record,
              responseId: this.resultResponseId,
            });
          } else {
            this.ss.beacon.clickthrough({
              source: 'recommendations',
              record: record,
              responseId: this.railResponseId,
              tag: this.dataset.recommendTag,
            });
          }
        }

        scrollRail(direction) {
          if (!this.grid) return;
          var first = this.grid.firstElementChild;
          var step = first ? first.getBoundingClientRect().width + 10 : 160;
          this.grid.scrollBy({ left: step * direction, behavior: 'smooth' });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-zoom"] && !Shopify.designMode) return;
  try {
    class ProductZoom extends HTMLElement {
    connectedCallback() {
      // Portal to body so the fixed modal escapes any transformed / stacking
      // ancestor (otherwise it renders below the header instead of covering it),
      // and so background-inert targets real top-level page elements. Moving the
      // node re-fires connectedCallback; the guard runs init only once at body level.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }

      this.panel = this.querySelector('.product-zoom__panel');
      this.stage = this.querySelector('[data-zoom-stage]');
      this.slides = Array.from(this.querySelectorAll('.product-zoom__slide'));
      this.closeBtn = this.querySelector('[data-zoom-close]');
      this.prevBtn = this.querySelector('[data-zoom-prev]');
      this.nextBtn = this.querySelector('[data-zoom-next]');
      this.active = 0;
      this.MIN_SCALE = 0.5;
      this.MAX_SCALE = 5;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.pointers = new Map();
      this.scale = 1;

      this.onKeydown = this.handleKeydown.bind(this);
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.onWheel = this.handleWheel.bind(this);

      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

      this.stage.addEventListener('pointerdown', this.onPointerDown);
      this.stage.addEventListener('wheel', this.onWheel, { passive: false });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      this.stopInertia();
    }

    get isOpen() {
      return this.hasAttribute('data-open');
    }

    open(index) {
      this.previouslyFocused = document.activeElement;
      this.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      this.setBackgroundInert(true);
      document.addEventListener('keydown', this.onKeydown);
      this.show(typeof index === 'number' ? index : 0);
      void this.offsetHeight;
      if (this.closeBtn) this.closeBtn.focus();
    }

    close() {
      if (!this.isOpen) return;
      this.removeAttribute('data-open');
      document.body.style.overflow = '';
      this.setBackgroundInert(false);
      document.removeEventListener('keydown', this.onKeydown);
      this.stopInertia();
      this.pauseAllVideos();
      this.resetTransform();
      this.active = 0;
      const target = this.previouslyFocused;
      if (target && typeof target.focus === 'function') target.focus();
    }

    show(index) {
      const count = this.slides.length;
      if (!count) return;
      this.active = ((index % count) + count) % count;
      this.slides.forEach((slide, i) => {
        const on = i === this.active;
        slide.toggleAttribute('hidden', !on);
        slide.classList.toggle('is-active', on);
      });
      this.stopInertia();
      this.resetTransform();
      if (this.stage) {
        this.stage.scrollTop = 0;
        this.stage.scrollLeft = 0;
      }
      this.playActiveVideo();
    }

    step(direction) {
      this.show(this.active + direction);
    }

    activeTransformEl() {
      const slide = this.slides[this.active];
      return slide ? slide.querySelector('[data-zoom-transform]') : null;
    }

    resetTransform() {
      this.scale = 1;
      this.applyTransform();
    }

    applyTransform() {
      const el = this.activeTransformEl();
      if (!el) return;
      // Centre the image on whichever axis it fits within the stage (live centres
      // it -- origin 0 0 alone pins it to the top-left). On an axis where it
      // overflows, anchor at 0 so native scroll reaches every edge. Same
      // translate+scale form always, so the bounce-back transition is smooth.
      const sw = this.stage.clientWidth;
      const sh = this.stage.clientHeight;
      const scaledW = el.offsetWidth * this.scale;
      const scaledH = el.offsetHeight * this.scale;
      const tx = scaledW < sw ? (sw - scaledW) / 2 : 0;
      const ty = scaledH < sh ? (sh - scaledH) / 2 : 0;
      el.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + this.scale + ')';
      // Zoomed in: take over touch panning (both axes); otherwise leave native
      // vertical scroll to the browser.
      this.stage.style.touchAction = this.scale > 1 ? 'none' : 'pan-y';
    }

    clampScale(scale) {
      return Math.min(this.MAX_SCALE, Math.max(this.MIN_SCALE, scale));
    }

    // Scale-only zoom (transform-origin 0 0) toward a focal point, keeping that
    // point under the cursor via native scroll. The content grows into positive
    // scroll space so every edge stays reachable (no left/top cut-off).
    zoomTo(nextScale, focalClientX, focalClientY) {
      const prev = this.scale;
      const scale = this.clampScale(nextScale);
      if (scale === prev) return;
      const rect = this.stage.getBoundingClientRect();
      const cx = focalClientX - rect.left;
      const cy = focalClientY - rect.top;
      const factor = scale / prev;
      const targetLeft = (this.stage.scrollLeft + cx) * factor - cx;
      const targetTop = (this.stage.scrollTop + cy) * factor - cy;
      this.scale = scale;
      this.applyTransform();
      // Set scroll after the transform so the new scroll extents are in effect.
      this.stage.scrollLeft = targetLeft;
      this.stage.scrollTop = targetTop;
    }

    handleWheel(event) {
      // Normal wheel scrolls the stage natively (scroll down to see the large
      // image). Only a pinch gesture (ctrl/meta + wheel, e.g. a trackpad pinch) zooms.
      if (!event.ctrlKey && !event.metaKey) return;
      event.preventDefault();
      const el = this.activeTransformEl();
      if (el) el.style.transition = '';
      const factor = event.deltaY < 0 ? 1.1 : 1 / 1.1;
      this.zoomTo(this.scale * factor, event.clientX, event.clientY);
      // A trackpad pinch streams wheel events with no "release"; debounce the end,
      // then bounce back if zoomed out below the original scale.
      if (this.wheelEndTimer) clearTimeout(this.wheelEndTimer);
      this.wheelEndTimer = setTimeout(() => {
        this.wheelEndTimer = null;
        if (this.scale < 1) this.settle();
      }, 140);
    }

    handlePointerDown(event) {
      this.stopInertia();
      // Cancel any in-flight settle transition so this gesture tracks instantly.
      const activeEl = this.activeTransformEl();
      if (activeEl) activeEl.style.transition = '';
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (this.pointers.size === 1) {
        // Drag-to-pan (via native scroll) only when zoomed; at scale 1 the browser
        // handles native scrolling.
        if (this.scale > 1) {
          this.dragStart = { x: event.clientX, y: event.clientY, sl: this.stage.scrollLeft, st: this.stage.scrollTop };
        } else {
          this.dragStart = null;
        }
      } else if (this.pointers.size === 2) {
        this.pinchStart = this.pinchSnapshot();
      }
      window.addEventListener('pointermove', this.onPointerMove, { passive: false });
      window.addEventListener('pointerup', this.onPointerUp);
    }

    pinchSnapshot() {
      const pts = Array.from(this.pointers.values());
      const dist = Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y);
      return {
        dist: dist || 1,
        scale: this.scale,
        midX: (pts[0].x + pts[1].x) / 2,
        midY: (pts[0].y + pts[1].y) / 2,
      };
    }

    handlePointerMove(event) {
      if (!this.pointers.has(event.pointerId)) return;
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (this.pointers.size >= 2 && this.pinchStart) {
        event.preventDefault();
        const snap = this.pinchSnapshot();
        const nextScale = this.pinchStart.scale * (snap.dist / this.pinchStart.dist);
        this.zoomTo(nextScale, snap.midX, snap.midY);
      } else if (this.pointers.size === 1 && this.dragStart) {
        event.preventDefault();
        this.stage.scrollLeft = this.dragStart.sl - (event.clientX - this.dragStart.x);
        this.stage.scrollTop = this.dragStart.st - (event.clientY - this.dragStart.y);
      }
    }

    handlePointerUp(event) {
      this.pointers.delete(event.pointerId);
      const pinchEnded = this.pinchStart && this.pointers.size < 2;
      if (this.pointers.size < 2) this.pinchStart = null;
      // Bounce-back: releasing a pinch that zoomed below the original scale springs
      // the image back to its original state (matches live react-quick-pinch-zoom).
      if (pinchEnded && this.scale < 1) this.settle();
      if (this.pointers.size === 1) {
        const pt = Array.from(this.pointers.values())[0];
        this.dragStart = this.scale > 1 ? { x: pt.x, y: pt.y, sl: this.stage.scrollLeft, st: this.stage.scrollTop } : null;
      }
      if (this.pointers.size === 0) {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }
    }

    // Animate the scale back to the original state (1x). Panning uses native scroll,
    // so there is no translate to reset.
    settle() {
      const el = this.activeTransformEl();
      this.scale = 1;
      if (!el || this.reduceMotion.matches) {
        this.applyTransform();
        return;
      }
      el.style.transition = 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1)';
      this.applyTransform();
      const clear = () => {
        el.style.transition = '';
        el.removeEventListener('transitionend', clear);
      };
      el.addEventListener('transitionend', clear);
    }

    // Cancels the pending trackpad-pinch bounce-back timer (named stopInertia for
    // its callers: close / show / gesture start).
    stopInertia() {
      if (this.wheelEndTimer) {
        clearTimeout(this.wheelEndTimer);
        this.wheelEndTimer = null;
      }
    }

    playActiveVideo() {
      this.pauseAllVideos();
      if (this.reduceMotion.matches) return;
      const slide = this.slides[this.active];
      const video = slide ? slide.querySelector('video') : null;
      if (video) {
        const playback = video.play();
        if (playback && playback.catch) playback.catch(function () {});
      }
    }

    pauseAllVideos() {
      this.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
    }

    setBackgroundInert(on) {
      let topAncestor = this;
      while (topAncestor.parentElement && topAncestor.parentElement !== document.body) {
        topAncestor = topAncestor.parentElement;
      }
      Array.from(document.body.children).forEach((child) => {
        if (child === topAncestor) return;
        if (on) {
          if (!child.hasAttribute('inert')) {
            child.setAttribute('inert', '');
            child.setAttribute('data-zoom-inert', '');
          }
        } else if (child.hasAttribute('data-zoom-inert')) {
          child.removeAttribute('inert');
          child.removeAttribute('data-zoom-inert');
        }
      });
    }

    getFocusable() {
      const selector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(this.panel.querySelectorAll(selector)).filter((el) => el.offsetParent !== null);
    }

    trapTab(event) {
      const focusables = this.getFocusable();
      if (focusables.length === 0) {
        event.preventDefault();
        this.panel.focus();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (!this.contains(active) || active === this) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleKeydown(event) {
      if (!this.isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab') {
        this.trapTab(event);
      } else if (event.key === 'ArrowLeft' && this.slides.length > 1) {
        this.step(-1);
      } else if (event.key === 'ArrowRight' && this.slides.length > 1) {
        this.step(1);
      }
    }
  }

  if (!window.customElements.get('product-zoom')) {
    window.customElements.define('product-zoom', ProductZoom);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.zoom = document.querySelector('product-zoom');
      this.tiles = Array.from(this.querySelectorAll('[data-zoom-index]'));
      this.onTileClick = this.handleTileClick.bind(this);
      this.tiles.forEach((tile) => tile.addEventListener('click', this.onTileClick));
      this.setupGridVideos();
    }

    disconnectedCallback() {
      this.tiles.forEach((tile) => tile.removeEventListener('click', this.onTileClick));
      if (this.videoObserver) this.videoObserver.disconnect();
    }

    handleTileClick(event) {
      const index = parseInt(event.currentTarget.getAttribute('data-zoom-index'), 10) || 0;
      if (this.zoom && typeof this.zoom.open === 'function') {
        this.zoom.open(index);
      }
    }

    // Desktop-grid videos: the mobile slider's videos are managed by dc-slider.
    setupGridVideos() {
      const grid = this.querySelector('.product-gallery__grid');
      if (!grid) return;
      this.gridVideos = Array.from(grid.querySelectorAll('[data-dc-video]'));
      if (!this.gridVideos.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduceMotion.matches) {
        this.gridVideos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }
      if (!('IntersectionObserver' in window)) return;

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const playback = entry.target.play();
              if (playback && playback.catch) playback.catch(function () {});
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );
      this.gridVideos.forEach((video) => this.videoObserver.observe(video));
    }
  }

  if (!window.customElements.get('product-gallery')) {
    window.customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-add"] && !Shopify.designMode) return;
  try {
    // Market-aware availability for cards built from the Searchspring feed (#301).
  // The feed's per-size flags come from the AU catalogue and know nothing about
  // which locations fulfil the visitor's market, so a size can render active and
  // then 422 at the cart. The theme's `product-availability` section (Section
  // Rendering API) echoes the shared `variant-available` rule -- Shopify's
  // market-aware `variant.available` gated by the live Click & Collect
  // metafield -- for the requested product in the visitor's session, which is
  // exactly what the PDP renders. (`/products/<handle>.js` was the first
  // source; it knows stock but not the metafield, so a stale feed flag left the
  // card and the PDP disagreeing.) Cached per product path for the page: the
  // hover, the sheet and a later re-hover share one request. Resolves to null
  // on any failure so callers keep the feed's answer rather than greying
  // everything.
  var marketAvailabilityCache = {};
  function marketAvailability(productUrl) {
    if (!productUrl) return Promise.resolve(null);
    var path;
    try {
      path = new URL(productUrl, window.location.origin).pathname;
    } catch (e) {
      return Promise.resolve(null);
    }
    if (marketAvailabilityCache[path]) return marketAvailabilityCache[path];
    marketAvailabilityCache[path] = fetch(path + '?section_id=product-availability', {
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        var match = html.match(/<script[^>]*data-product-availability[^>]*>([\s\S]*?)<\/script>/);
        if (!match) return null;
        var json = JSON.parse(match[1]);
        if (!json || !json.variants || typeof json.variants !== 'object') return null;
        var map = {};
        Object.keys(json.variants).forEach(function (id) {
          map[String(id)] = json.variants[id] === true;
        });
        return map;
      })
      .catch(function () {
        return null;
      });
    return marketAvailabilityCache[path];
  }

  class DcQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.__bound) return;
      this.__bound = true;

      this.productId = parseInt(this.dataset.productId, 10);

      this.errorEl = this.querySelector('[data-qa-error]');
      this.trigger = this.querySelector('[data-qa-trigger]');

      // Feed-built cards only (searchspring.js sets the attribute); Liquid cards
      // already rendered from the market-aware rule. The desktop panel reveals on
      // media hover / panel focus, so those are the moments to settle the sizes;
      // the mobile trigger hands the same promise to the sheet (#301).
      this.verify = this.hasAttribute('data-verify-availability');
      if (this.verify && this.querySelector('[data-qa-size]')) {
        var reveal = this.verifyMarket.bind(this);
        var media = this.closest('.product-card__media');
        if (media) media.addEventListener('pointerenter', reveal);
        this.addEventListener('focusin', reveal);
      }

      // ONE delegated listener per card, not one per size button: a flagged
      // 48-product PLP carries ~470 size buttons across the Searchspring grid and
      // the native fallback, so per-button binding cost ~530 listeners a page.
      // Both controls are always descendants of this element, so `closest()`
      // resolves them -- and it is strictly more robust than the old binding,
      // which relied on `currentTarget` because the real event target is usually
      // the sold-out label span or the trigger's <svg>. Same delegation
      // `<dc-quick-add-modal>` uses for its size row.
      //
      // Nothing is unbound on disconnect: the listener lives on this element, so
      // it is collected with it, and a re-inserted card keeps working (the old
      // symmetric remove + `__bound` guard would have left one dead).
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      if (!event.target || !event.target.closest) return;
      var size = event.target.closest('[data-qa-size]');
      if (size && this.contains(size)) {
        this.handleSizeClick(event, size);
        return;
      }
      var trigger = event.target.closest('[data-qa-trigger]');
      if (trigger && this.contains(trigger)) this.handleTriggerClick(event);
    }

    // Per-card variant payload, parsed once. The bottom sheet renders from this
    // object, so it never needs a fetch.
    payload() {
      if (this.__payload !== undefined) return this.__payload;
      var el = this.querySelector('script[data-quick-add-data]');
      try {
        this.__payload = el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        this.__payload = null;
      }
      return this.__payload;
    }

    // The Searchspring record rides on the card element (set by the results
    // host when it appends the card). Null on native-grid cards, which fire no
    // beacon -- there is no session or responseId for them.
    record() {
      var card = this.closest('.product-card');
      return (card && card.__record) || null;
    }

    handleTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var data = this.payload();
      if (!data) return;
      document.dispatchEvent(
        new CustomEvent('quick-add:open', {
          detail: {
            data: data,
            record: this.record(),
            trigger: this.trigger,
            availability: this.verify ? this.verifyMarket() : null,
          },
        })
      );
    }

    handleSizeClick(event, btn) {
      event.preventDefault();
      // Stops at this element rather than at the button, which is the same
      // outcome: the results host's clickthrough beacon listens in the bubble
      // phase on <searchspring-results>, above this element.
      event.stopPropagation();
      // `disabled` = sold out; `aria-disabled` = an add already in flight on
      // this button (setBusy). Both are inert, only the first is unfocusable.
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (Number.isNaN(variantId)) return;
      this.add(variantId, btn);
    }

    // Cart contract copied verbatim from product-quick-shop.handleAdd, plus the
    // hidden _aux_* line properties from the card's analytics payload via
    // dcAnalytics.lineProps (#268, #336, event map Q7): the checkout pixel cannot
    // see product tags. Live's quick add sent none; that gap is deliberate to close.
    add(variantId, btn) {
      var properties = {};
      var dca = window.dcAnalytics;
      if (dca && dca.lineProps) {
        var variants = (this.payload() || {}).variants || [];
        var size = '';
        for (var i = 0; i < variants.length; i++) {
          if (Number(variants[i].id) === Number(variantId)) {
            size = variants[i].size;
            break;
          }
        }
        Object.assign(properties, dca.lineProps(this.closest('[data-analytics]'), size));
      }

      var self = this;
      this.clearError();
      this.setBusy(btn, true);

      // Beacon fires before the fetch resolves (live parity). The results host
      // turns this into SS.beacon.addtocart with its own per-surface source.
      this.dispatchEvent(
        new CustomEvent('quick-add:atc', {
          bubbles: true,
          detail: { variantId: variantId, productId: this.productId },
        })
      );

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: properties }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          if (response.ok) {
            return response.json().then(function (json) {
              self.onAdded(json, variantId);
            });
          }
          // Shopify's cart error body carries the reason ("… is already sold
          // out", quantity limits); surface it rather than the generic label.
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (body) {
              self.onAddFailed(response.status, body, btn);
            });
        })
        .catch(function () {
          self.showError();
        })
        .finally(function () {
          self.setBusy(btn, false);
        });
    }

    // Settle this card's sizes against the product-availability section, the
    // PDP's rule (#301). Idempotent: memoised per card and per product.
    verifyMarket() {
      if (!this.verify) return Promise.resolve(null);
      if (this.__verified) return this.__verified;
      var self = this;
      this.__verified = marketAvailability(this.dataset.productUrl).then(function (map) {
        if (map) self.applyAvailability(map);
        return map;
      });
      return this.__verified;
    }

    // The section's answer wins in BOTH directions for every size it lists: it
    // already carries the Click & Collect gate (shippable "false") as well as
    // the market, so applying it verbatim makes the card identical to the PDP,
    // including re-enabling a size the feed had stale as sold out. Sizes it does
    // not list keep the feed's flag. Updates the payload the bottom sheet renders
    // from as well as the panel buttons.
    applyAvailability(map) {
      var payload = this.payload();
      var variants = (payload && payload.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        var known = map[String(variants[i].id)];
        if (typeof known === 'boolean') variants[i].available = known;
      }
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-qa-size]'), function (btn) {
        var known = map[String(btn.dataset.variantId)];
        if (typeof known !== 'boolean') return;
        btn.dataset.available = known ? 'true' : 'false';
        if (btn.getAttribute('aria-busy') !== 'true') self.syncSize(btn);
      });
    }

    // Render a size button's sold-out state from `data-available`: native
    // `disabled` plus the visually hidden label the Liquid markup emits, so a
    // size settled client-side reads identically to a server-rendered one.
    syncSize(btn) {
      var available = btn.dataset.available !== 'false';
      btn.disabled = !available;
      var sr = btn.querySelector('.visually-hidden');
      if (!available && !sr) {
        sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = ' - ' + (this.dataset.labelSoldOut || '');
        btn.appendChild(sr);
      } else if (available && sr) {
        sr.remove();
      }
    }

    // A 422 means the cart refused the line (sold out for this market, limits):
    // show Shopify's reason and retire the size so a second click cannot repeat
    // it. Any other failure keeps the size and shows the generic label.
    onAddFailed(status, body, btn) {
      var message = body && (body.description || body.message);
      this.showError(typeof message === 'string' ? message : '');
      if (status !== 422 || !btn) return;
      btn.dataset.available = 'false';
      var payload = this.payload();
      var variants = (payload && payload.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(btn.dataset.variantId)) variants[i].available = false;
      }
    }

    // Clicked button only: the label is replaced by the spinner and kept as the
    // accessible name. Sibling sizes stay active (live runs a fetcher per
    // variant).
    //
    // A11y: the in-flight state is `aria-disabled`, NOT the `disabled` property.
    // Setting `disabled` blurs the button, which strands keyboard focus on
    // <body> -- and because the panel only shows on
    // `.product-quick-add__panel:focus-within`, losing focus fades the whole
    // panel out mid-request, taking the role="alert" error line with it
    // (measured: panel opacity 0 while the error was displayed).
    // handleSizeClick enforces the same inertness, and the CSS renders
    // aria-disabled identically, so nothing changes visually.
    setBusy(btn, on) {
      if (!btn) return;
      if (on) {
        btn.__label = btn.innerHTML;
        btn.setAttribute('aria-label', (btn.textContent || '').trim());
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('aria-disabled', 'true');
        btn.innerHTML = '<span class="product-quick-add__spinner"></span>';
      } else {
        if (btn.__label != null) btn.innerHTML = btn.__label;
        btn.removeAttribute('aria-label');
        btn.setAttribute('aria-busy', 'false');
        btn.removeAttribute('aria-disabled');
        this.syncSize(btn);
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || this.dataset.labelError || '';
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    // Announce the add; the <cart-drawer> controller (sections/cart-drawer.liquid)
    // owns the drawer swap / added-mode / open / auto-close / count sync (#145).
    onAdded(json, variantId) {
      document.dispatchEvent(
        new CustomEvent('cart:added', {
          detail: {
            variantId: variantId,
            quantity: 1,
            sections: (json && json.sections) || null,
          },
        })
      );
    }
  }

  if (!window.customElements.get('dc-quick-add')) {
    window.customElements.define('dc-quick-add', DcQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-shop"] && !Shopify.designMode) return;
  try {
    class DcWishlistQuickShop extends HTMLElement {
    connectedCallback() {
      this.productId = parseInt(this.dataset.productId, 10);
      this.productUrl = this.dataset.productUrl;
      this.comingSoon = this.dataset.comingSoon === 'true';
      this.swapping = false;
      this.busy = false;

      this.label = this.querySelector('[data-size-value]');
      this.select = this.querySelector('[data-size-select]');
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-size-btn]'));
      this.addBtn = this.querySelector('[data-add]');
      this.errorEl = this.querySelector('[data-quick-shop-error]');

      this.selectedVariantId = this.addBtn ? parseInt(this.addBtn.dataset.variantId, 10) : NaN;

      this.onButtonClick = this.handleButtonClick.bind(this);
      this.onSelectChange = this.handleSelectChange.bind(this);
      this.onAdd = this.handleAdd.bind(this);

      this.buttons.forEach((btn) => btn.addEventListener('click', this.onButtonClick));
      if (this.select) this.select.addEventListener('change', this.onSelectChange);
      if (this.addBtn) this.addBtn.addEventListener('click', this.onAdd);
    }

    disconnectedCallback() {
      this.buttons.forEach((btn) => btn.removeEventListener('click', this.onButtonClick));
      if (this.select) this.select.removeEventListener('change', this.onSelectChange);
      if (this.addBtn) this.addBtn.removeEventListener('click', this.onAdd);
    }

    swym() {
      return window._swat || null;
    }

    handleButtonClick(e) {
      const btn = e.currentTarget;
      if (btn.disabled) return;
      this.selectSize(parseInt(btn.dataset.variantId, 10), btn.dataset.size);
    }

    handleSelectChange(e) {
      const opt = e.target.options[e.target.selectedIndex];
      if (!opt || !opt.value) return;
      this.selectSize(parseInt(opt.value, 10), opt.dataset.size);
    }

    // Update the selected variant everywhere (buttons, select, label, ADD TO BAG),
    // then persist the swap to Swym. The commit is optimistic (mirrors
    // wishlist-button's handleClick); swapWishlistVariant reverts it if the
    // Swym round-trip fails.
    selectSize(newVariantId, sizeValue) {
      if (Number.isNaN(newVariantId)) return;
      const previousVariantId = this.selectedVariantId;
      if (newVariantId === previousVariantId) return;

      this.clearError();
      this.selectedVariantId = newVariantId;
      this.updateSelectionUI(newVariantId, sizeValue);

      if (previousVariantId && !Number.isNaN(previousVariantId)) {
        this.swapWishlistVariant(previousVariantId, newVariantId);
      }
    }

    sizeForVariant(variantId) {
      const btn = this.buttons.find((b) => parseInt(b.dataset.variantId, 10) === variantId);
      if (btn) return btn.dataset.size;
      const opt = this.select ? this.select.querySelector('option[value="' + variantId + '"]') : null;
      return opt ? opt.dataset.size : null;
    }

    updateSelectionUI(variantId, sizeValue) {
      this.buttons.forEach((btn) => {
        btn.classList.toggle('is-selected', parseInt(btn.dataset.variantId, 10) === variantId);
      });
      if (this.select && this.select.value !== String(variantId)) this.select.value = String(variantId);
      if (this.label && sizeValue != null) this.label.textContent = sizeValue;
      if (this.addBtn) this.addBtn.dataset.variantId = variantId;
    }

    // Mirror live's isSizeChanging loading state: while the swap round-trip is in
    // flight, EVERY size button (and the mobile select) is disabled so the row
    // fades and no concurrent swap can start; on settle, availability-driven
    // disabled state is restored.
    setSwapping(on) {
      this.swapping = on;
      this.classList.toggle('is-swapping', on);
      this.buttons.forEach((btn) => {
        if (on) {
          btn.disabled = true;
        } else {
          btn.disabled = btn.dataset.available === 'false' || this.comingSoon;
        }
      });
      if (this.select) this.select.disabled = on;
    }

    // Swym swap: remove the old variant then add the new one (absolute du). On success
    // re-point the card's heart + the wishlist tile to the new variant so heart-remove
    // and tile tracking follow the swap. No wishlist:change broadcast (same product).
    // On failure the optimistic selection is reverted; if the add fails after the
    // remove already landed, the old variant is re-added first (best effort) so a
    // transient error can't silently drop the item from the wishlist.
    swapWishlistVariant(previousVariantId, newVariantId) {
      // Live gate (useWishlistSizeSelect): swap only when this product is in
      // the VISITOR's own list. On the shared-wishlist page (#137) the cards
      // show someone else's list, so a size change must not write to the
      // visitor's list. Product-level membership, so repeat swaps on the
      // wishlist page still pass (the coordinator snapshot keeps the product).
      // Skip ONLY once the coordinator has settled AND disowned the product:
      // today's wishlist surfaces render cards after wishlist:ready, but this
      // snippet must not silently drop the Swym sync if a future surface (the
      // planned PLP quick-add) mounts it before the coordinator's async read
      // lands (review P1, 137-code-review.md).
      const items = window.__dcWishlistItems;
      const owned = Array.isArray(items) && items.some((item) => item && item.productId === this.productId);
      if (window.__dcWishlistReady && !owned) return;
      const swat = this.swym();
      if (!swat || this.swapping) return;
      const removeFn = swat.removeFromWishList || swat.deleteFromWishList;
      if (typeof removeFn !== 'function' || typeof swat.addToWishList !== 'function') return;

      const du = this.productUrl ? new URL(this.productUrl, window.location.origin).href : this.productUrl;
      const self = this;
      this.setSwapping(true);

      const succeed = () => {
        self.repointVariant(newVariantId);
        self.setSwapping(false);
      };
      const revert = () => {
        self.selectedVariantId = previousVariantId;
        self.updateSelectionUI(previousVariantId, self.sizeForVariant(previousVariantId));
        self.setSwapping(false);
      };

      try {
        removeFn.call(
          swat,
          { empi: this.productId, epi: previousVariantId, du: du },
          function () {
            swat.addToWishList(
              { empi: self.productId, epi: newVariantId, du: du },
              succeed,
              function () {
                swat.addToWishList({ empi: self.productId, epi: previousVariantId, du: du }, revert, revert);
              }
            );
          },
          revert
        );
      } catch (err) {
        revert();
      }
    }

    repointVariant(variantId) {
      const card = this.closest('.product-card');
      const heart = card ? card.querySelector('dc-wishlist-button') : null;
      if (heart) heart.setAttribute('data-variant-id', variantId);
      const tile = this.closest('[data-variant-id]');
      if (tile) tile.setAttribute('data-variant-id', variantId);
    }

    handleAdd(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.busy || this.comingSoon) return;
      const variantId = this.addBtn ? parseInt(this.addBtn.dataset.variantId, 10) : NaN;
      if (Number.isNaN(variantId)) return;

      const properties = {};
      // Hidden _aux_* line properties from the card's analytics payload via
      // dcAnalytics.lineProps (#268, #336, event map Q7) so checkout items keep
      // their category. Without dcAnalytics the add goes ahead without them.
      const dca = window.dcAnalytics;
      if (dca && dca.lineProps) Object.assign(properties, dca.lineProps(this.closest('[data-analytics]')));

      const self = this;
      this.clearError();
      this.setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: properties }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          if (response.ok) {
            return response.json().then(function (json) {
              self.onAdded(json, variantId);
            });
          }
          // Shopify's cart error body carries the reason ("… is already sold
          // out"); surface it rather than the generic label (#301).
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (body) {
              var message = body && (body.description || body.message);
              self.showError(typeof message === 'string' ? message : '');
            });
        })
        .catch(function () {
          self.showError();
        })
        .finally(function () {
          self.setBusy(false);
        });
    }

    setBusy(on) {
      this.busy = on;
      if (!this.addBtn) return;
      this.addBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      this.addBtn.disabled = on || this.comingSoon;
    }

    // Cart-add failure feedback, mirroring product-form's _onError/_clearError.
    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || this.dataset.labelError || '';
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    // Announce the add; the <cart-drawer> controller (sections/cart-drawer.liquid)
    // owns the drawer swap / added-mode / open / auto-close / count sync (#145).
    onAdded(json, variantId) {
      document.dispatchEvent(
        new CustomEvent('cart:added', {
          detail: {
            variantId: variantId,
            quantity: 1,
            sections: (json && json.sections) || null,
          },
        })
      );
    }
  }

  if (!window.customElements.get('dc-wishlist-quick-shop')) {
    window.customElements.define('dc-wishlist-quick-shop', DcWishlistQuickShop);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    class DcQuickAddModal extends HTMLElement {
    connectedCallback() {
      if (this.__bound) return;
      this.__bound = true;

      this.sheet = this.querySelector('[data-qam-sheet]');
      this.overlayEl = this.querySelector('[data-qam-overlay]');
      this.closeBtn = this.querySelector('[data-qam-close]');
      this.titleEl = this.querySelector('[data-qam-title]');
      this.titleFallback = this.titleEl ? this.titleEl.textContent : '';
      this.sizesBlock = this.querySelector('[data-qam-sizes-block]');
      this.sizesEl = this.querySelector('[data-qam-sizes]');
      this.addBtn = this.querySelector('[data-qam-add]');
      this.addLabel = this.querySelector('[data-qam-add-label]');
      this.detailsLink = this.querySelector('[data-qam-details]');
      this.errorEl = this.querySelector('[data-qam-error]');

      this.data = null;
      this.record = null;
      this.trigger = null;
      this.selected = null;
      this.busy = false;
      this.dragStartY = null;
      this.dragY = 0;

      this.onOpenRequest = this.handleOpenRequest.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onOverlayClick = this.close.bind(this);
      this.onCloseClick = this.close.bind(this);
      this.onSizesClick = this.handleSizesClick.bind(this);
      this.onAddClick = this.handleAddClick.bind(this);
      this.onTouchStart = this.handleTouchStart.bind(this);
      this.onTouchMove = this.handleTouchMove.bind(this);
      this.onTouchEnd = this.handleTouchEnd.bind(this);

      document.addEventListener('quick-add:open', this.onOpenRequest);
      document.addEventListener('keydown', this.onKeydown);
      if (this.overlayEl) this.overlayEl.addEventListener('click', this.onOverlayClick);
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.onCloseClick);
        // Live stops the handle's touchstart so grabbing it never starts a
        // sheet drag as well.
        this.closeBtn.addEventListener('touchstart', function (event) {
          event.stopPropagation();
        });
      }
      if (this.sizesEl) this.sizesEl.addEventListener('click', this.onSizesClick);
      if (this.addBtn) this.addBtn.addEventListener('click', this.onAddClick);
      if (this.sheet) {
        this.sheet.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.sheet.addEventListener('touchmove', this.onTouchMove, { passive: true });
        this.sheet.addEventListener('touchend', this.onTouchEnd);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('quick-add:open', this.onOpenRequest);
      document.removeEventListener('keydown', this.onKeydown);
    }

    get isOpen() {
      return this.hasAttribute('data-open');
    }

    handleOpenRequest(event) {
      var detail = event.detail || {};
      if (!detail.data || !Array.isArray(detail.data.variants) || !detail.data.variants.length) return;
      // Scope routing (#1714): a scoped host answers only triggers inside its
      // own scope; the per-page host ignores triggers inside any scope.
      var trigger = detail.trigger;
      var triggerScope = trigger && trigger.closest ? trigger.closest('[data-quick-add-scope]') : null;
      if (this.hasAttribute('data-scope')) {
        if (!triggerScope || triggerScope !== this.closest('[data-quick-add-scope]')) return;
      } else if (triggerScope) {
        return;
      }
      this.open(detail);
    }

    open(detail) {
      this.data = detail.data;
      this.record = detail.record || null;
      this.trigger = detail.trigger || null;

      this.clearError();
      if (this.titleEl) this.titleEl.textContent = this.data.title || this.titleFallback;
      if (this.detailsLink && this.data.url) this.detailsLink.setAttribute('href', this.data.url);

      var variants = this.data.variants;
      var multi = variants.length > 1;
      if (this.sizesBlock) this.sizesBlock.hidden = !multi;
      if (multi) this.buildSizes(variants);
      else if (this.sizesEl) this.sizesEl.innerHTML = '';

      // Live preselects the first AVAILABLE variant, falling back to the first.
      var preselect = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { preselect = variants[i]; break; }
      }
      if (!preselect) preselect = variants[0];
      this.select(preselect);

      var availability = detail.availability;
      if (availability && typeof availability.then === 'function') {
        var self = this;
        availability.then(function (map) {
          // Ignore a late answer for a payload the sheet has since moved on from.
          if (map && self.isOpen && self.data === detail.data) self.applyAvailability(map);
        });
      }

      // Remember the lock state we found (the cart drawer overlay already
      // holds `hidden` while it is open) so close() hands it back untouched.
      // Captured only on the opening transition: a second open() while the
      // sheet is already up (another card's trigger reached behind it) swaps
      // the content above but must not read back our own `hidden` as the
      // page's baseline, or close() would leave the page scroll-locked
      // (CI review D11).
      if (!this.isOpen) this.previousOverflow = document.body.style.overflow;
      this.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      // Force a style flush so the now-visible sheet can take focus (a still
      // hidden element silently rejects focus()).
      void this.offsetHeight;
      if (this.sheet) this.sheet.focus();
    }

    close() {
      if (!this.isOpen) return;
      this.removeAttribute('data-open');
      document.body.style.overflow = this.previousOverflow || '';
      this.previousOverflow = '';
      this.resetDrag();
      var target = this.trigger;
      this.trigger = null;
      // The trigger may be gone by now: a successful add re-renders the cart
      // drawer's carousel (and its cards) before the sheet closes.
      if (target && typeof target.focus === 'function' && target.isConnected) target.focus();
    }

    // The section's answer wins in both directions for every size it lists
    // (#301): it carries the market and the Click & Collect gate, so the sheet
    // ends up identical to the PDP. Sizes it does not list keep the payload's
    // flag. Always rebuilds the row: the payload object is shared with the card,
    // whose own handler settles first and has usually already written these
    // flags, so a "changed" diff here would see nothing to do while the rendered
    // row is stale. Keeps the selection if it is still buyable, otherwise moves
    // to the first size that is, otherwise leaves it selected with ADD TO BAG
    // disabled.
    applyAvailability(map) {
      var variants = (this.data && this.data.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        var known = map[String(variants[i].id)];
        if (typeof known === 'boolean') variants[i].available = known;
      }
      this.refreshSizes();
    }

    refreshSizes() {
      var variants = (this.data && this.data.variants) || [];
      if (variants.length > 1) this.buildSizes(variants);
      var next = this.selected;
      if (!next || next.available !== true) {
        for (var j = 0; j < variants.length; j++) {
          if (variants[j].available) { next = variants[j]; break; }
        }
      }
      this.select(next || this.selected);
    }

    buildSizes(variants) {
      if (!this.sizesEl) return;
      this.sizesEl.innerHTML = '';
      var oneSize = this.dataset.labelOneSize || '';
      var soldOut = this.dataset.labelSoldOut || '';
      var self = this;
      variants.forEach(function (variant) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add-modal__size';
        btn.setAttribute('data-variant-id', String(variant.id));
        btn.setAttribute('data-available', variant.available ? 'true' : 'false');
        btn.setAttribute('aria-pressed', 'false');
        // Live renders `size || "One Size"`; the same fallback covers products
        // with no Size option on both surfaces.
        btn.textContent = variant.size || oneSize;
        if (!variant.available) {
          btn.disabled = true;
          var sr = document.createElement('span');
          sr.className = 'visually-hidden';
          sr.textContent = ' - ' + soldOut;
          btn.appendChild(sr);
        }
        self.sizesEl.appendChild(btn);
      });
    }

    handleSizesClick(event) {
      var btn = event.target.closest('[data-variant-id]');
      if (!btn || btn.disabled) return;
      var id = parseInt(btn.dataset.variantId, 10);
      var match = null;
      var variants = (this.data && this.data.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        if (parseInt(variants[i].id, 10) === id) { match = variants[i]; break; }
      }
      if (match) this.select(match);
    }

    select(variant) {
      this.selected = variant || null;
      if (this.sizesEl) {
        Array.prototype.forEach.call(this.sizesEl.children, function (btn) {
          var on = variant != null && parseInt(btn.dataset.variantId, 10) === parseInt(variant.id, 10);
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      this.syncAddState();
    }

    // An unavailable selection is genuinely `disabled`. An add in flight is only
    // `aria-disabled`: setting `disabled` blurs the button, which drops focus
    // onto <body> -- outside an aria-modal dialog -- for the length of the
    // request and, on failure, leaves it there next to the role="alert" line.
    // handleAddClick already refuses to fire while this.busy, and the CSS
    // renders aria-disabled identically, so nothing changes visually.
    syncAddState() {
      if (!this.addBtn) return;
      var usable = this.selected != null && this.selected.available === true;
      this.addBtn.disabled = !usable;
      if (this.busy) this.addBtn.setAttribute('aria-disabled', 'true');
      else this.addBtn.removeAttribute('aria-disabled');
    }

    handleAddClick(event) {
      event.preventDefault();
      if (this.busy || !this.selected || this.selected.available !== true) return;
      var variantId = parseInt(this.selected.id, 10);
      if (Number.isNaN(variantId)) return;

      var properties = {};
      // Hidden _aux_* line properties from the opening card's analytics payload
      // via dcAnalytics.lineProps (#268, #336, event map Q7) so checkout items
      // keep their category. Without dcAnalytics the add goes ahead without them.
      var dca = window.dcAnalytics;
      if (dca && dca.lineProps) {
        var card = this.trigger && this.trigger.closest ? this.trigger.closest('[data-analytics]') : null;
        Object.assign(properties, dca.lineProps(card, this.selected && this.selected.size));
      }

      var self = this;
      this.clearError();
      this.setBusy(true);

      // Beacon fires before the fetch resolves (live parity). The results host
      // maps this to SS.beacon.addtocart with its own per-surface source, which
      // is why a collection add reports `category` rather than live's hardcoded
      // `search`.
      this.dispatchEvent(
        new CustomEvent('quick-add:atc', {
          bubbles: true,
          detail: {
            variantId: variantId,
            productId: this.data ? this.data.id : null,
            record: this.record,
          },
        })
      );

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: properties }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          if (response.ok) {
            return response.json().then(function (json) {
              self.onAdded(json, variantId);
            });
          }
          // Shopify's cart error body carries the reason ("… is already sold
          // out", quantity limits); surface it rather than the generic label.
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (body) {
              self.onAddFailed(response.status, body, variantId);
            });
        })
        .catch(function () {
          self.showError();
        })
        .finally(function () {
          self.setBusy(false);
        });
    }

    // A 422 means the cart refused the line for this market: show Shopify's
    // reason and retire the size so the sheet cannot offer it again (#301).
    onAddFailed(status, body, variantId) {
      var message = body && (body.description || body.message);
      this.showError(typeof message === 'string' ? message : '');
      if (status !== 422) return;
      var variants = (this.data && this.data.variants) || [];
      for (var i = 0; i < variants.length; i++) {
        if (parseInt(variants[i].id, 10) === variantId) variants[i].available = false;
      }
      this.refreshSizes();
    }

    setBusy(on) {
      this.busy = on;
      if (!this.addBtn) return;
      this.addBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) {
        this.__addLabelHtml = this.addBtn.innerHTML;
        this.addBtn.setAttribute('aria-label', (this.addBtn.textContent || '').trim());
        this.addBtn.innerHTML = '<span class="quick-add-modal__spinner"></span>';
      } else if (this.__addLabelHtml != null) {
        this.addBtn.innerHTML = this.__addLabelHtml;
        this.addBtn.removeAttribute('aria-label');
        this.addLabel = this.querySelector('[data-qam-add-label]');
      }
      this.syncAddState();
    }

    // Announce the add and dismiss; the <cart-drawer> controller owns the
    // added-mode confirmation, open and 4s auto-close (#145).
    onAdded(json, variantId) {
      document.dispatchEvent(
        new CustomEvent('cart:added', {
          detail: {
            variantId: variantId,
            quantity: 1,
            sections: (json && json.sections) || null,
          },
        })
      );
      this.close();
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || this.dataset.labelError || '';
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    /* ---- touch drag to dismiss (live threshold: 100px) ----------------- */

    handleTouchStart(event) {
      if (!this.isOpen || this.busy) return;
      this.dragStartY = event.touches[0].clientY;
      this.dragY = 0;
    }

    handleTouchMove(event) {
      if (this.dragStartY == null || !this.sheet) return;
      var delta = event.touches[0].clientY - this.dragStartY;
      if (delta <= 0) return;
      this.dragY = delta;
      this.sheet.style.transition = 'none';
      this.sheet.style.transform = 'translateY(' + delta + 'px)';
    }

    handleTouchEnd() {
      if (this.dragStartY == null) return;
      var shouldClose = this.dragY >= 100;
      this.resetDrag();
      if (shouldClose) this.close();
    }

    // Clearing the inline transition first, then the transform, lets the sheet
    // animate back to its CSS resting position (translateY(0) when open,
    // translateY(100%) once data-open is gone) instead of snapping.
    resetDrag() {
      this.dragStartY = null;
      this.dragY = 0;
      if (!this.sheet) return;
      this.sheet.style.transition = '';
      this.sheet.style.transform = '';
    }

    /* ---- keyboard ------------------------------------------------------ */

    handleKeydown(event) {
      if (!this.isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab') {
        this.trapTab(event);
      }
    }

    getFocusable() {
      if (!this.sheet) return [];
      var selector = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.prototype.slice
        .call(this.sheet.querySelectorAll(selector))
        .filter((el) => el.offsetParent !== null && !el.closest('[hidden]'));
    }

    trapTab(event) {
      var focusables = this.getFocusable();
      if (focusables.length === 0) {
        event.preventDefault();
        if (this.sheet) this.sheet.focus();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;
      if (!this.contains(active) || active === this.sheet) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!window.customElements.get('dc-quick-add-modal')) {
    window.customElements.define('dc-quick-add-modal', DcQuickAddModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recaptcha-v3"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.dcRecaptcha) return;

    var TIMEOUT_MS = 5000;
    var POLL_MS = 100;

    function load(key) {
      if (!key || window.grecaptcha || document.querySelector('script[data-dc-recaptcha]')) return;
      var script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(key);
      script.async = true;
      script.defer = true;
      script.setAttribute('data-dc-recaptcha', '');
      document.head.appendChild(script);
    }

    // Resolves to a token, or '' when no key is set, Google has not loaded
    // within the timeout, or execute throws. Never rejects.
    function token(key, action) {
      if (!key) return Promise.resolve('');
      load(key);
      return new Promise(function (resolve) {
        var settled = false;
        var finish = function (value) {
          if (settled) return;
          settled = true;
          resolve(typeof value === 'string' ? value : '');
        };
        var timer = setTimeout(function () {
          finish('');
        }, TIMEOUT_MS);
        var attempt = function () {
          if (settled) return;
          var api = window.grecaptcha;
          if (api && typeof api.ready === 'function' && typeof api.execute === 'function') {
            try {
              api.ready(function () {
                api.execute(key, { action: action }).then(
                  function (value) {
                    clearTimeout(timer);
                    finish(value);
                  },
                  function () {
                    clearTimeout(timer);
                    finish('');
                  }
                );
              });
            } catch (error) {
              clearTimeout(timer);
              finish('');
            }
            return;
          }
          setTimeout(attempt, POLL_MS);
        };
        attempt();
      });
    }

    window.dcRecaptcha = { load: load, token: token };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["searchspring-recommended"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('dc-recommended-rail')) {
    class DcRecommendedRail extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.band = this.closest('[data-ss-rec]');
        this.tablist = this.band ? this.band.querySelector('[role="tablist"]') : null;

        this.profile = this.dataset.profile || '';
        this.limit = parseInt(this.dataset.limit, 10) || 4;
        this.tabbed = this.hasAttribute('data-tabs');
        this.excludeWishlist = this.hasAttribute('data-exclude-wishlist');
        this.seed = this.dataset.seed || '';

        this.panels = {
          recommended: this.querySelector('[data-ss-panel="recommended"]'),
          recent: this.tabbed ? this.querySelector('[data-ss-panel="recent"]') : null,
        };
        /* Per dataset: { records, raw, responseId, tag, settled, impressed }.
           `raw` is the unnormalised recommend result, which the legacy beacon
           payload needs (it reads `result.id` and `result.mappings`, both of
           which normalizeRecommendResult discards). */
        this.sets = {};
        this.legacyByTag = {};
        this.active = 'recommended';
        this.inView = false;

        this.onReady = this.init.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.onTabKeydown = this.onTabKeydown.bind(this);

        /* No Searchspring on this page: the consuming section gates on the same
           test and renders zero bytes, so this is a defensive bail only. */
        if (!window.__searchspring || !this.panels.recommended) return;

        if (this.deferUntilOpen()) return;

        if (window.Searchspring) this.init();
        else document.addEventListener('searchspring:ready', this.onReady, { once: true });
      }

      /* Cart drawer opt-in (`data-defer-until-open`, #1714). Inside a CLOSED
         `<overlay-drawer>` the whole start - and with it the first recommend
         request - waits for that drawer's first `overlay:open`, so a page
         where the drawer is never opened sends no Searchspring traffic and
         the drawer instance never races the cart page instance for the same
         tag. Same pattern as `predictive-search`. Returns false (start now)
         without the attribute, outside a drawer, or when the drawer is
         already open (a section re-render while it is showing). */
      deferUntilOpen() {
        if (!this.hasAttribute('data-defer-until-open')) return false;
        var overlay = this.closest('overlay-drawer');
        if (!overlay || overlay.hasAttribute('data-open')) return false;

        var self = this;
        this.deferOverlay = overlay;
        this.onOverlayOpen = function (event) {
          /* The event bubbles, so a nested overlay's open must not count. */
          if (event.target !== overlay) return;
          overlay.removeEventListener('overlay:open', self.onOverlayOpen);
          self.deferOverlay = null;
          if (window.Searchspring) self.init();
          else document.addEventListener('searchspring:ready', self.onReady, { once: true });
        };
        overlay.addEventListener('overlay:open', this.onOverlayOpen);
        return true;
      }

      disconnectedCallback() {
        if (this.deferOverlay) {
          this.deferOverlay.removeEventListener('overlay:open', this.onOverlayOpen);
          this.deferOverlay = null;
        }
        document.removeEventListener('searchspring:ready', this.onReady);
        if (this.onWishlistItems) document.removeEventListener('wishlist:items', this.onWishlistItems);
        this.removeEventListener('click', this.onClick);
        /* The tab row is a node this element does not own (it sits in the band
           head, outside this subtree), so its listeners must come off here. */
        if (this.tablist) {
          this.tablist.removeEventListener('click', this.onTabClick);
          this.tablist.removeEventListener('keydown', this.onTabKeydown);
        }
        if (this.observer) this.observer.disconnect();
        this.started = false;
        this.bound = false;
      }

      init() {
        if (this.started) return;
        this.started = true;
        this.ss = window.Searchspring;

        /* The swatch library is fetched (functions app proxy + localStorage
           cache, #223), not inlined. The loader memoises its promise, so a
           page carrying both a results grid and a rail shares one fetch.
           paint() awaits it; {} degrades to no swatch row. */
        this.swatchLibrary = null;
        var self = this;
        this.swatchLibraryReady = this.ss.getSwatchLibrary().then(function (lib) {
          self.swatchLibrary = lib;
        });

        this.addEventListener('click', this.onClick);
        if (this.tablist) {
          this.tablist.addEventListener('click', this.onTabClick);
          this.tablist.addEventListener('keydown', this.onTabKeydown);
        }
        this.observeBand();

        /* Wishlist surfaces cannot filter before the wishlist read resolves, so
           they defer the whole fetch rather than fetching and re-filtering. */
        if (this.excludeWishlist) this.whenWishlistReady(this.fetchAll.bind(this));
        else this.fetchAll();
      }

      /* ---------------- data ---------------- */

      /* An EMPTY wishlist read means no fetch at all - live only requests
         recommendations when the list has items, and the section hides the band
         in the empty state anyway. This matters because the wishlist SDK
         publishes an empty list on its 8s degrade timeout, which otherwise sent
         two requests whose results were discarded.

         The listener is deliberately not `once`: a later non-empty publish (the
         coordinator re-resolving) must still be able to start the fetch, and
         `ran` keeps that to a single pass. */
      whenWishlistReady(run) {
        var self = this;
        var ran = false;

        var attempt = function (items) {
          if (ran || !Array.isArray(items) || !items.length) return;
          ran = true;
          document.removeEventListener('wishlist:items', self.onWishlistItems);
          run();
        };

        this.onWishlistItems = function (event) {
          var detail = event && event.detail;
          attempt((detail && detail.items) || window.__dcWishlistItems);
        };

        document.addEventListener('wishlist:items', this.onWishlistItems);
        attempt(window.__dcWishlistItems);
      }

      /* The recommended profile fetches on connect (live parity). The
         recently-viewed profile fetches only when a tab can reveal it - live
         mounts and fetches it even on untabbed instances.

         The two requests are chained rather than fired together: `ssFetch`
         aborts the previous in-flight request per endpoint name, so a second
         synchronous `recommend` call would cancel the first. */
      fetchAll() {
        var self = this;
        this.fetchSet('recommended', function () {
          if (self.tabbed) self.fetchSet('recent');
        });
      }

      fetchSet(key, done) {
        var self = this;
        var tag = key === 'recent' ? this.dataset.recentProfile || 'recently-viewed' : this.profile;
        var finish = function () { if (done) done(); };

        if (!tag) {
          this.receive(key, [], '', tag);
          finish();
          return;
        }

        var opts = {
          tags: tag,
          /* Wishlist surfaces over-fetch 3x and slice back after filtering
             (live behaviour). */
          limits: this.excludeWishlist ? this.limit * 3 : this.limit,
        };
        if (this.seed) opts.products = this.seed;

        this.ss.client
          .recommend(opts)
          .then(function (response) {
            var profile = Array.isArray(response) ? response[0] : response;
            self.receive(key, (profile && profile.results) || [], (profile && profile.responseId) || '', tag);
            finish();
          })
          .catch(function (error) {
            /* A superseded request leaves its panel alone: the newer one owns
               it. Everything else reads as empty - live renders no error UI. */
            if (self.ss.errors && self.ss.errors.isAbort(error)) {
              finish();
              return;
            }
            self.receive(key, [], '', tag);
            finish();
          });
      }

      receive(key, results, responseId, tag) {
        var self = this;
        var pairs = (results || []).map(function (result) {
          return { raw: result, record: self.ss.normalizeRecommendResult(result) };
        });

        if (this.excludeWishlist) {
          var saved = this.wishlistIds();
          pairs = pairs.filter(function (pair) {
            return saved.indexOf(String(pair.record.id)) === -1;
          });
        }

        pairs = pairs.slice(0, this.limit);

        this.sets[key] = {
          records: pairs.map(function (pair) { return pair.record; }),
          raw: pairs.map(function (pair) { return pair.raw; }),
          responseId: responseId,
          tag: tag,
          settled: true,
          impressed: false,
        };

        /* Dots must be on the cards at first paint, so the library AND the
           skuGroup sibling families gate the paint. Both always resolve
           (worst case: metafield-snapshot fallback per card). */
        this.swatchLibraryReady.then(function () {
          return self.ss.resolveSiblingFamilies(pairs.map(function (pair) { return pair.record; }));
        }).then(function (families) {
          self.siblingFamilies = families;
          self.paint(key, pairs);
          self.trackRender(key);
          if (self.inView) self.trackImpressions(key);
          self.updateBand();
        });
      }

      /* The two sides differ in primitive type: wishlist items carry numeric
         product ids, normalised records carry string ids. */
      wishlistIds() {
        var items = Array.isArray(window.__dcWishlistItems) ? window.__dcWishlistItems : [];
        return items.map(function (item) {
          return String((item && item.productId) != null ? item.productId : '');
        });
      }

      /* ---------------- rendering ---------------- */

      paint(key, pairs) {
        var panel = this.panels[key];
        if (!panel) return;
        var track = panel.querySelector('[data-ss-track]');
        var status = panel.querySelector('[data-ss-status]');
        if (!track) return;

        var self = this;
        var site = (this.ss.config && this.ss.config.site) || undefined;
        var frag = document.createDocumentFragment();

        pairs.forEach(function (pair, index) {
          /* `compact: false` plus a library is what turns the sibling swatch
             row on; renderCard appends `className` to the card root, so the
             card IS the slide - no wrapper element. */
          var card = self.ss.renderCard(pair.record, {
            index: index,
            site: site,
            compact: false,
            quickAdd: self.hasAttribute('data-quick-add'),
            swatchLibrary: self.swatchLibrary,
            siblingFamilies: self.siblingFamilies,
            swatchLimit: 2,
            className: 'dc-slider__slide',
          });
          card.__record = pair.record;
          card.__raw = pair.raw;
          card.__ssKey = key;
          frag.appendChild(card);
        });

        /* Clearing the track drops the six skeleton slides with it. */
        track.textContent = '';
        track.appendChild(frag);

        /* Gate the injected cards' mobile bag trigger on a bottom sheet host
           that would SERVE this rail being on the page (see the stylesheet
           note): inside a quick-add scope (the cart drawer, #1714) that is
           the scope's own host; elsewhere it is an unscoped per-page host
           (results pages, the cart page) -- a scoped host never answers a
           rail outside its scope. Re-checked per paint rather than cached at
           init, so a host mounted later still counts. */
        var qaScope = this.closest('[data-quick-add-scope]');
        var qaHost = qaScope
          ? qaScope.querySelector('dc-quick-add-modal')
          : document.querySelector('dc-quick-add-modal:not([data-scope])');
        this.classList.toggle('searchspring-recommended__rail--no-quick-add', !qaHost);

        /* Correct the progress thumb to the RESOLVED product count (the
           scaffold seeded the requested limit). Searchspring routinely returns
           fewer records than `limits` asks for, and the wishlist surface filters
           more out again, so a stale seed would leave the thumb permanently
           narrower than one card. Set before `refresh` below, whose resize event
           is what makes `<dc-scroller>` re-measure. Scoped to the panel's own
           scroller by class: every injected card carries a nested
           `<dc-scroller>` for its gallery, and those keep the primitive's
           default visible-fraction model. */
        var scroller = panel.querySelector('.searchspring-recommended__scroller');
        if (scroller && pairs.length) {
          scroller.setAttribute('data-dc-scroller-items', pairs.length);
        }

        panel.setAttribute('data-state', pairs.length ? 'ready' : 'empty');
        /* The lock tracks the RESOLVED dataset in both directions. Locking on
           an empty resolution is the contract; unlocking on a populated one
           keeps that from being a one-way door, so a dataset that resolves
           late, or a second resolution after a re-fetch, can still light its
           tab back up. */
        this.setTabLocked(key, !pairs.length);
        if (!pairs.length) panel.hidden = true;
        if (status) status.textContent = '';

        /* A panel that just resolved may have left the selection stranded on a
           dataset that can no longer paint (see reselect). */
        this.reselect();
        this.refresh();
      }

      /* Move the selection off a dataset that resolved empty when the other one
         has content. Without this the band survives (updateBand only hides it
         when NOTHING can show) but paints nothing: the empty panel is hidden,
         the populated panel was never selected, and the shopper is left with a
         tab row over a blank band - the exact live defect the zero-state rules
         exist to avoid. Runs after every paint, because the two datasets settle
         in sequence and the second one is what makes a switch possible. */
      reselect() {
        if (!this.tabbed) return;
        var current = this.panels[this.active];
        if (current && current.getAttribute('data-state') !== 'empty') return;

        var self = this;
        var next = this.tabEls().filter(function (tab) {
          var panel = self.panels[tab.getAttribute('data-ss-tab')];
          return !self.isLocked(tab) && panel && panel.getAttribute('data-state') === 'ready';
        })[0];
        if (next) this.selectTab(next.getAttribute('data-ss-tab'), false);
      }

      /* Neither primitive observes DOM mutations, and both listen on window
         resize: this is the no-new-API way to re-run the arrow gate, the bar
         visibility and the thumb width after injection (and after a tab swap,
         where the newly shown track measured zero while hidden). */
      refresh() {
        window.dispatchEvent(new Event('resize'));
      }

      /* Hide the whole band - rules included - when nothing can ever show. */
      updateBand() {
        if (!this.band) return;
        var recommended = this.sets.recommended;
        var recent = this.sets.recent;
        if (!recommended || !recommended.settled) return;
        if (recommended.records.length) return;
        if (this.tabbed) {
          if (!recent || !recent.settled) return;
          if (recent.records.length) return;
        }
        this.band.hidden = true;
      }

      /* ---------------- tabs ---------------- */

      tabEls() {
        if (!this.tablist) return [];
        return Array.prototype.slice.call(this.tablist.querySelectorAll('[data-ss-tab]'));
      }

      tabFor(key) {
        if (!this.tablist) return null;
        return this.tablist.querySelector('[data-ss-tab="' + key + '"]');
      }

      /* Lock the tab of a dataset that resolved empty. It stays in the tab row
         (the layout must not change) but stops being an activation target, so
         switching into an empty panel - which would blank the band - is
         impossible. `aria-disabled` rather than `disabled`: the tab stays
         focusable and discoverable, and is announced as unavailable. The lock
         is only ever applied to a RESOLVED dataset (paint runs on the fetch's
         settled result), never to one still loading, and it lifts again when a
         later resolution brings records. */
      setTabLocked(key, locked) {
        var tab = this.tabFor(key);
        if (!tab) return;
        if (locked) tab.setAttribute('aria-disabled', 'true');
        else tab.removeAttribute('aria-disabled');
      }

      isLocked(tab) {
        return !!tab && tab.getAttribute('aria-disabled') === 'true';
      }

      onTabClick(event) {
        var tab = event.target.closest('[data-ss-tab]');
        if (!tab || this.isLocked(tab)) return;
        this.selectTab(tab.getAttribute('data-ss-tab'), false);
      }

      /* Automatic activation (the two-tab, no-lazy-content case). Locked tabs
         are skipped by the arrows and are not valid Home / End destinations. */
      onTabKeydown(event) {
        var key = event.key;
        if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
        var tabs = this.tabEls();
        if (tabs.length < 2) return;

        var self = this;
        var open = tabs.filter(function (tab) { return !self.isLocked(tab); });
        if (!open.length) return;

        var at = open.indexOf(event.target.closest('[data-ss-tab]'));
        var next = 0;
        if (key === 'Home') next = 0;
        else if (key === 'End') next = open.length - 1;
        else if (at === -1) next = 0;
        else if (key === 'ArrowRight') next = (at + 1) % open.length;
        else next = (at - 1 + open.length) % open.length;

        event.preventDefault();
        this.selectTab(open[next].getAttribute('data-ss-tab'), true);
      }

      /* Client-side only: switching never refetches. */
      selectTab(key, focusTab) {
        /* Defence in depth: no path may activate a locked tab. */
        if (this.isLocked(this.tabFor(key))) return;
        this.active = key;
        this.tabEls().forEach(function (tab) {
          var selected = tab.getAttribute('data-ss-tab') === key;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focusTab) tab.focus();
        });

        var self = this;
        Object.keys(this.panels).forEach(function (name) {
          var panel = self.panels[name];
          if (!panel) return;
          /* An empty dataset keeps its panel hidden even if its tab somehow
             became the selection; its tab is locked, so the other one stays
             the only reachable target. */
          panel.hidden = name !== key || panel.getAttribute('data-state') === 'empty';
        });

        this.refresh();
      }

      /* ---------------- tracking ---------------- */

      legacyFor(tag) {
        if (!tag || typeof this.ss.legacyBeacon !== 'function') return null;
        if (!this.legacyByTag[tag]) this.legacyByTag[tag] = this.ss.legacyBeacon(tag);
        return this.legacyByTag[tag];
      }

      trackRender(key) {
        var set = this.sets[key];
        if (!set || !set.records.length || !this.ss.canTrack()) return;
        var legacy = this.legacyFor(set.tag);
        if (legacy) legacy.render(set.raw);
        this.ss.beacon.render({
          source: 'recommendations',
          responseId: set.responseId,
          tag: set.tag,
        });
      }

      /* One observer on the band, threshold 0, once per dataset. */
      observeBand() {
        if (!this.band || typeof IntersectionObserver !== 'function') return;
        var self = this;
        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              self.observer.unobserve(entry.target);
              self.inView = true;
              Object.keys(self.sets).forEach(function (key) {
                self.trackImpressions(key);
              });
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.band);
      }

      trackImpressions(key) {
        var set = this.sets[key];
        if (!set || set.impressed || !set.records.length) return;
        set.impressed = true;
        if (!this.ss.canTrack()) return;

        var legacy = this.legacyFor(set.tag);
        if (legacy) legacy.impression(set.raw);
        /* Beacon 2.0 per-card impressions ride the module's 300ms queue. */
        var self = this;
        set.records.forEach(function (record) {
          self.ss.beacon.impression({
            source: 'recommendations',
            record: record,
            responseId: set.responseId,
            tag: set.tag,
          });
        });
      }

      /* Delegated: navigation is never prevented, and no IntelliSuggest fires
         from a rail card (live parity). Gated on a link the way the results
         controller is, so the heart and quick-add buttons inside the media box
         never register as a clickthrough. */
      onClick(event) {
        if (!this.ss || !this.ss.canTrack()) return;
        var link = event.target.closest('a');
        if (!link) return;
        var card = link.closest('.product-card');
        if (!card || !card.__record) return;
        var set = this.sets[card.__ssKey];
        if (!set) return;

        var legacy = this.legacyFor(set.tag);
        if (legacy) legacy.click(card.__raw);
        this.ss.beacon.clickthrough({
          source: 'recommendations',
          record: card.__record,
          responseId: set.responseId,
          tag: set.tag,
        });
      }
    }

    window.customElements.define('dc-recommended-rail', DcRecommendedRail);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["searchspring-results"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('searchspring-results')) {
    
    var escapeText = function (value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    class SearchspringResults extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;

        this.mode = this.dataset.mode === 'search' ? 'search' : 'category';
        /* Beacon source is per-instance, not a module constant: the same
           controller serves the collection ('category') and search pages. */
        this.source = this.mode;
        this.handle = this.dataset.handle || '';
        this.perPage = parseInt(this.dataset.perPage, 10) || 48;
        this.collectionTitle = this.dataset.title || '';
        this.grid = this.querySelector('[data-ss-grid]');
        this.paginationEl = this.querySelector('[data-ss-pagination]');
        this.skeletonTpl = this.querySelector('template[data-ss-skeleton]');

        if (!window.__searchspring || !this.grid) return;

        var start = this.init.bind(this);
        if (window.Searchspring) start();
        else document.addEventListener('searchspring:ready', start, { once: true });
      }

      init() {
        if (this.__started) return;
        this.__started = true;

        this.SS = window.Searchspring;
        this.strings = (window.__searchspring && window.__searchspring.strings) || {};
        this.icons = (window.__searchspring && window.__searchspring.icons) || {};
        this.facetList = this.querySelector('[data-facet-list]');
        this.sortList = this.querySelector('[data-sort-list]');
        this.seeResultsBtn = this.querySelector('[data-see-results]');
        /* Search mode only: the zero-results block and the count line are
           server-rendered by the section (merchant-editable copy), so the
           controller reveals and writes them rather than templating them. */
        this.resultCountEl = document.querySelector('[data-ss-result-count]');
        var fieldWrap = document.querySelector('[data-ss-search-field]');
        this.searchInput = fieldWrap ? fieldWrap.querySelector('input[type="search"]') : null;
        this.response = null;
        this.responseId = null;
        this.openFacets = null;

        /* The swatch library is fetched (functions app proxy + localStorage
           cache, #223), not inlined - kicked off here so it resolves in
           parallel with the first results request; render() awaits it. The
           loader always resolves (worst case {} = no dots). */
        this.swatchLibrary = null;
        var self = this;
        this.swatchLibraryReady = this.SS.getSwatchLibrary().then(function (lib) {
          self.swatchLibrary = lib;
        });

        this.readUrl();
        this.observer = new IntersectionObserver(this.onIntersect.bind(this));
        this.bindEvents();
        /* The skeleton cells are server-rendered so the grid reserves its height
           from the first paint; only clone them if that markup is absent. */
        if (!this.grid.firstElementChild) this.renderSkeletons();
        this.fetchResults();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.__typeTimer);
        if (this.searchInput && this.__onType) this.searchInput.removeEventListener('input', this.__onType);
        if (this.searchForm && this.__onSubmit) this.searchForm.removeEventListener('submit', this.__onSubmit);
        this.__started = false;
        this.__bound = false;
      }

      /* ---- URL contract: ?filters=field:value,...&sort=field:dir&page=N ---- */

      readUrl() {
        var params = new URLSearchParams(window.location.search);
        var filters = params.get('filters');
        this.filters = filters ? filters.split(',').filter(Boolean) : [];
        this.sort = params.get('sort') || '';
        var page = parseInt(params.get('page'), 10);
        this.page = page > 1 ? page : 1;

        if (this.mode !== 'search') return;
        /* `q` is the contract (Shopify's own search param, so the native
           fallback grid populates). The headless site used `query`, so inbound
           and indexed links still carry it -- adopt it, then normalise the
           address bar to `q` without a reload. */
        this.query = params.get('q') || '';
        if (!this.query && params.get('query')) {
          this.query = params.get('query');
          /* Shopify's `search` object only reads `q`, so the server rendered the
             field empty for a legacy `?query=` link -- back-fill it, or the
             shopper sees results for a term the box does not show. */
          if (this.searchInput && !this.searchInput.value) this.searchInput.value = this.query;
          this.syncUrl();
        }
      }

      buildParams(page) {
        var params = new URLSearchParams(window.location.search);
        if (this.mode === 'search') {
          params.delete('query');
          if (this.query) params.set('q', this.query);
          else params.delete('q');
        }
        if (this.filters.length) params.set('filters', this.filters.join(','));
        else params.delete('filters');
        if (this.sort) params.set('sort', this.sort);
        else params.delete('sort');
        var target = page != null ? page : this.page;
        if (target > 1) params.set('page', String(target));
        else params.delete('page');
        return params;
      }

      pageHref(page) {
        var query = this.buildParams(page).toString();
        return query ? '?' + query : window.location.pathname;
      }

      syncUrl() {
        var query = this.buildParams().toString();
        history.replaceState(null, '', query ? '?' + query : window.location.pathname);
      }

      /* ---- data ---- */

      fetchResults(options) {
        var self = this;
        /* Render-supersede guard (#223): render() used to be called
           synchronously inside request.then, so ssFetch's abort-on-supersede
           alone guaranteed a stale response never painted. The sibling-family
           gate below adds an un-cancellable async gap after the request
           resolves (family fetches deliberately never abort each other), so a
           slower older continuation could otherwise overwrite a newer render.
           Each fetch stamps a sequence; the continuation discards itself if a
           newer fetch has started. */
        var seq = (this.__renderSeq || 0) + 1;
        this.__renderSeq = seq;
        var common = {
          page: this.page,
          resultsPerPage: this.perPage,
          sort: this.sort || undefined,
          filters: this.filters,
        };
        var request;
        if (this.mode === 'search') {
          common.q = this.query || '';
          /* A debounced keystroke is not a search the shopper committed to:
             recording it would fill the overlay's 5-slot Recent searches with
             partial words (the live site's behaviour -- deliberately fixed). */
          common.recordRecent = !(options && options.transient);
          request = this.SS.client.search(common);
        } else {
          common.handle = this.handle;
          request = this.SS.client.category(common);
        }
        request.then(function (response) {
          /* Dots must be on the cards at first paint (no repaint pass), so the
             library AND the skuGroup sibling families gate the render. The
             family lookup needs this response's records, so it fires here;
             warm caches resolve synchronously-fast, and both resolvers always
             resolve (worst case: metafield-snapshot fallback per card). */
          self.swatchLibraryReady.then(function () {
            return self.SS.resolveSiblingFamilies(self.SS.normalizeRecords(response.results || []));
          }).then(function (families) {
            if (seq !== self.__renderSeq) return; /* superseded by a newer fetch */
            self.siblingFamilies = families;
            self.render(response);
          });
        }).catch(function (error) {
          if (self.SS.errors.isAbort(error)) return;
          /* Keep the previous grid on error -- live renders no error UI. */
          if (window.console && console.warn) console.warn('[searchspring-results] request failed', error);
        });
      }

      refine(change) {
        if (change.filters) {
          this.filters = change.filters;
          this.page = 1;
        }
        if (change.sort != null) this.sort = change.sort; /* page kept: live parity */
        if (change.page) this.page = change.page;
        if (change.query != null) {
          this.query = change.query;
          this.page = 1;
        }
        /* Typed refinement never rewrites the address bar: live keeps the
           committed term there, so a shared URL still reflects the search the
           shopper actually ran. */
        if (!change.transient) this.syncUrl();
        this.fetchResults({ transient: !!change.transient });
        if (change.page) window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      /* ---- rendering ---- */

      /* Merchandising redirects are configured in Searchspring against the
         production storefront, so they come back as absolute URLs on the live
         domain (`https://www.decjuba.com.au/...`). Following one verbatim throws
         a shopper on staging, a preview theme or the dev server straight onto
         production mid-session (#314: a search for "gift card" did exactly
         this). Keep the path and ride the current origin -- identical in effect
         on production, correct everywhere else.

         Any redirect whose host is one of the brand's storefront hosts is
         treated as this storefront, whatever the path: the previous rule only
         rewrote Shopify-shaped paths (/collections, /products, ...) and let a
         headless-only path such as `/e-gift-cards` through verbatim, which is
         the #314 leak. Paths the theme does not serve are the store's URL
         redirect table's job (`/e-gift-cards` -> `/pages/gift-cards`), not this
         component's -- a missing redirect surfaces as an honest 404 on the
         current origin, never as a silent jump to another environment.
         A genuinely external redirect (help centre, a partner site) is still
         honoured verbatim. */
      redirectTarget(raw) {
        if (!raw) return null;
        if (raw.charAt(0) === '/') return raw;
        var url;
        try { url = new URL(raw, window.location.origin); } catch (e) { return raw; }
        if (url.origin === window.location.origin) return url.pathname + url.search + url.hash;
        if (this.isStorefrontHost(url.hostname)) return url.pathname + url.search + url.hash;
        return raw;
      }

      /* The brand's storefront hosts across environments: the headless
         production sites (www.decjuba.com.au / .co.nz / .com), the Shopify
         primary domains that front the theme (checkout.decjuba.com.au,
         checkout.staging.decjuba.com.au, and the bare/www forms the launch
         moves to), and any *.myshopify.com store domain. Brand hosts that are
         NOT storefronts (decjuba.gorgias.help, decjuba.sanity.studio) do not
         match and keep their absolute redirect. */
      isStorefrontHost(hostname) {
        var host = String(hostname || '').toLowerCase();
        if (/(^|\.)myshopify\.com$/.test(host)) return true;
        return /^(www\.|checkout\.|checkout\.staging\.)?decjuba\.(com|com\.au|co\.nz)$/.test(host);
      }

      render(response) {
        var merch = response && response.merchandising;
        if (merch && merch.redirect) {
          var target = this.redirectTarget(merch.redirect);
          if (target) {
            window.location.href = target;
            return;
          }
        }

        this.response = response;
        this.responseId = response.responseId || null;

        var records = this.SS.normalizeRecords(response.results || []);
        var items = records.slice();
        var pagination = response.pagination || {};
        var begin = pagination.begin || 0;
        var end = pagination.end != null ? pagination.end : begin + items.length;
        var inline = (merch && merch.content && merch.content.inline) || [];

        inline.forEach(function (banner) {
          var pos = banner && banner.config && banner.config.position;
          if (!pos || pos.index == null) return;
          if (pos.index >= begin && pos.index < end) {
            /* Page-relative splice, one slot after the SS index (live parity,
               including the +1). */
            items.splice(pos.index - begin + 1, 0, { __banner: banner.value });
          }
        });

        this.observer.disconnect();
        this.grid.innerHTML = '';

        if (!records.length) {
          /* Category mode renders its empty copy into the grid; search mode
             reveals the section's server-rendered, merchant-editable block. */
          if (this.mode !== 'search') this.grid.appendChild(this.emptyEl());
        } else {
          var frag = document.createDocumentFragment();
          var self = this;
          items.forEach(function (item, index) {
            if (item && item.__banner != null) {
              frag.appendChild(self.bannerCell(item.__banner));
              return;
            }
            var card = self.SS.renderCard(item, {
              index: index,
              compact: false,
              swatchLibrary: self.swatchLibrary,
              siblingFamilies: self.siblingFamilies,
            });
            card.__record = item;
            frag.appendChild(card);
            self.observer.observe(card);
          });
          this.grid.appendChild(frag);
        }

        /* Search mode, zero results (#259): live keeps the controls bar mounted at
           full height with nothing in it (its Filter and Sort render nothing when
           the response carries no facets), so the divider stays and the empty
           band is the bar plus the wrapper's bottom pad. The buttons stay when a
           shopper has filtered down to zero, so Filter can undo it. */
        this.classList.toggle('is-empty', this.mode === 'search' && !records.length && !this.filters.length);

        this.renderFacets();
        this.renderSort();
        this.renderPagination();
        this.updateSeeResults();
        this.updateResultCount();
        this.announceResults();
        /* Data layer hook (#270, assets/dc-analytics.js): one event per render
           carrying the state that produced it; the module keys `search` on the
           query, so facet / sort / page renders under the same term are free. */
        document.dispatchEvent(new CustomEvent('searchspring:results', {
          detail: {
            mode: this.mode,
            query: this.query || '',
            total: Number(pagination.totalResults) || 0,
            page: this.page,
            filters: this.filters.slice(),
            sort: this.sort || '',
          },
        }));
        /* Cards just replaced the grid, so their Yotpo star widgets are past the
           loader's initial scan -- rescan explicitly (#124). Single owner: no other
           component may call this. */
        this.SS.hydrateYotpo();
        this.SS.beacon.render({ source: this.source, responseId: this.responseId });
      }

      renderSkeletons() {
        if (!this.skeletonTpl) return;
        this.grid.innerHTML = '';
        for (var i = 0; i < this.perPage; i++) {
          this.grid.appendChild(this.skeletonTpl.content.cloneNode(true));
        }
      }

      bannerCell(html) {
        var cell = document.createElement('figure');
        cell.className = 'collection-main__banner-cell';
        cell.innerHTML = html;
        return cell;
      }

      emptyEl() {
        var el = document.createElement('div');
        el.className = 'collection-main__empty';
        el.innerHTML = (this.strings.emptyHtml || '').replace('__TITLE__', escapeText(this.collectionTitle));
        return el;
      }

      updateResultCount() {
        if (!this.resultCountEl || !this.strings.resultsCount) return;
        var total = ((this.response && this.response.pagination) || {}).totalResults || 0;
        this.resultCountEl.textContent = this.strings.resultsCount.replace('__COUNT__', String(total));
        /* The section seeds the line with Shopify's native total (capped at
           1,000) and pre-paint hides it while Searchspring drives the page --
           the first real total is now in place, so reveal it. */
        this.resultCountEl.removeAttribute('data-ss-pending');
      }

      iconHtml(name, cls) {
        var svg = this.icons[name] || '';
        if (!svg) return '';
        return '<span class="svg-icon' + (cls ? ' ' + cls : '') + '" style="--icon-size: 24px;" aria-hidden="true">' + svg + '</span>';
      }

      renderFacets() {
        if (!this.facetList || !this.response) return;
        var self = this;
        var facets = (this.response.facets || []).filter(function (facet) {
          return facet && facet.values && facet.values.length > 1;
        });

        /* First response: panels holding an active filter start open (live).
           After that the shopper's own toggles win -- deliberate divergence
           from live's collapse-on-every-change quirk (scope Resolved Decision). */
        if (!this.openFacets) {
          this.openFacets = {};
          this.filters.forEach(function (token) {
            self.openFacets[String(token).split(':')[0]] = true;
          });
        }

        this.facetList.innerHTML = facets.map(function (facet) {
          var field = String(facet.field || '');
          var rows = Math.ceil(facet.values.length / 2);
          var values = facet.values.map(function (value) {
            var token = field + ':' + value.value;
            var checked = self.filters.indexOf(token) !== -1;
            return '<label class="collection-facet__value">' +
              '<input class="collection-facet__input" type="checkbox" data-facet-value="' + escapeText(token) + '"' + (checked ? ' checked' : '') + '>' +
              '<span class="collection-facet__box" aria-hidden="true"></span>' +
              '<span class="collection-facet__label">' + escapeText(value.label != null ? value.label : value.value) + '</span>' +
              '</label>';
          }).join('');

          return '<details class="collection-facet" data-facet-field="' + escapeText(field) + '"' + (self.openFacets[field] ? ' open' : '') + '>' +
            '<summary class="collection-facet__summary">' +
            '<span class="collection-facet__title">' + escapeText(facet.label || field) + '</span>' +
            self.iconHtml('add', 'collection-facet__icon collection-facet__icon--add') +
            self.iconHtml('remove', 'collection-facet__icon collection-facet__icon--remove') +
            '</summary>' +
            '<div class="collection-facet__content">' +
            '<div class="collection-facet__grid" style="grid-template-rows: repeat(' + rows + ', 1fr);">' + values + '</div>' +
            '</div>' +
            '</details>';
        }).join('');
      }

      renderSort() {
        if (!this.sortList || !this.response) return;
        var options = (((this.response.sorting || {}).options) || []).map(function (option) {
          return { label: option.label, value: option.field + ':' + option.direction };
        });
        var active = this.sort || (options[0] && options[0].value) || '';
        this.sortList.innerHTML = options.map(function (option) {
          return '<label class="collection-sort__option">' +
            '<input class="collection-sort__input" type="radio" name="collection-sort" data-sort-value="' + escapeText(option.value) + '"' + (option.value === active ? ' checked' : '') + '>' +
            '<span class="collection-sort__radio" aria-hidden="true"></span>' +
            '<span class="collection-sort__label">' + escapeText(option.label) + '</span>' +
            '</label>';
        }).join('');
      }

      /* Live windowing: first/last always shown, up to two ellipses. */
      pageList(total, current) {
        var range = function (from, to) {
          var out = [];
          for (var i = from; i <= to; i++) out.push(i);
          return out;
        };
        if (total <= 5) return range(1, total);
        if (current <= 3) return [1, 2, 3, 4, 'gap', total];
        if (current >= total - 2) return [1, 'gap', total - 3, total - 2, total - 1, total];
        return [1, 'gap', current - 1, current, current + 1, 'gap', total];
      }

      renderPagination() {
        if (!this.paginationEl || !this.response) return;
        var total = (this.response.pagination || {}).totalPages || 0;
        if (total <= 1) {
          this.paginationEl.innerHTML = '';
          return;
        }

        var self = this;
        var s = this.strings;
        var current = this.page;

        var navItem = function (page, enabled, chevron, label, ariaLabel, chevronFirst) {
          var inner = (chevronFirst ? self.iconHtml(chevron) : '') +
            '<span class="collection-pagination__nav-label">' + escapeText(label) + '</span>' +
            (chevronFirst ? '' : self.iconHtml(chevron));
          if (!enabled) {
            return '<span class="collection-pagination__nav" aria-disabled="true">' + inner + '</span>';
          }
          return '<a class="collection-pagination__nav" href="' + escapeText(self.pageHref(page)) + '" data-page="' + page + '" aria-label="' + escapeText(ariaLabel) + '">' + inner + '</a>';
        };

        var pages = this.pageList(total, current).map(function (page) {
          if (page === 'gap') {
            return '<li><span class="collection-pagination__ellipsis" aria-hidden="true">&#8230;</span>' +
              '<span class="visually-hidden">' + escapeText(s.morePages || '') + '</span></li>';
          }
          if (page === current) {
            return '<li><span class="collection-pagination__page collection-pagination__page--active" aria-current="page">' + page + '</span></li>';
          }
          return '<li><a class="collection-pagination__page" href="' + escapeText(self.pageHref(page)) + '" data-page="' + page + '"' +
            ' aria-label="' + escapeText((s.goToPage || '').replace('__PAGE__', String(page))) + '">' + page + '</a></li>';
        }).join('');

        this.paginationEl.innerHTML = '<ul class="collection-pagination__list">' +
          '<li>' + navItem(current - 1, current > 1, 'chevron-left', s.previous || '', s.goToPreviousPage || '', true) + '</li>' +
          pages +
          '<li>' + navItem(current + 1, current < total, 'chevron-right', s.next || '', s.goToNextPage || '', false) + '</li>' +
          '</ul>';
      }

      updateSeeResults() {
        if (!this.seeResultsBtn || !this.response) return;
        var total = (this.response.pagination || {}).totalResults || 0;
        this.seeResultsBtn.textContent = total > 0 && this.strings.seeResults
          ? this.strings.seeResults.replace('__COUNT__', String(total))
          : (this.strings.apply || '');
      }

      /* A11y (WCAG 4.1.3): announce the new result count / page after a
         refinement. Skipped for the first response so the region does not speak
         over the page title on load. */
      announceResults() {
        var region = this.querySelector('[data-results-announce]');
        if (!region) return;
        if (!this.hasAnnouncedOnce) {
          this.hasAnnouncedOnce = true;
          return;
        }
        var pagination = (this.response && this.response.pagination) || {};
        var total = pagination.totalResults || 0;
        var pages = pagination.totalPages || 1;
        var page = pagination.currentPage || 1;
        var text;
        if (total === 0) {
          text = (this.strings.resultsNone || '');
        } else if (pages > 1) {
          text = (this.strings.resultsPaged || '')
            .replace('__COUNT__', String(total))
            .replace('__PAGE__', String(page))
            .replace('__PAGES__', String(pages));
        } else {
          text = (this.strings.results || '').replace('__COUNT__', String(total));
        }
        /* Re-assigning identical text is not re-announced; clear first. */
        region.textContent = '';
        region.textContent = text;
      }

      /* ---- data layer hooks (#270, assets/dc-analytics.js) ---- */

      /* Resolve a `field:value` token to the labels the shopper saw, via the
         last response's facets (a toggle fires before the next response). */
      describeToken(token) {
        var parts = String(token || '').split(':');
        var field = parts.shift() || '';
        var raw = parts.join(':');
        var out = { key: field, label: field, value: raw };
        var facets = (this.response && this.response.facets) || [];
        for (var i = 0; i < facets.length; i++) {
          var facet = facets[i];
          if (!facet || String(facet.field || '') !== field) continue;
          out.label = facet.label || field;
          var values = facet.values || [];
          for (var j = 0; j < values.length; j++) {
            if (values[j] && String(values[j].value) === raw) {
              if (values[j].label != null) out.value = String(values[j].label);
              break;
            }
          }
          break;
        }
        return out;
      }

      /* `action` is add / remove (token toggled) or clear (Clear all, no
         token). Called after refine() so `this.filters` is the new active set. */
      emitFilter(action, token) {
        var self = this;
        var toggled = token ? this.describeToken(token) : { key: '', label: '', value: '' };
        document.dispatchEvent(new CustomEvent('searchspring:filter', {
          detail: {
            action: action,
            key: toggled.key,
            type: toggled.label,
            value: toggled.value,
            filters: this.filters.map(function (active) { return self.describeToken(active); }),
          },
        }));
      }

      emitSort(input) {
        var option = input.closest('.collection-sort__option');
        var label = option && option.querySelector('.collection-sort__label');
        document.dispatchEvent(new CustomEvent('searchspring:sort', {
          detail: {
            label: label ? label.textContent.trim() : '',
            value: input.getAttribute('data-sort-value') || '',
          },
        }));
      }

      /* ---- events (delegated on the section root; survive re-renders) ---- */

      bindEvents() {
        var self = this;

        this.addEventListener('change', function (event) {
          var facetInput = event.target.closest('[data-facet-value]');
          if (facetInput) {
            var token = facetInput.getAttribute('data-facet-value');
            var next = self.filters.slice();
            var at = next.indexOf(token);
            if (at === -1) next.push(token);
            else next.splice(at, 1);
            self.refine({ filters: next });
            self.emitFilter(at === -1 ? 'add' : 'remove', token);
            return;
          }
          var sortInput = event.target.closest('[data-sort-value]');
          if (sortInput) {
            self.refine({ sort: sortInput.getAttribute('data-sort-value') });
            self.emitSort(sortInput);
          }
        });

        this.addEventListener('click', function (event) {
          var pageLink = event.target.closest('a[data-page]');
          if (pageLink) {
            event.preventDefault();
            self.refine({ page: parseInt(pageLink.getAttribute('data-page'), 10) || 1 });
            return;
          }
          if (event.target.closest('[data-clear-all]')) {
            /* Instant clear; the drawer stays open (live parity). */
            self.refine({ filters: [] });
            self.emitFilter('clear', null);
            return;
          }
          if (event.target.closest('[data-see-results]')) {
            self.closeDrawer(self.mode + '-filter-drawer');
            return;
          }
          if (event.target.closest('[data-apply-sort]')) {
            self.closeDrawer(self.mode + '-sort-drawer');
            return;
          }

          var link = event.target.closest('a');
          if (link) {
            var card = link.closest('.product-card');
            if (card && card.__record) {
              self.SS.beacon.clickthrough({ source: self.source, record: card.__record, responseId: self.responseId });
              self.SS.intellisuggest.trackClick(link, card.__record);
            }
          }
        });

        if (this.mode === 'search') this.bindSearchField();

        /* Quick-add ATC beacon (#225). Both the desktop hover panel and the
           bottom sheet bubble `quick-add:atc` up to this host, which is the only
           thing that knows the per-surface source ('category' on the PLP,
           'search' on search results) and the current responseId. Live hardcodes
           source: "search" inside its mobile modal, which mis-attributes every
           collection add; resolving it here fixes that.

           The record comes from the card the panel sits in (same lookup as the
           clickthrough handler above) or, for sheet-originated adds, from the
           detail the trigger handed over. Native-grid cards carry no __record,
           so they fire no beacon -- correct, since there is no Searchspring
           session or responseId behind them. */
        this.addEventListener('quick-add:atc', function (event) {
          var detail = event.detail || {};
          var record = detail.record || null;
          if (!record) {
            var card = event.target.closest ? event.target.closest('.product-card') : null;
            record = (card && card.__record) || null;
          }
          if (!record || !self.responseId) return;
          self.SS.beacon.addtocart({ source: self.source, record: record, responseId: self.responseId });
        });

        /* toggle does not bubble: capture keeps one listener for all panels. */
        this.addEventListener('toggle', function (event) {
          var details = event.target;
          if (!details || !details.hasAttribute || !details.hasAttribute('data-facet-field')) return;
          if (!self.openFacets) self.openFacets = {};
          self.openFacets[details.getAttribute('data-facet-field')] = details.open;
        }, true);
      }

      /* The search page's field re-queries as you type (live parity: 300ms
         after the last keystroke, from 3 characters up) WITHOUT navigating.
         The form itself is never intercepted -- it is a real GET to
         routes.search_url, which is what makes the page work with JS off and
         on the NZ market, so submit only fires the beacon and lets the browser
         navigate (beacon posts are keepalive, so they survive it). */
      bindSearchField() {
        var self = this;
        if (!this.searchInput) return;

        /* The field lives in the section band, outside this element's subtree,
           so the handlers are kept on `this` and removed on disconnect -- a
           node the element does not own must never keep a listener alive. */
        this.__onType = function () {
          var term = self.searchInput.value.trim();
          clearTimeout(self.__typeTimer);
          if (term.length < 3) return; /* below 3 chars: leave the last response up */
          self.__typeTimer = setTimeout(function () {
            if (term === self.query) return;
            self.refine({ query: term, transient: true });
          }, 300);
        };
        this.searchInput.addEventListener('input', this.__onType);

        this.searchForm = this.searchInput.form;
        if (!this.searchForm) return;
        this.__onSubmit = function () {
          clearTimeout(self.__typeTimer);
          if (!self.SS || !self.SS.canTrack()) return;
          var term = self.searchInput.value.trim();
          if (!term) return;
          var url = self.searchForm.getAttribute('action') + '?q=' + encodeURIComponent(term);
          self.SS.beacon.redirect({
            source: self.source,
            redirect: url.indexOf('http') === 0 ? url : window.location.origin + url,
            responseId: self.responseId,
          });
        };
        this.searchForm.addEventListener('submit', this.__onSubmit);
      }

      closeDrawer(id) {
        var drawer = document.getElementById(id);
        if (drawer && typeof drawer.close === 'function') drawer.close();
      }

      onIntersect(entries) {
        var self = this;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.observer.unobserve(entry.target);
          if (entry.target.__record) {
            self.SS.beacon.impression({ source: self.source, record: entry.target.__record, responseId: self.responseId });
          }
        });
      }
    }

    customElements.define('searchspring-results', SearchspringResults);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-dialog')) {
    customElements.define(
      'size-guide-dialog',
      class extends HTMLElement {
        connectedCallback() {
          this.SETTINGS_VERSION = '19';
          this.ENDPOINT = 'https://app.kiwisizing.com/api/getSizingChart';
          this._charts = null;
          this._settings = null;

          this._dialog = this.querySelector('[data-size-guide-dialog]');
          this._header = this.querySelector('[data-size-guide-header]');
          this._body = this.querySelector('[data-size-guide-body]');
          if (!this._dialog) return;

          var closeBtn = this.querySelector('[data-size-guide-close]');
          if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
          this._dialog.addEventListener('click', this._onBackdrop.bind(this));
          // The native `close` event fires for every close path (Escape, close(),
          // backdrop) so reset the trigger's aria-expanded here, not just in close().
          var self = this;
          this._dialog.addEventListener('close', function () {
            if (self._trigger) self._trigger.setAttribute('aria-expanded', 'false');
          });

          this._load();
        }

        _load() {
          var ds = this.dataset;
          var params = new URLSearchParams({
            shop: ds.shop || '',
            product: ds.productId || '',
            title: ds.title || '',
            tags: ds.tags || '',
            type: ds.type || '',
            vendor: ds.vendor || '',
            collections: ds.collections || '',
            settingsVersion: this.SETTINGS_VERSION,
          });

          var self = this;
          fetch(this.ENDPOINT + '?' + params.toString())
            .then(function (res) {
              if (!res.ok) throw new Error('size guide request failed');
              return res.json();
            })
            .then(function (json) {
              var data = json.data || json;
              var charts = self._selectCharts((data && data.sizings) || []);
              if (!charts.length) return;
              self._charts = charts;
              self._settings = (data && data.settings) || {};
              self._render();
              self._activateTrigger();
            })
            .catch(function () {
              /* no chart: leave the trigger hidden, render nothing */
            });
        }

        // Port of live's useSizeGuide chart selection: Kiwi returns every chart
        // whose rules match the product, so order by priority (desc) then
        // createdAt (asc) and keep only the charts sharing the top priority.
        // Deliberate deviation from live: a chart with no explicit priority
        // weight reads as 0. Live compares the raw `undefined`, which makes both
        // `>` and `<` false in the sort and turns the keep-check into `x > NaN`,
        // so tied unweighted charts were silently dropped.
        _selectCharts(sizings) {
          var sorted = sizings.slice().sort(function (a, b) {
            var pa = self_priority(a);
            var pb = self_priority(b);
            if (pa > pb) return -1;
            if (pa < pb) return 1;
            if (a.createdAt && b.createdAt) return String(a.createdAt).localeCompare(String(b.createdAt));
            return 0;
          });
          var kept = [];
          for (var i = 0; i < sorted.length; i++) {
            if (!kept.length) {
              kept.push(sorted[i]);
            } else if (self_priority(sorted[i]) > self_priority(kept[0]) - 1) {
              kept.push(sorted[i]);
            }
          }
          return kept;

          function self_priority(chart) {
            var weight = chart && chart.advancedOptions ? chart.advancedOptions.priority : undefined;
            return typeof weight === 'number' && !isNaN(weight) ? weight : 0;
          }
        }

        _activateTrigger() {
          this._trigger = document.querySelector('[data-size-guide-trigger]');
          if (!this._trigger) return;
          this._trigger.removeAttribute('hidden');
          this._trigger.addEventListener('click', this.open.bind(this));
        }

        open() {
          if (this._dialog && typeof this._dialog.showModal === 'function') {
            this._dialog.showModal();
            if (this._trigger) this._trigger.setAttribute('aria-expanded', 'true');
          }
        }

        close() {
          if (this._dialog && this._dialog.open) this._dialog.close();
          // aria-expanded reset is handled by the dialog's `close` event listener.
        }

        _onBackdrop(event) {
          if (event.target === this._dialog) this.close();
        }

        _render() {
          this._renderHeader();
          this._body.textContent = '';

          for (var c = 0; c < this._charts.length; c++) {
            var chart = this._charts[c];
            var wrap = document.createElement('div');
            wrap.className = 'size-guide__chart';
            var layout = (chart.layout && chart.layout.data) || [];
            for (var i = 0; i < layout.length; i++) {
              var item = layout[i];
              if (item.type === 1) {
                var table = (chart.tables || {})[item.value];
                if (table) wrap.appendChild(this._buildTable(table));
              } else if (item.type === 0) {
                var html = document.createElement('div');
                html.className = 'size-guide__html';
                html.innerHTML = item.value || '';
                wrap.appendChild(html);
              }
            }
            this._body.appendChild(wrap);
          }
        }

        _renderHeader() {
          this._header.textContent = '';
          var settings = this._settings || {};
          var title = (settings.modalHeaderText || '').replace(/\{\{\s*product\.title\s*\}\}/g, this.dataset.title || '');
          if (title) {
            // <h2> so the dialog has a top-level heading (the section charts are h3);
            // id lets the dialog reference it via aria-labelledby.
            var h = document.createElement('h2');
            h.className = 'size-guide__title';
            h.id = 'size-guide-title';
            h.textContent = title;
            this._header.appendChild(h);
          }
          if (settings.modalSubHeaderText) {
            var sub = document.createElement('div');
            sub.className = 'size-guide__subtitle';
            sub.id = 'size-guide-subtitle';
            sub.innerHTML = settings.modalSubHeaderText;
            this._header.appendChild(sub);
          }
          var hr = document.createElement('hr');
          hr.className = 'size-guide__divider';
          this._header.appendChild(hr);
        }

        _buildTable(table) {
          var wrap = document.createElement('div');
          wrap.className = 'size-guide__chart-table';

          if (table.header) {
            var heading = document.createElement('h3');
            heading.className = 'size-guide__section-heading';
            heading.textContent = table.header;
            wrap.appendChild(heading);
          }

          var scroll = document.createElement('div');
          scroll.className = 'size-guide__table-scroll';
          var el = document.createElement('table');
          el.className = 'size-guide__table';

          var rows = table.data || [];
          for (var r = 0; r < rows.length; r++) {
            var tr = document.createElement('tr');
            // Rows carrying cm values are body-measurement rows (bust / waist /
            // hip); the size-scheme rows (AU/UK, US, EU) carry no unit type. The
            // first row is the column-label row, never a measurement row.
            var isMeasurementRow = r > 0 && this._hasCmUnits(rows[r]);
            for (var i = 0; i < rows[r].length; i++) {
              var cell = rows[r][i];
              // Treat only non-empty header cells as <th>; blank spacer cells (the
              // empty first cells of the alpha-size rows) render as plain <td> so
              // screen readers don't announce empty row headers.
              var isHeader = cell && cell.type === 'header' && cell.value;
              var td = document.createElement(isHeader ? 'th' : 'td');
              if (isHeader) td.setAttribute('scope', r === 0 ? 'col' : 'row');
              var text = (cell && cell.value) || '';
              if (isHeader && isMeasurementRow) text = this._measurementLabel(text);
              td.textContent = text;
              tr.appendChild(td);
            }
            el.appendChild(tr);
          }

          scroll.appendChild(el);
          wrap.appendChild(scroll);

          // Live renders the chart's footer copy centred under the table.
          if (table.footer) {
            var footer = document.createElement('p');
            footer.className = 'size-guide__footer';
            footer.textContent = table.footer;
            wrap.appendChild(footer);
          }
          return wrap;
        }

        _hasCmUnits(row) {
          for (var i = 0; i < row.length; i++) {
            if (row[i] && row[i].unitType === 'cm') return true;
          }
          return false;
        }

        // Live renders measurement row labels as "BUST (CM)" / "WAIST (CM)" /
        // "HIP (CM)" where Kiwi supplies "Bust" / "Waist" / "Hip". Case-folding
        // happens here (rather than via CSS text-transform) so it travels with the
        // appended unit suffix as one piece of text content.
        _measurementLabel(value) {
          var label = String(value).toUpperCase();
          if (label.indexOf('(CM)') === -1) label += ' (CM)';
          return label;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-map"] && !Shopify.designMode) return;
  try {
    var STORE_MAP_PIN_PATH =
    'M5.02 25.493h0a14.833 14.833 0 01-3.018-8.99V16.5a15 15 0 0130 0v.002a14.826 14.826 0 01-3.017 8.986l-.15.198-.001.003-.08.104-.17.22-.06.078-.007.009h0L17.001 39.68 5.51 26.129a50.83 50.83 0 01-.49-.635z';
  // Detail-page single marker: live uses the FILLED location glyph (StorePin index=0),
  // not the numbered outline teardrop.
  var STORE_MAP_LOCATION_PATH =
    'M25 6.25c-8.062 0-14.583 6.52-14.583 14.583C10.417 31.771 25 43.75 25 43.75s14.584-11.98 14.584-22.917C39.584 12.771 33.063 6.25 25 6.25zm0 20.833a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5z';

  class StoreMap extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.mode = this.dataset.mode === 'detail' ? 'detail' : 'directory';
      this.canvas = document.createElement('div');
      this.canvas.className = 'store-map__canvas';
      this.appendChild(this.canvas);

      this.markers = {};
      this.stores = [];

      var self = this;
      this.dataset.state = 'loading-maps';
      this._whenLoaderReady(function () {
        window
          .ensureGoogleMaps(self.dataset.apiKey || '', self.dataset.mapId || '')
          .then(function (libs) {
            if (!libs) {
              self.dataset.state = 'no-position';
              return;
            }
            if (self.mode === 'detail') {
              self._buildDetail();
            } else {
              self._buildDirectory();
            }
          })
          .catch(function () {
            self.dataset.state = 'error';
          });
      });
    }

    // The snippet JS bundle order is not guaranteed, so the loader definition may
    // land after this element upgrades. Wait for it rather than failing synchronously.
    _whenLoaderReady(cb) {
      if (typeof window.ensureGoogleMaps === 'function') {
        cb();
        return;
      }
      var self = this;
      var tries = 0;
      var iv = window.setInterval(function () {
        if (typeof window.ensureGoogleMaps === 'function') {
          window.clearInterval(iv);
          cb();
        } else if (++tries > 50) {
          window.clearInterval(iv);
          self.dataset.state = 'error';
        }
      }, 100);
    }

    disconnectedCallback() {
      if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
    }

    _mapOptions(center, zoom, extra) {
      var opts = {
        center: center,
        zoom: zoom,
        disableDefaultUI: true,
        zoomControl: true
      };
      if (this.dataset.mapId) opts.mapId = this.dataset.mapId;
      if (extra) {
        Object.keys(extra).forEach(function (k) {
          opts[k] = extra[k];
        });
      }
      return opts;
    }

    _buildDetail() {
      var lat = parseFloat(this.dataset.lat);
      var lng = parseFloat(this.dataset.lng);
      if (isNaN(lat) || isNaN(lng)) {
        this.dataset.state = 'no-position';
        return;
      }
      var zoom = parseInt(this.dataset.zoom, 10) || 14;
      this.map = new google.maps.Map(this.canvas, this._mapOptions({ lat: lat, lng: lng }, zoom));
      new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: { lat: lat, lng: lng },
        content: this._buildDetailPin(),
        title: this.dataset.title || ''
      });
      this.dataset.state = 'ready';
    }

    _buildDetailPin() {
      var pin = document.createElement('div');
      pin.className = 'store-map__pin--detail';
      pin.innerHTML =
        '<svg viewBox="0 0 50 50" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="' +
        STORE_MAP_LOCATION_PATH +
        '"></path></svg>';
      return pin;
    }

    _buildDirectory() {
      var center = this._parsePosition(this.dataset.position);
      if (!center) {
        this.dataset.state = 'no-position';
        return;
      }
      this.stores = this._parseStores();
      this._mobile = window.matchMedia('(max-width: 47.99rem)').matches;
      // Live settles the directory at zoom 11 on BOTH breakpoints after a search
      // (its handleCenter calls setZoom(11)). Zoom 13 framed only a ~16km-wide
      // viewport, so the section's in-view filter reported no stores for searches
      // whose nearest stores sit 18-28km away (e.g. Richmond NSW).
      var zoom = this._mobile
        ? parseInt(this.dataset.zoomMobile, 10) || 11
        : parseInt(this.dataset.zoom, 10) || 11;
      var minZoom = parseInt(this.dataset.minZoom, 10) || 4;
      this.map = new google.maps.Map(this.canvas, this._mapOptions(center, zoom, { minZoom: minZoom }));

      var self = this;
      this.stores.forEach(function (store) {
        self._addMarker({ lat: store.lat, lng: store.lng }, store.title || '', store.handle);
      });

      this.map.addListener('idle', function () {
        self._emitBounds();
      });

      this._resizeHandler = function () {
        self._onResize();
      };
      window.addEventListener('resize', this._resizeHandler);

      this.dataset.state = 'ready';
      this._emitBounds();
    }

    _buildPin() {
      var pin = document.createElement('div');
      pin.className = 'store-map__pin';
      var svg =
        '<svg class="store-map__pin-svg" viewBox="0 0 34 42" aria-hidden="true"><path d="' +
        STORE_MAP_PIN_PATH +
        '"></path></svg>';
      pin.innerHTML = svg;
      var num = document.createElement('span');
      num.className = 'store-map__pin-num';
      pin.appendChild(num);
      pin._numEl = num;
      return pin;
    }

    _addMarker(position, title, handle) {
      var pin = this._buildPin();
      var marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: position,
        content: pin,
        title: title
      });
      marker._position = position;
      if (!handle) return marker;
      marker._pin = pin;
      this.markers[handle] = marker;
      var self = this;
      pin.addEventListener('click', function () {
        self._onPinClick(handle);
      });
      return marker;
    }

    _parsePosition(value) {
      if (!value) return null;
      var parts = String(value).split(',');
      if (parts.length !== 2) return null;
      var lat = parseFloat(parts[0]);
      var lng = parseFloat(parts[1]);
      if (isNaN(lat) || isNaN(lng)) return null;
      return { lat: lat, lng: lng };
    }

    _parseStores() {
      var id = this.dataset.storesId;
      if (!id) return [];
      var node = document.getElementById(id);
      if (!node) return [];
      var list;
      try {
        list = JSON.parse(node.textContent);
      } catch (e) {
        return [];
      }
      if (!Array.isArray(list)) return [];
      return list
        .map(function (s) {
          return {
            handle: s.handle,
            title: s.title,
            url: s.url,
            lat: parseFloat(s.lat),
            lng: parseFloat(s.lng),
            brands: s.brands
          };
        })
        .filter(function (s) {
          return s.handle && !isNaN(s.lat) && !isNaN(s.lng);
        });
    }

    _emitBounds() {
      if (!this.map) return;
      var bounds = this.map.getBounds();
      if (!bounds) return;
      var handles = [];
      this.stores.forEach(function (store) {
        if (bounds.contains({ lat: store.lat, lng: store.lng })) handles.push(store.handle);
      });
      this.dispatchEvent(
        new CustomEvent('store-map:bounds', {
          bubbles: true,
          composed: true,
          detail: { handles: handles }
        })
      );
    }

    _onPinClick(handle) {
      // Live parity: a pin click recenters + zooms closer only. No list scroll,
      // no active-pin inversion, no modal/popup (live's handleSelect).
      var marker = this.markers[handle];
      if (!marker || !this.map) return;
      this.map.setCenter(marker._position);
      this.map.setZoom(this._mobile ? 11 : 13);
    }

    _reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    _onResize() {
      if (!this.map) return;
      var mobile = window.matchMedia('(max-width: 47.99rem)').matches;
      if (mobile === this._mobile) return;
      this._mobile = mobile;
      var zoom = mobile
        ? parseInt(this.dataset.zoomMobile, 10) || 11
        : parseInt(this.dataset.zoom, 10) || 11;
      this.map.setZoom(zoom);
    }

    // Public API (section -> element).
    setOrder(handles) {
      var order = {};
      (handles || []).forEach(function (handle, i) {
        order[handle] = i + 1;
      });
      var self = this;
      Object.keys(this.markers).forEach(function (handle) {
        var marker = self.markers[handle];
        var n = order[handle];
        marker._pin._numEl.textContent = n ? String(n) : '';
      });
    }

    selectStore(handle) {
      var marker = this.markers[handle];
      if (!marker || !this.map) return;
      var position = marker._position;
      if (this._reducedMotion()) {
        this.map.setCenter(position);
      } else {
        this.map.panTo(position);
      }
    }
  }

  if (!window.customElements.get('store-map')) {
    window.customElements.define('store-map', StoreMap);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    class DcToast extends HTMLElement {
    connectedCallback() {
      this.onShow = this.handleShow.bind(this);
      document.addEventListener('toast:show', this.onShow);
    }

    disconnectedCallback() {
      if (this.onShow) document.removeEventListener('toast:show', this.onShow);
    }

    handleShow(e) {
      const detail = e && e.detail;
      const text = detail && typeof detail.text === 'string' ? detail.text.trim() : '';
      if (!text) return;

      const toast = document.createElement('div');
      toast.className = 'toast-host__toast';

      const iconName = detail.icon && typeof detail.icon === 'string' ? detail.icon : '';
      const tpl = iconName
        ? this.querySelector('template[data-toast-icon="' + CSS.escape(iconName) + '"]')
        : null;
      if (tpl && tpl.content) toast.appendChild(tpl.content.cloneNode(true));

      const label = document.createElement('span');
      label.textContent = text;
      toast.appendChild(label);
      this.appendChild(toast);

      // Double rAF so the entry transition runs from the initial hidden frame.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.classList.add('is-visible');
        });
      });

      setTimeout(function () {
        toast.classList.remove('is-visible');
        let removed = false;
        const remove = function () {
          if (removed) return;
          removed = true;
          toast.remove();
        };
        // transitionend does not fire under reduced-motion; the timer covers it.
        toast.addEventListener('transitionend', remove, { once: true });
        setTimeout(remove, 400);
      }, 4000);
    }
  }

  if (!window.customElements.get('dc-toast')) {
    window.customElements.define('dc-toast', DcToast);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    class DcWishlistButton extends HTMLElement {
    static get observedAttributes() {
      return ['data-variant-id'];
    }

    // A wishlist size-swap (product-quick-shop) re-points this heart to the new
    // variant by setting data-variant-id. Update the cached id so a later
    // heart-remove targets the new variant. Saved-state is intentionally left
    // as-is (the item is still saved as the new variant) rather than re-seeded
    // from the coordinator cache, which isn't updated on a same-product swap.
    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'data-variant-id' || !this.btn) return;
      const id = parseInt(newValue, 10);
      if (!Number.isNaN(id)) this.variantId = id;
    }

    connectedCallback() {
      this.btn = this.querySelector('.wishlist-button__btn');
      if (!this.btn) return;
      this.productId = parseInt(this.dataset.productId, 10);
      this.variantId = parseInt(this.dataset.variantId, 10);
      this.url = this.dataset.productUrl;
      this.labelAdd = this.dataset.labelAdd;
      this.labelRemove = this.dataset.labelRemove;
      this.labelRemoved = this.dataset.labelRemoved;
      this.labelRemoveFailed = this.dataset.labelRemoveFailed;
      // In-flight guard (live disabled={isLoading}): blocks a second click while
      // a remove round-trip is pending, which could otherwise open the add modal
      // against the optimistically-unsaved state.
      this.busy = false;

      // Parsed once; null on any failure so the click path can fall back to the
      // pre-#214 direct add instead of dead-ending.
      this.payload = null;
      const payloadEl = this.querySelector('[data-wishlist-payload]');
      if (payloadEl) {
        try {
          this.payload = JSON.parse(payloadEl.textContent);
        } catch (err) {
          this.payload = null;
        }
      }

      this.onClick = this.handleClick.bind(this);
      this.onReady = this.handleReady.bind(this);
      this.onChange = this.handleChange.bind(this);
      this.btn.addEventListener('click', this.onClick);
      document.addEventListener('wishlist:change', this.onChange);

      // Seed saved-state from the coordinator: read its cache synchronously if
      // the SDK is already ready, otherwise wait once for wishlist:ready.
      if (window.__dcWishlistReady) {
        this.seedFromCoordinator(null);
      } else {
        document.addEventListener('wishlist:ready', this.onReady, { once: true });
      }
    }

    disconnectedCallback() {
      if (this.btn && this.onClick) this.btn.removeEventListener('click', this.onClick);
      if (this.onChange) document.removeEventListener('wishlist:change', this.onChange);
      if (this.onReady) document.removeEventListener('wishlist:ready', this.onReady);
    }

    swym() {
      return window._swat || null;
    }

    isSaved() {
      return this.btn.getAttribute('aria-pressed') === 'true';
    }

    setSaved(saved) {
      this.btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      this.classList.toggle('is-saved', !!saved);
      const label = saved ? this.labelRemove : this.labelAdd;
      if (label) this.btn.setAttribute('aria-label', label);
    }

    handleReady(e) {
      const ids = e && e.detail && Array.isArray(e.detail.variantIds) ? e.detail.variantIds : [];
      this.seedFromCoordinator(ids);
    }

    // Live parity (#214): saved-state is PRODUCT-level -- the live WishlistButton
    // looks up which variant of this product is saved and operates on it. The
    // modal saves the shopper's CHOSEN size, which usually differs from the
    // card/PDP's displayed variant, so seed from the coordinator's full items
    // (published before wishlist:ready) and re-point to the saved variant so a
    // later heart-remove targets the right one. Falls back to variant-level Set
    // membership when the items publish is unavailable.
    seedFromCoordinator(variantIds) {
      const items = Array.isArray(window.__dcWishlistItems) ? window.__dcWishlistItems : null;
      if (items) {
        const self = this;
        const match = items.find(function (item) {
          return parseInt(item.productId, 10) === self.productId;
        });
        if (match) {
          const epi = parseInt(match.variantId, 10);
          if (!Number.isNaN(epi)) this.variantId = epi;
        }
        this.setSaved(!!match);
        return;
      }
      let ids = variantIds;
      if (!ids) {
        ids = window.__dcWishlistSavedVariantIds instanceof Set ? Array.from(window.__dcWishlistSavedVariantIds) : [];
      }
      this.setSaved(ids.indexOf(this.variantId) !== -1);
    }

    handleChange(e) {
      const detail = e && e.detail;
      if (!detail) return;
      if (parseInt(detail.variantId, 10) !== this.variantId) return;
      this.setSaved(!!detail.added);
    }

    broadcast(added) {
      document.dispatchEvent(
        new CustomEvent('wishlist:change', {
          detail: { productId: this.productId, variantId: this.variantId, added: added },
        })
      );
    }

    notify(text, icon) {
      if (!text) return;
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: text, icon: icon } }));
    }

    setBusy(on) {
      this.busy = on;
      if (this.btn) this.btn.disabled = on;
    }

    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.busy) return;
      const swat = this.swym();
      if (!swat) {
        window.location.href = '/pages/wishlist';
        return;
      }
      const wasSaved = this.isSaved();

      // #214: an unsaved heart opens the shared size-select modal instead of
      // adding directly. No optimistic flip -- the modal broadcasts
      // wishlist:change on success and this heart fills from that event. A
      // missing payload falls through to the legacy direct add below.
      if (!wasSaved && this.payload) {
        document.dispatchEvent(
          new CustomEvent('wishlist:modal-open', { detail: { payload: this.payload, trigger: this } })
        );
        return;
      }

      // Swym requires an absolute destination URL; product.url is relative.
      const du = this.url ? new URL(this.url, window.location.origin).href : this.url;
      const product = { empi: this.productId, epi: this.variantId, du: du };
      const self = this;
      // Swym's SDK remove method is removeFromWishList; deleteFromWishList is
      // kept as a fallback in case an older SDK build exposes that name.
      const removeFn = swat.removeFromWishList || swat.deleteFromWishList;
      // Optimistic flip; revert in the error callback if the SDK write fails.
      this.setSaved(!wasSaved);
      try {
        if (wasSaved) {
          if (typeof removeFn === 'function') {
            this.setBusy(true);
            removeFn.call(
              swat,
              product,
              function () { self.setBusy(false); self.broadcast(false); self.notify(self.labelRemoved, 'tick'); },
              function () { self.setBusy(false); self.setSaved(true); self.notify(self.labelRemoveFailed); }
            );
          } else {
            this.setSaved(true);
          }
        } else if (typeof swat.addToWishList === 'function') {
          swat.addToWishList(product, function () { self.broadcast(true); }, function () { self.setSaved(false); });
        } else {
          this.setSaved(wasSaved);
        }
      } catch (err) {
        // Swallow SDK errors so the storefront never breaks; revert optimistic state.
        this.setBusy(false);
        this.setSaved(wasSaved);
      }
    }
  }

  if (!window.customElements.get('dc-wishlist-button')) {
    window.customElements.define('dc-wishlist-button', DcWishlistButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-modal"] && !Shopify.designMode) return;
  try {
    class DcWishlistModal extends HTMLElement {
    connectedCallback() {
      this.sizeDialog = this.querySelector('[data-wishlist-size-dialog]');
      this.guestDialog = this.querySelector('[data-wishlist-guest-dialog]');
      this.titleEl = this.querySelector('[data-wishlist-product-title]');
      this.colorEl = this.querySelector('[data-wishlist-product-color]');
      this.pillsEl = this.querySelector('[data-wishlist-pills]');
      this.addBtn = this.querySelector('[data-wishlist-add]');
      this.loggedIn = this.dataset.loggedIn === 'true';

      this.payload = null;
      this.trigger = null;
      this.selectedVariantId = NaN;
      this.busy = false;

      this.onOpenRequest = this.handleOpenRequest.bind(this);
      document.addEventListener('wishlist:modal-open', this.onOpenRequest);

      const self = this;
      this.querySelectorAll('[data-wishlist-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.closeAll();
        });
      });

      const continueBtn = this.querySelector('[data-wishlist-continue]');
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          self.closeDialog(self.guestDialog);
          self.openSize();
        });
      }

      // Backdrop click: a click landing on the dialog element itself (not its
      // content) means the backdrop was clicked.
      [this.sizeDialog, this.guestDialog].forEach(function (dialog) {
        if (!dialog) return;
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) self.closeDialog(dialog);
        });
      });

      if (this.addBtn) this.addBtn.addEventListener('click', this.handleAdd.bind(this));
    }

    disconnectedCallback() {
      if (this.onOpenRequest) document.removeEventListener('wishlist:modal-open', this.onOpenRequest);
    }

    handleOpenRequest(e) {
      const detail = e && e.detail;
      if (!detail || !detail.payload || !this.sizeDialog) return;
      if (this.sizeDialog.open || (this.guestDialog && this.guestDialog.open)) return;

      this.payload = detail.payload;
      this.trigger = detail.trigger || null;

      // Guest with an empty wishlist gets the save-your-list prompt first; a
      // not-yet-ready coordinator counts as empty (task scope Resolved Decisions).
      const saved = window.__dcWishlistSavedVariantIds;
      const guestEmpty = !this.loggedIn && (!(saved instanceof Set) || saved.size === 0);
      if (guestEmpty && this.guestDialog) {
        this.openDialog(this.guestDialog);
      } else {
        this.openSize();
      }
    }

    openSize() {
      this.populate();
      this.openDialog(this.sizeDialog);
    }

    openDialog(dialog) {
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
        // Focus the panel itself (tabindex="-1"), not the first pill -- live
        // parity, and avoids an immediate focus ring after a mouse click.
        dialog.focus();
      }
    }

    closeDialog(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    closeAll() {
      this.closeDialog(this.sizeDialog);
      this.closeDialog(this.guestDialog);
    }

    // Rebuild the size dialog from the current payload: title, colour line, one
    // pill per size (disabled when unavailable), confirm reset to idle/disabled.
    populate() {
      const payload = this.payload || {};
      this.selectedVariantId = NaN;
      this.busy = false;

      if (this.titleEl) this.titleEl.textContent = payload.title || '';
      if (this.colorEl) {
        this.colorEl.textContent = payload.color || '';
        this.colorEl.hidden = !payload.color;
      }

      if (this.pillsEl) {
        this.pillsEl.textContent = '';
        const sizes = Array.isArray(payload.sizes) ? payload.sizes : [];
        const self = this;
        sizes.forEach(function (size) {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'wishlist-modal__pill';
          pill.textContent = size.value || '';
          pill.disabled = !size.available;
          // A11y: toggle-button pattern so screen readers can perceive which
          // size is selected (the underline alone is visual-only).
          pill.setAttribute('aria-pressed', 'false');
          pill.dataset.variantId = String(size.variantId);
          pill.addEventListener('click', function () {
            self.selectPill(pill);
          });
          self.pillsEl.appendChild(pill);
        });

        // Live parity: a single size is preselected regardless of availability.
        if (sizes.length === 1 && this.pillsEl.firstElementChild) {
          this.selectPill(this.pillsEl.firstElementChild);
        }
      }

      this.updateAddButton();
    }

    selectPill(pill) {
      if (this.busy) return;
      const id = parseInt(pill.dataset.variantId, 10);
      if (Number.isNaN(id)) return;
      this.selectedVariantId = id;
      const kids = this.pillsEl ? this.pillsEl.children : [];
      Array.prototype.forEach.call(kids, function (el) {
        el.classList.toggle('is-selected', el === pill);
        el.setAttribute('aria-pressed', el === pill ? 'true' : 'false');
      });
      this.updateAddButton();
    }

    updateAddButton() {
      if (!this.addBtn) return;
      this.addBtn.textContent = this.busy ? this.dataset.labelAdding : this.dataset.labelAdd;
      this.addBtn.disabled = this.busy || Number.isNaN(this.selectedVariantId);
      this.addBtn.setAttribute('aria-busy', this.busy ? 'true' : 'false');
    }

    toast(text, icon) {
      if (!text) return;
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: text, icon: icon } }));
    }

    // Swym add for the chosen variant. On success: re-point the trigger heart
    // FIRST (its attributeChangedCallback updates the cached id without touching
    // saved state), then broadcast wishlist:change so the heart fills, siblings
    // sync, and the coordinator cache updates; toast; close. On error: failure
    // toast and close anyway (live closes in its finally). Callbacks must not
    // assume the dialog is still open (Escape during busy is allowed).
    handleAdd() {
      if (this.busy || Number.isNaN(this.selectedVariantId) || !this.payload) return;
      const swat = window._swat;
      const self = this;
      const payload = this.payload;
      const variantId = this.selectedVariantId;

      const fail = function () {
        self.busy = false;
        self.updateAddButton();
        self.toast(self.dataset.labelAddFailed);
        self.closeAll();
      };

      if (!swat || typeof swat.addToWishList !== 'function') {
        fail();
        return;
      }

      this.busy = true;
      this.updateAddButton();

      // Swym requires an absolute destination URL (payload.productUrl is relative).
      const du = payload.productUrl ? new URL(payload.productUrl, window.location.origin).href : payload.productUrl;

      try {
        swat.addToWishList(
          { empi: payload.productId, epi: variantId, du: du },
          function () {
            self.busy = false;
            self.updateAddButton();
            if (self.trigger && typeof self.trigger.setAttribute === 'function') {
              self.trigger.setAttribute('data-variant-id', String(variantId));
            }
            document.dispatchEvent(
              new CustomEvent('wishlist:change', {
                detail: { productId: payload.productId, variantId: variantId, added: true },
              })
            );
            self.toast(self.dataset.labelAdded, 'tick');
            self.closeAll();
          },
          fail
        );
      } catch (err) {
        // Swallow SDK errors so the storefront never breaks.
        fail();
      }
    }
  }

  if (!window.customElements.get('dc-wishlist-modal')) {
    window.customElements.define('dc-wishlist-modal', DcWishlistModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-sdk"] && !Shopify.designMode) return;
  try {
    class DcWishlistSdk extends HTMLElement {
    connectedCallback() {
      this.settled = false;
      this.readyTimer = null;
      this.onChange = this.handleChange.bind(this);
      document.addEventListener('wishlist:change', this.onChange);
      this.init();
    }

    disconnectedCallback() {
      if (this.onChange) document.removeEventListener('wishlist:change', this.onChange);
      if (this.readyTimer) clearTimeout(this.readyTimer);
      if (this.regidTimer) clearInterval(this.regidTimer);
    }

    init() {
      this.readyTimer = setTimeout(() => this.publishReady([]), 8000);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push((swat) => this.onSwym(swat));
    }

    onSwym(swat) {
      if (!swat) {
        this.publishReady([]);
        return;
      }
      if (this.sessionReady(swat)) {
        this.read(swat);
        return;
      }
      const evtLayer = swat.evtLayer;
      const events = swat.JSEvents || {};
      const names = [events.sessionStarted, events.sessionCreated, events.registered].filter(Boolean);
      if (evtLayer && typeof evtLayer.addEventListener === 'function' && names.length) {
        const onSession = () => {
          if (!this.settled && this.sessionReady(swat)) this.read(swat);
        };
        names.forEach((name) => {
          try {
            evtLayer.addEventListener(name, onSession);
          } catch (e) {
            // Ignore unknown event names; the ready timeout still degrades.
          }
        });
      }
    }

    sessionReady(swat) {
      const session = swat && swat.session;
      return !!(session && session.sessionId && session.sw && session.sw.swymHost);
    }

    read(swat) {
      if (this.settled) return;
      const session = swat.session;
      const host = session.sw.swymHost;
      const pid = session.sw.pid || this.cookie('swym-pid');
      const regid = this.cookie('swym-swymRegid');
      const sessionid = session.sessionId;
      if (!host || !pid || !sessionid) {
        this.publishReady([]);
        return;
      }
      if (!regid) {
        // Fresh guests: the app embed writes the swym-swymRegid cookie a beat
        // AFTER the session becomes ready, so an immediate read loses the race
        // and degrades a first-time visitor (blank hearts; empty shared page).
        // Retry until the cookie lands; the ready timer still degrades at 8s.
        if (!this.regidTimer) {
          this.regidTimer = setInterval(() => {
            if (this.settled) {
              clearInterval(this.regidTimer);
              this.regidTimer = null;
              return;
            }
            if (this.cookie('swym-swymRegid')) {
              clearInterval(this.regidTimer);
              this.regidTimer = null;
              this.read(swat);
            }
          }, 250);
        }
        return;
      }
      this.creds = { host: host, pid: pid, regid: regid, sessionid: sessionid };
      const url = host + '/api/v3/lists/fetch-lists?pid=' + encodeURIComponent(pid);
      const body = 'regid=' + encodeURIComponent(regid) + '&sessionid=' + encodeURIComponent(sessionid);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body,
      })
        .then((res) => (res.ok ? res.text() : ''))
        .then((text) => {
          let lists = [];
          if (text) {
            try {
              const parsed = JSON.parse(text);
              if (Array.isArray(parsed)) lists = parsed;
            } catch (e) {
              lists = [];
            }
          }
          const first = lists.length ? lists[0] : null;
          this.listId = first && first.lid ? String(first.lid) : '';
          const contents = first && Array.isArray(first.listcontents) ? first.listcontents : [];
          const items = contents
            .map((entry) => this.normalise(entry))
            .filter((item) => item && !Number.isNaN(item.variantId));
          this.publishReady(items);
        })
        .catch(() => this.publishReady([]));
    }

    normalise(entry) {
      if (!entry) return null;
      const url = entry.du || '';
      return {
        productId: parseInt(entry.empi, 10),
        variantId: parseInt(entry.epi, 10),
        url: url,
        handle: this.handleFromUrl(url),
        image: entry.iu || '',
        title: entry.dt || '',
        price: entry.pr,
        variantTitle: entry.vi || '',
      };
    }

    handleFromUrl(url) {
      if (!url) return '';
      const marker = '/products/';
      const at = url.indexOf(marker);
      if (at === -1) return '';
      const rest = url.slice(at + marker.length);
      return rest.split('?')[0].split('#')[0].split('/')[0];
    }

    cookie(name) {
      const parts = document.cookie ? document.cookie.split(';') : [];
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (part.indexOf(name + '=') === 0) {
          return decodeURIComponent(part.slice(name.length + 1));
        }
      }
      return '';
    }

    publishReady(items) {
      if (this.settled) return;
      this.settled = true;
      if (this.readyTimer) {
        clearTimeout(this.readyTimer);
        this.readyTimer = null;
      }
      if (this.regidTimer) {
        clearInterval(this.regidTimer);
        this.regidTimer = null;
      }
      const list = Array.isArray(items) ? items : [];
      const ids = list.map((item) => item.variantId).filter((id) => !Number.isNaN(id));
      window.__dcWishlistSavedVariantIds = new Set(ids);
      window.__dcWishlistItems = list;
      window.__dcWishlistListId = this.listId || '';
      window.__dcWishlistCreds = this.creds || null;
      window.__dcWishlistReady = true;
      document.dispatchEvent(
        new CustomEvent('wishlist:ready', { detail: { variantIds: ids, listId: window.__dcWishlistListId } })
      );
      document.dispatchEvent(new CustomEvent('wishlist:items', { detail: { items: list } }));
    }

    handleChange(e) {
      const detail = e && e.detail;
      if (!detail || typeof detail.variantId === 'undefined') return;
      if (!(window.__dcWishlistSavedVariantIds instanceof Set)) {
        window.__dcWishlistSavedVariantIds = new Set();
      }
      const id = parseInt(detail.variantId, 10);
      if (Number.isNaN(id)) return;
      if (detail.added) window.__dcWishlistSavedVariantIds.add(id);
      else window.__dcWishlistSavedVariantIds.delete(id);
    }
  }

  if (!window.customElements.get('dc-wishlist-sdk')) {
    window.customElements.define('dc-wishlist-sdk', DcWishlistSdk);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-share-modal"] && !Shopify.designMode) return;
  try {
    class DcWishlistShareModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-share-dialog]');
      this.form = this.querySelector('[data-share-form]');
      this.senderName = this.querySelector('[data-share-sender-name]');
      this.senderEmail = this.querySelector('[data-share-sender-email]');
      this.recipientEmail = this.querySelector('[data-share-recipient-email]');
      this.message = this.querySelector('[data-share-message]');
      this.submitBtn = this.querySelector('[data-share-submit]');
      this.copyBtn = this.querySelector('[data-share-copy]');

      this.trigger = null;
      this.shareUrl = '';
      this.publicLid = '';
      this.sending = false;

      this.onOpenRequest = this.handleOpenRequest.bind(this);
      document.addEventListener('wishlist:share-open', this.onOpenRequest);

      const self = this;
      const closeBtn = this.querySelector('[data-share-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          self.close();
        });
      }
      if (this.dialog) {
        // Backdrop click: a click landing on the dialog element itself (not
        // its content) means the backdrop was clicked.
        this.dialog.addEventListener('click', function (e) {
          if (e.target === self.dialog) self.close();
        });
        // Fires for every close path (X, backdrop, Escape, programmatic).
        this.dialog.addEventListener('close', function () {
          if (self.trigger && typeof self.trigger.focus === 'function') self.trigger.focus();
        });
      }
      if (this.form) this.form.addEventListener('submit', this.handleSubmit.bind(this));
      if (this.copyBtn) this.copyBtn.addEventListener('click', this.handleCopy.bind(this));
    }

    disconnectedCallback() {
      if (this.onOpenRequest) document.removeEventListener('wishlist:share-open', this.onOpenRequest);
    }

    handleOpenRequest(e) {
      if (!this.dialog || this.dialog.open) return;
      this.trigger = e && e.detail ? e.detail.trigger || null : null;
      this.dialog.showModal();
      // Focus the panel itself (tabindex="-1"), not the first field.
      this.dialog.focus();
      this.mintLink();
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    creds() {
      const creds = window.__dcWishlistCreds;
      const lid = window.__dcWishlistListId;
      if (!creds || !creds.host || !creds.pid || !creds.regid || !creds.sessionid || !lid) return null;
      return { host: creds.host, pid: creds.pid, regid: creds.regid, sessionid: creds.sessionid, lid: lid };
    }

    // `lid` overrides the coordinator's list id so reportShare/emailList can be
    // keyed on markPublic's returned publicLid, exactly as live does.
    post(op, params, lid) {
      const creds = this.creds();
      if (!creds) return Promise.reject(new Error('wishlist share: no credentials'));
      const body = new URLSearchParams();
      body.set('regid', creds.regid);
      body.set('sessionid', creds.sessionid);
      body.set('lid', lid || creds.lid);
      Object.keys(params || {}).forEach(function (key) {
        body.set(key, params[key]);
      });
      const url = creds.host + '/api/v3/lists/' + op + '?pid=' + encodeURIComponent(creds.pid);
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString(),
      }).then(function (res) {
        if (!res.ok) throw new Error('wishlist share: ' + op + ' failed');
        return res.json();
      });
    }

    // Mint the share link on every open, in live's order: markPublic ->
    // publicLid -> reportShare (which doubles as Swym's share beacon, so
    // re-firing per open is live parity) -> URL. Live's chain, verbatim:
    // `WishlistContext.tsx` callMarkListPublicAPI() -> setPublicLid(response.lid);
    // `ShareWishlistModal.tsx` callCopyLinkAPI({ publicLid }) -> getSharedURL(response?.lid).
    // Marking public is what makes the link readable by the recipient (Swym
    // 401s `sw-unauth-acl` otherwise), so the mint fails closed: Copy URL stays
    // disabled rather than handing out a link that lands on the empty state.
    mintLink() {
      const self = this;
      this.shareUrl = '';
      this.publicLid = '';
      if (this.copyBtn) this.copyBtn.disabled = true;
      this.post('markPublic')
        .then(function (data) {
          const publicLid = data && data.lid ? String(data.lid) : '';
          if (!publicLid) throw new Error('wishlist share: markPublic returned no lid');
          self.publicLid = publicLid;
          return self.post('reportShare', { fromname: 'user', medium: 'copylink' }, publicLid);
        })
        .then(function (data) {
          const lid = data && data.lid ? String(data.lid) : self.publicLid;
          if (!lid) return;
          const path = self.dataset.sharePath || '/pages/shared-wishlist';
          const query = '?hkey=' + encodeURIComponent(lid) + '&lid=' + encodeURIComponent(lid);
          // Protocol-less on purpose - live copies host + path (resolved decision).
          self.shareUrl = window.location.host + path + query;
          if (self.copyBtn) self.copyBtn.disabled = false;
        })
        .catch(function () {
          // Copy stays disabled; the email form still works (it needs no link).
        });
    }

    toast(text, icon) {
      if (!text) return;
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: text, icon: icon } }));
    }

    handleCopy() {
      const self = this;
      if (!this.shareUrl) return;
      const url = this.shareUrl;
      const clipboard = navigator.clipboard;
      if (clipboard && typeof clipboard.writeText === 'function') {
        clipboard
          .writeText(url)
          .then(function () {
            self.toast(self.dataset.labelCopied, 'tick');
          })
          .catch(function () {
            self.copyFallback(url);
          });
      } else {
        this.copyFallback(url);
      }
    }

    // execCommand fallback for contexts where the async clipboard is
    // unavailable (live carries the same fallback).
    copyFallback(url) {
      let ok = false;
      const textArea = document.createElement('textarea');
      textArea.value = url;
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        ok = document.execCommand('copy');
      } catch (err) {
        ok = false;
      }
      document.body.removeChild(textArea);
      if (ok) this.toast(this.dataset.labelCopied, 'tick');
      else this.toast(this.dataset.labelCopyFailed);
    }

    setSending(sending) {
      this.sending = sending;
      if (!this.submitBtn) return;
      this.submitBtn.disabled = sending;
      this.submitBtn.textContent = sending ? this.dataset.labelSending : this.dataset.labelSubmit;
      this.submitBtn.setAttribute('aria-busy', sending ? 'true' : 'false');
    }

    handleSubmit(e) {
      e.preventDefault();
      if (this.sending) return;
      const self = this;
      const fromname = this.senderName ? this.senderName.value.trim() : '';
      const senderEmail = this.senderEmail ? this.senderEmail.value.trim() : '';
      const toemail = this.recipientEmail ? this.recipientEmail.value.trim() : '';
      const note = this.message ? this.message.value.trim() : '';

      // Native `required` validation blocks empty submits before this handler
      // runs; this mirrors live's JS fallback check.
      if (!fromname || !senderEmail || !toemail) {
        this.toast(this.dataset.labelRequired);
        return;
      }

      const params = { fromname: fromname, toemail: toemail };
      if (note) params.note = note;

      this.setSending(true);
      // Same publicLid live posts (`callShareEmailAPI({ publicLid, ... })`), so
      // the "view wishlist" link in Swym's email resolves for the recipient.
      // Falls back to the coordinator's lid if the mint hasn't settled.
      this.post('emailList', params, this.publicLid)
        .then(function () {
          self.setSending(false);
          self.toast(self.dataset.labelEmailed, 'tick');
          if (self.form) self.form.reset();
          self.close();
        })
        .catch(function () {
          self.setSending(false);
          self.toast(self.dataset.labelEmailFailed);
        });
    }
  }

  if (!window.customElements.get('dc-wishlist-share-modal')) {
    window.customElements.define('dc-wishlist-share-modal', DcWishlistShareModal);
  }
  } catch(e) { console.error(e); }
})();

})();
